export type TPlace = [string, number, number];

export const places: Array<TPlace> = [
	["Aa en Hunze", 0, 0],
	["De Aa", 1, 1],
	["Aadorp", 2, 2],
	["Aagtdorp", 3, 3],
	["Aagtekerke", 4, 4],
	["Aalbeek", 5, 5],
	["Aalburg", 6, 1],
	["Aalden", 7, 0],
	["Aalderinkshoek", 2, 2],
	["Aaldonk", 8, 5],
	["Aalsmeer", 9, 3],
	["Aalsmeerderbrug", 10, 3],
	["Aalst", 11, 6],
	["Aalst", 12, 6],
	["Aalst", 13, 1],
	["Ter Aalst", 14, 1],
	["Aalsum", 15, 7],
	["Aalsum", 16, 8],
	["Aalten", 17, 6],
	["Aam", 18, 6],
	["Aanschot", 19, 1],
	["Aanwas", 20, 1],
	["Ter Aar", 21, 9],
	["Ter Aard", 22, 0],
	["Aardam", 21, 9],
	["Aardenburg", 23, 4],
	["Aardhuis", 24, 6],
	["Aarlanderveen", 25, 9],
	["Aarle", 26, 1],
	["Aarle", 27, 1],
	["Aarle-Rixtel", 27, 1],
	["Aartswoud", 28, 3],
	["Aast", 29, 5],
	["Aasterberg", 30, 5],
	["Abbega", 31, 8],
	["Abbegaesterketting", 31, 8],
	["Abbekerk", 32, 3],
	["Abbekinderen", 33, 4],
	["Abbenbroek", 34, 9],
	["Abbenes", 10, 3],
	["Abbestede", 35, 3],
	["Abcoude", 36, 10],
	["Abcoven", 37, 1],
	["Abdissenbosch", 38, 5],
	["Absdale", 39, 4],
	["Absdalepolder", 39, 4],
	["Abtswoude", 40, 9],
	["Achlum", 41, 8],
	["Acht", 42, 1],
	["Achterberg", 43, 10],
	["Achterbos", 44, 10],
	["Achterbosch", 45, 1],
	["Achterbosch", 27, 1],
	["Achterbroek", 46, 9],
	["Achterbroek", 47, 1],
	["Achterdiep", 48, 7],
	["Achterdijk", 49, 1],
	["Achterdrempt", 50, 6],
	["Achtereind", 13, 1],
	["Achterhoek", 51, 1],
	["Achter-Lindt", 52, 9],
	["Achterom", 53, 0],
	["Achterschaijk", 54, 1],
	["Achtersloot", 55, 10],
	["Achtersluispolder", 56, 3],
	["Achterste Brug", 57, 1],
	["Achterste Erm", 7, 0],
	["Achterste Hees", 29, 5],
	["Achterste Heide", 54, 1],
	["Achterste Heikant", 58, 1],
	["Achterstehoek", 59, 6],
	["Achter-Thesinge", 60, 7],
	["Achterveld", 61, 10],
	["In het Achterveld", 62, 2],
	["In het Achterveld", 63, 6],
	["Achterwehl", 64, 6],
	["Achterwetering", 65, 10],
	["Achterwijzend", 32, 3],
	["Achthoven", 66, 10],
	["Achthoven", 67, 9],
	["Achthuizen", 68, 9],
	["Achtkarspelen", 69, 8],
	["Achtmaal", 70, 1],
	["Achttienhoven", 21, 9],
	["Achttienhoven-Westbroek", 65, 10],
	["Acquoy", 71, 6],
	["Adorp", 72, 7],
	["Aduard", 15, 7],
	["Aduarderzijl", 72, 7],
	["Aerdenhout", 73, 3],
	["Aerdt", 74, 6],
	["Aetveldsche Polder", 75, 3],
	["Afferden", 76, 6],
	["Afferden", 77, 5],
	["Agelo", 78, 2],
	["Agobuurt", 79, 7],
	["Aijen", 77, 5],
	["Akersloot", 80, 3],
	["Akinga", 81, 8],
	["Akker", 82, 1],
	["Akkereind", 83, 1],
	["Akkerput", 23, 4],
	["Akkerwoude", 84, 8],
	["Akkrum", 85, 8],
	["Akmarijp", 86, 8],
	["Albergen", 87, 2],
	["Alblasserdam", 88, 9],
	["Albrandswaard", 89, 9],
	["Aldeboarn", 85, 8],
	["Aldemiede", 90, 8],
	["Aldtsjerk", 90, 8],
	["Alem", 91, 6],
	["Alendorp", 92, 10],
	["Alerdink", 93, 2],
	["Alinghuizen", 72, 7],
	["Alkemade", 94, 9],
	["Alkmaar", 95, 3],
	["Allersma", 72, 7],
	["Allingawier", 96, 8],
	["Almelo", 2, 2],
	["Almen", 97, 6],
	["Almenum", 98, 8],
	["Almere", 99, 11],
	["Almere-Buiten", 99, 11],
	["Almere-Haven", 99, 11],
	["Almere-Stad", 99, 11],
	["Almkerk", 100, 1],
	["Alphen", 101, 6],
	["Alphen", 102, 1],
	["Alphen aan den Rijn", 25, 9],
	["Alphen-Chaam", 102, 1],
	["Altena", 103, 0],
	["Alteveer", 104, 7],
	["Alteveer", 53, 0],
	["Alteveer", 105, 6],
	["Alteveer", 106, 0],
	["Alteveer", 103, 0],
	["Altforst", 101, 6],
	["Alting", 107, 0],
	["Alting-Klatering", 107, 0],
	["Altweert", 108, 5],
	["Altweerterheide", 108, 5],
	["Alverna", 109, 6],
	["Ambt Delden", 111, 2],
	["Ambt Montfort", 112, 5],
	["Amby", 113, 5],
	["Ameide", 67, 9],
	["Ameland", 114, 8],
	["Amelte", 22, 0],
	["Amen", 0, 0],
	["America", 29, 5],
	["Amerongen", 115, 10],
	["Amersfoort", 116, 10],
	["Amersfoortsestraat", 117, 10],
	["Ammerstol", 46, 9],
	["Ammerzoden", 91, 6],
	["Ampsen", 97, 6],
	["Langs de Amstel", 36, 10],
	["Amsteldijk", 118, 3],
	["Amsteleind", 54, 1],
	["Amstelhoek", 44, 10],
	["Amstelveen", 118, 3],
	["Amstenrade", 119, 5],
	["Amsterdam", 120, 3],
	["Amsterdamsche Veld", 121, 0],
	["Amsterdam-Zuidoost", 120, 3],
	["Amsweer", 122, 7],
	["Andel", 100, 1],
	["Den Andel", 72, 7],
	["Andelst", 18, 6],
	["Anderen", 0, 0],
	["Andijk", 123, 3],
	["Ane", 62, 2],
	["Anerveen", 62, 2],
	["Anevelde", 62, 2],
	["Angelslo", 121, 0],
	["Angeren", 124, 6],
	["Angerlo", 125, 6],
	["Anholt", 106, 0],
	["Anjum", 16, 8],
	["Ankeveen", 126, 3],
	["Ankeveense Rade", 126, 3],
	["Anklaar", 24, 6],
	["Ankum", 127, 2],
	["Anloo", 0, 0],
	["Anna Jacobapolder", 128, 4],
	["Anna Paulowna", 129, 3],
	["Annadal", 113, 5],
	["Anneburen", 31, 8],
	["Annen", 0, 0],
	["Annendaal", 30, 5],
	["Annerveen", 0, 0],
	["Annerveenschekanaal", 0, 0],
	["Anreep", 22, 0],
	["Ansen", 106, 0],
	["Ter Apel", 79, 7],
	["Apeldoorn", 24, 6],
	["Ter Apelkanaal", 79, 7],
	["Apenhuizen", 130, 2],
	["Aperloo", 131, 6],
	["Appel", 132, 6],
	["Appelscha", 81, 8],
	["Appeltern", 101, 6],
	["Appen (Scheveld)", 133, 6],
	["Appingedam", 134, 7],
	["Arcen", 135, 5],
	["Archem", 136, 2],
	["Arendsnest", 137, 1],
	["Arensgenhout", 5, 5],
	["Arkel", 138, 9],
	["Arkens", 41, 8],
	["Arkum", 96, 8],
	["Ten Arlo", 106, 0],
	["Armhoede", 97, 6],
	["Armweide", 106, 0],
	["Arnemuiden", 139, 4],
	["Arnhem", 105, 6],
	["Arnoud", 140, 9],
	["Arriën", 136, 2],
	["Arriërveld", 136, 2],
	["Arum", 96, 8],
	["Arwerd", 122, 7],
	["As", 141, 5],
	["Asch", 11, 6],
	["Asdonk", 27, 1],
	["Asenray", 142, 5],
	["Asperen", 143, 6],
	["Asschat", 61, 10],
	["Assel", 24, 6],
	["Asselt", 142, 5],
	["Assen", 22, 0],
	["Assendelft", 56, 3],
	["Assendorp", 144, 2],
	["Assum", 145, 3],
	["Assumburg", 146, 3],
	["Asten", 45, 1],
	["Atterlaken", 147, 1],
	["Atzeburen", 96, 8],
	["Augsbuurt", 148, 8],
	["Augustinusga", 69, 8],
	["Austerlitz", 149, 10],
	["Auvergnepolder", 150, 1],
	["Avenhorn", 151, 3],
	["Avereest", 62, 2],
	["Averlo", 130, 2],
	["Avest", 63, 6],
	["Avezaath", 152, 6],
	["Axel", 153, 4],
	["Axelsche Sassing", 153, 4],
	["Axwijk", 154, 3],
	["Azelo", 111, 2],
	["Azewijn", 155, 6],
	["Baaiduinen", 156, 8],
	["Baaium", 157, 8],
	["Baak", 50, 6],
	["Baakhoven", 30, 5],
	["Baaks", 158, 5],
	["Baal", 124, 6],
	["Baalder", 62, 2],
	["Baalhoek", 39, 4],
	["Baambrugge", 36, 10],
	["Baambrugse Zuwe", 44, 10],
	["Baamsum", 122, 7],
	["Baan", 159, 1],
	["De Baan", 160, 1],
	["Baard", 157, 8],
	["Baarderadeel", 157, 8],
	["Baarderburen", 161, 8],
	["Baarderburen", 96, 8],
	["Baardwijk", 162, 1],
	["Baarland", 163, 4],
	["Baarle-Nassau", 164, 1],
	["Baarle-Nassau-Grens", 164, 1],
	["Baarlo", 165, 5],
	["Baarlo", 166, 2],
	["Baarlo", 167, 2],
	["Baarn", 168, 10],
	["Baars", 166, 2],
	["Baarschot", 169, 1],
	["Baarsdorp", 163, 4],
	["Baarsdorpermeer", 151, 3],
	["Baarstraat", 170, 5],
	["Babberich", 125, 6],
	["Baburen", 96, 8],
	["Babyloniënbroek", 6, 1],
	["Badhoevedorp", 10, 3],
	["Baexem", 141, 5],
	["Baflo", 72, 7],
	["Bahr en Lathum", 125, 6],
	["Bakel", 171, 1],
	["Bakelsebrug", 171, 1],
	["Bakelsedijk", 172, 1],
	["Bakenberg", 105, 6],
	["Bakendorp", 163, 4],
	["Bakertand", 37, 1],
	["Bakheide", 173, 5],
	["Bakhuizen", 174, 8],
	["Bakkersdam", 23, 4],
	["Bakkeveen", 175, 8],
	["Bakkum", 80, 3],
	["Bakovensmee", 79, 7],
	["Balgoij", 109, 6],
	["Balinge", 107, 0],
	["Balk", 174, 8],
	["Balkbrug", 62, 2],
	["Ballast", 7, 0],
	["Balleman", 102, 1],
	["Ballingbuur", 86, 8],
	["Balloërveld", 0, 0],
	["Balloo", 0, 0],
	["Ballum", 114, 8],
	["Balmahuizen", 15, 7],
	["Band", 31, 8],
	["Bandijk", 101, 6],
	["Bandsloot", 176, 8],
	["Baneheide", 158, 5],
	["Bangert", 177, 3],
	["Banholt", 178, 5],
	["De Banken", 179, 3],
	["Bankert", 171, 1],
	["Bant", 180, 11],
	["Bantega", 176, 8],
	["Barchem", 97, 6],
	["Barendrecht", 181, 9],
	["Barendrechtse Veer", 181, 9],
	["Bareveld", 182, 7],
	["Bargebek", 174, 8],
	["Bargen", 183, 3],
	["Barger-Compascuum", 121, 0],
	["Barger-Erfscheidenveen", 121, 0],
	["Barger-Oosterveen", 121, 0],
	["Barger-Oosterveld", 121, 0],
	["Barkwerd", 157, 8],
	["Barlage", 104, 7],
	["Barlaque", 49, 1],
	["Barlo", 17, 6],
	["Barneveld", 184, 6],
	["Barnflair", 79, 7],
	["Barradeel", 41, 8],
	["Barrier", 185, 5],
	["Barsbeek", 166, 2],
	["Barsingerhorn", 186, 3],
	["Bartlehiem", 90, 8],
	["Barwoutswaarder", 187, 10],
	["Basse", 166, 2],
	["Batadorp", 26, 1],
	["Batenburg", 109, 6],
	["Bath", 188, 4],
	["Bathmen", 130, 2],
	["Batooserf", 101, 6],
	["Battenoord", 189, 9],
	["Batterij", 153, 4],
	["Bautsch", 190, 5],
	["Bavel", 191, 1],
	["Bazuin", 106, 0],
	["Bears", 157, 8],
	["Beckum", 192, 2],
	["Bedaf", 193, 1],
	["Bedijking", 44, 10],
	["Bedum", 194, 7],
	["Beegden", 170, 5],
	["Beek", 155, 6],
	["Beek", 195, 6],
	["Beek", 196, 5],
	["Beek", 27, 1],
	["Beek en Donk", 27, 1],
	["De Beek", 197, 6],
	["Beekbergen", 24, 6],
	["Beekheuvel", 77, 5],
	["Beekkant", 198, 1],
	["De Beekkant", 141, 5],
	["Beekveld", 198, 1],
	["De Beemden", 91, 6],
	["Beemdkant", 27, 1],
	["Beemster", 199, 3],
	["Beemte", 24, 6],
	["Op de Beeret", 135, 5],
	["Beers", 200, 1],
	["Beerschoten", 115, 10],
	["Beersdal", 190, 5],
	["Beerserhaar", 136, 2],
	["Beersterhoogen", 201, 7],
	["Beerta", 201, 7],
	["Beerten", 169, 1],
	["Beertsenhoven", 202, 5],
	["Beerze", 136, 2],
	["Beerzerveld", 136, 2],
	["Beesd", 71, 6],
	["Beesel", 173, 5],
	["Beetgum", 203, 8],
	["Beetgumermolen", 203, 8],
	["Beets", 175, 8],
	["Beets", 154, 3],
	["Beetsterzwaag", 175, 8],
	["Het Beggelder", 17, 6],
	["Het Beijersche", 204, 9],
	["Beilen", 107, 0],
	["Beimerwaard", 125, 6],
	["Beinsdorp", 10, 3],
	["Beinum", 125, 6],
	["Beisterveld", 205, 1],
	["Beitel", 190, 5],
	["Bekelaar", 206, 1],
	["Bekenes", 187, 10],
	["Bekveld", 50, 6],
	["Belcrum", 191, 1],
	["Belfeld", 135, 5],
	["Belgeren", 172, 1],
	["Bellingeweer", 72, 7],
	["Bellingwedde", 207, 7],
	["Bellingwolde", 207, 7],
	["Bellinkhof", 2, 2],
	["De Bels", 174, 8],
	["Belsberg", 29, 5],
	["De Belt", 62, 2],
	["De Belt", 208, 3],
	["De-Schutsloot Belt", 166, 2],
	["Op de Belt", 77, 5],
	["Beltrum", 63, 6],
	["Belvert", 209, 1],
	["Bemelen", 178, 5],
	["Bemmel", 124, 6],
	["Bemmer", 27, 1],
	["Benderse", 106, 0],
	["Benedenberg en Zuidbroek", 46, 9],
	["Beneden-Delwijnen", 12, 6],
	["Benedeneind", 210, 6],
	["Beneden-Haastrecht", 204, 9],
	["Benedenheul", 204, 9],
	["Benedenkerk", 204, 9],
	["Beneden-Leeuwen", 101, 6],
	["Benedenstad", 211, 6],
	["Benedenvaart", 62, 2],
	["Beneden-Veensloot", 212, 7],
	["Benkoelen", 213, 0],
	["Bennebroek", 73, 3],
	["De Bennekel", 42, 1],
	["Bennekom", 210, 6],
	["Benneveld", 7, 0],
	["Benningbroek", 32, 3],
	["Benschop", 214, 10],
	["Bent", 215, 9],
	["Bentelo", 111, 2],
	["Benthem", 171, 1],
	["Benthuizen", 215, 9],
	["Bentveld (ged.)", 73, 3],
	["Bentveld (ged.)", 216, 3],
	["Benzenrade", 190, 5],
	["Berg", 217, 1],
	["Berg", 218, 5],
	["Berg", 219, 1],
	["Berg en Bos", 24, 6],
	["Berg en Dal (ged.)", 220, 6],
	["Berg en Dal (ged.)", 195, 6],
	["Berg en Terblijt", 218, 5],
	["Aan de Berg", 112, 5],
	["Berkelland", 63, 6],
	["De Berg", 166, 2],
	["Bergakker", 152, 6],
	["Bergambacht", 46, 9],
	["Bergeijk", 1, 1],
	["Bergen", 3, 3],
	["Bergen", 77, 5],
	["Bergen aan Zee", 3, 3],
	["Bergen op Zoom", 150, 1],
	["Aan de Bergen", 141, 5],
	["Bergen-Binnen", 3, 3],
	["Bergenhuizen", 178, 5],
	["Bergenshuizen", 221, 1],
	["Bergentheim", 62, 2],
	["Bergerden", 124, 6],
	["Bergermeerpolder", 3, 3],
	["Bergharen", 109, 6],
	["Berghem", 54, 1],
	["Berghoven", 202, 5],
	["Berghuizen", 222, 6],
	["Berghuizen", 106, 0],
	["Bergkwartier", 116, 10],
	["Bergsche Heide", 77, 5],
	["Bergschenhoek", 223, 9],
	["Bergstoep", 46, 9],
	["Berik", 141, 5],
	["Beringe", 165, 5],
	["Beringerhoek", 165, 5],
	["Berk", 51, 1],
	["Berkdijk", 224, 1],
	["Berkel", 223, 9],
	["Berkel en Rodenrijs", 223, 9],
	["Berkelaar", 30, 5],
	["Berkel-Enschot", 224, 1],
	["Berkenrode", 121, 0],
	["Berkenwoude", 46, 9],
	["Berkhoek", 137, 1],
	["Berkhout", 151, 3],
	["Berkmeer", 28, 3],
	["Berkt", 83, 1],
	["Berkt", 225, 1],
	["Berkum", 144, 2],
	["Berkum-Veldhoek", 144, 2],
	["Berlicum", 198, 1],
	["Berlikum", 203, 8],
	["Berm", 91, 6],
	["Bern", 12, 6],
	["Berndijk", 159, 1],
	["Bernheze", 225, 1],
	["Bernisse", 34, 9],
	["Bij Bernsterburen", 85, 8],
	["Besoijen", 162, 1],
	["Besselaar", 198, 1],
	["Bessens", 157, 8],
	["Best", 26, 1],
	["Besthmen", 136, 2],
	["Beswerd", 72, 7],
	["Beterwonen", 226, 6],
	["Bethlehem", 227, 7],
	["Betterwird", 16, 8],
	["Beugen", 228, 1],
	["Beugt", 225, 1],
	["Beukbergen", 149, 10],
	["Beukelaar", 229, 1],
	["Beukers", 166, 2],
	["Beuningen", 230, 2],
	["Beuningen", 231, 6],
	["Beuseberg", 232, 2],
	["Beusichem", 11, 6],
	["Beutenaken", 202, 5],
	["Bevermeer", 125, 6],
	["Beverwijk", 233, 3],
	["Biddinghuizen", 234, 11],
	["Bierum", 122, 7],
	["Biervliet", 153, 4],
	["Biesstraat", 141, 5],
	["Biessum", 122, 7],
	["Biest", 169, 1],
	["Biesthoek", 193, 1],
	["Biezelinge", 235, 4],
	["Biezen", 23, 4],
	["Biezenmortel", 209, 1],
	["Biggekerke", 4, 4],
	["Bijdorp", 236, 9],
	["Bijland", 74, 6],
	["Bijlmermeer", 120, 3],
	["Bijsteren", 237, 6],
	["Bijsterhuizen", 211, 6],
	["De Bik", 116, 10],
	["Bilderdam", 94, 9],
	["het Bildt", 238, 8],
	["Billinghuizen", 202, 5],
	["Bilt", 170, 5],
	["De Bilt", 65, 10],
	["Bilthoven", 65, 10],
	["Binderven", 205, 1],
	["Bingelrade", 239, 5],
	["Bingerden", 125, 6],
	["Binnengeest", 80, 3],
	["Binnenheurne", 240, 6],
	["Binnenmaas", 241, 9],
	["Binnen-Moerdijk", 49, 1],
	["Binnenvree", 7, 0],
	["Binnenwijzend", 242, 3],
	["Birkhoven", 116, 10],
	["De Birkt", 117, 10],
	["Birstum", 85, 8],
	["Bisschopswetering", 243, 2],
	["Bisselt", 244, 5],
	["Bissen", 202, 5],
	["Bitswijk", 193, 1],
	["Bittens", 96, 8],
	["Blaak", 241, 9],
	["De Blaak", 224, 1],
	["Blaaksedijk", 241, 9],
	["Blaarthem", 42, 1],
	["Bladel", 245, 1],
	["Blanken", 106, 0],
	["Blankenberg", 178, 5],
	["Blankenham", 166, 2],
	["Blaricum", 246, 3],
	["Blauw", 247, 7],
	["Blauwe Hand", 166, 2],
	["Blauwe Sluis", 248, 1],
	["Blauwenhoek", 249, 1],
	["Blauwesluis", 101, 6],
	["Blauwewijk", 33, 4],
	["Blauwhuis", 31, 8],
	["Blauwkapel", 65, 10],
	["Blauwverlaat", 69, 8],
	["Blazekop", 163, 4],
	["Bleijenbeek", 77, 5],
	["Bleijerheide", 250, 5],
	["Bleiswijk", 223, 9],
	["Blekslage", 104, 7],
	["Blerick", 135, 5],
	["Blesdijke", 251, 8],
	["Blesdijkerveld", 251, 8],
	["Bleskensgraaf", 252, 9],
	["De Blesse", 251, 8],
	["Blessum", 203, 8],
	["Blijdenstein", 106, 0],
	["Blije", 253, 8],
	["Blijham", 207, 7],
	["De Blijnse", 41, 8],
	["Blikhalm", 172, 1],
	["Blikkenburg", 149, 10],
	["Blitterswijck", 254, 5],
	["Bloemberg", 106, 0],
	["Bloemendaal", 73, 3],
	["Bloemendaal", 255, 9],
	["Bloemendalerpolder", 75, 3],
	["Blokhuiswetering", 256, 10],
	["Blokhuizen", 186, 3],
	["Blokker", 177, 3],
	["Blokker", 96, 8],
	["Blokland", 66, 10],
	["Blokland", 44, 10],
	["Blokum", 60, 7],
	["Blokzijl", 166, 2],
	["Boarnsterhim", 85, 8],
	["Boazum", 157, 8],
	["Bobeldijk", 151, 3],
	["Bocholtz", 158, 5],
	["Bocholtzerheide", 158, 5],
	["De Bocht", 248, 1],
	["Boddenkamp", 257, 2],
	["Bodegraven", 258, 9],
	["Boeiink", 82, 1],
	["Boeimeer", 191, 1],
	["Boekel", 137, 1],
	["Boekelo", 257, 2],
	["Boekelte", 251, 8],
	["Boekend", 135, 5],
	["Boekend", 171, 1],
	["Boeket", 259, 5],
	["Boekhorst", 81, 8],
	["Boelenslaan", 69, 8],
	["Boer", 41, 8],
	["De Boer", 260, 1],
	["Ten Boer", 60, 7],
	["Boerakker", 247, 7],
	["Boerakker", 261, 7],
	["Boerdonk", 229, 1],
	["Boerelaan", 103, 0],
	["Boerengat", 153, 4],
	["Boerenhol", 23, 4],
	["Boerenstreek", 247, 7],
	["Boerhaar", 262, 2],
	["Boeschoten", 184, 6],
	["Boesingheliede", 10, 3],
	["Boetele", 93, 2],
	["Boijl", 251, 8],
	["Boijlerveld", 251, 8],
	["Bokhoven", 263, 1],
	["Bokkum", 85, 8],
	["Boksheide", 264, 1],
	["Boksum", 203, 8],
	["Bokt", 19, 1],
	["Bolberg", 191, 1],
	["Bolberg", 265, 1],
	["Bolenberg", 135, 5],
	["Bolgarijen", 266, 10],
	["Bolhaar", 257, 2],
	["Bolkshoek", 2, 2],
	["Bollebieste", 144, 2],
	["Bollendorp", 267, 3],
	["Bollingawier", 16, 8],
	["Bolnes", 268, 9],
	["Bolshuizen", 72, 7],
	["Bolst", 229, 1],
	["Bolsward", 269, 8],
	["De Bolt", 270, 1],
	["Den Bommel", 68, 9],
	["Bommerig", 202, 5],
	["Bong", 135, 5],
	["Bong", 165, 5],
	["Bongier", 157, 8],
	["Bonifaciusbuurt", 16, 8],
	["Bonnen", 0, 0],
	["Bonnerveen", 0, 0],
	["Bonrepas", 204, 9],
	["Bontebak", 41, 8],
	["Bontebok", 271, 8],
	["Bontemorgen", 11, 6],
	["Boom", 61, 10],
	["Boome", 186, 3],
	["Boomen", 47, 1],
	["Boompjes", 248, 1],
	["Boompjesdijk", 248, 1],
	["Booneschans", 201, 7],
	["Boornbergum", 272, 8],
	["Boornzwaag", 86, 8],
	["Borculo", 63, 6],
	["Borg", 112, 5],
	["Ter Borg", 79, 7],
	["Borgele", 130, 2],
	["Borger", 273, 0],
	["Borgercompagnie (ged.)", 182, 7],
	["Borgercompagnie (ged.)", 212, 7],
	["Borger-Odoorn", 273, 0],
	["Borgerveld", 79, 7],
	["Borgharen", 113, 5],
	["Borgsweer", 122, 7],
	["Borgweg (ged.)", 48, 7],
	["Borgweg (ged.)", 274, 7],
	["Borkel", 57, 1],
	["Borkeld", 232, 2],
	["Born", 275, 5],
	["Borne", 276, 2],
	["Borne", 277, 1],
	["Bornerbroek", 2, 2],
	["Bornwird", 16, 8],
	["Borsbeek", 166, 2],
	["Borsele", 163, 4],
	["Borssele", 163, 4],
	["Borteldonk", 82, 1],
	["Bosch", 219, 1],
	["Bosch en Duin", 149, 10],
	["Het Bosch", 245, 1],
	["Boscheind", 1, 1],
	["Boschheurne", 97, 6],
	["Boschhoek", 278, 6],
	["Boschhoven", 164, 1],
	["Boschhoven", 279, 1],
	["Boschkant", 280, 1],
	["Boschkens", 37, 1],
	["Boschoord", 281, 0],
	["Boschpoort", 113, 5],
	["Boschweg", 277, 1],
	["Boshoven", 108, 5],
	["Boshoven", 102, 1],
	["Boshoven", 1, 1],
	["Boshoverbeek", 108, 5],
	["Boskamp", 262, 2],
	["Boskant", 109, 6],
	["Boskoop", 282, 9],
	["Bossche Broek", 263, 1],
	["Bosschenhoofd", 283, 1],
	["Bosschenhuizen", 158, 5],
	["Bosscherheide", 77, 5],
	["Bosscherveld", 113, 5],
	["Bosserstraat", 259, 5],
	["Boswinkel", 257, 2],
	["Boteburen", 253, 8],
	["Boterdijk", 179, 3],
	["Boterhoek", 284, 4],
	["Boterveen", 281, 0],
	["Boterwijk", 285, 1],
	["Bothof", 257, 2],
	["Botlek", 286, 9],
	["Botshol", 44, 10],
	["Botshoofd", 128, 4],
	["Bouchauterhaven", 153, 4],
	["Boudewijnskerke", 4, 4],
	["Boukoul", 142, 5],
	["Bourtange", 79, 7],
	["Op den Bout", 165, 5],
	["Bouwberg", 287, 5],
	["Bouwerschap", 60, 7],
	["Bovenberg", 46, 9],
	["Bovenburen", 201, 7],
	["Bovenburen", 288, 8],
	["Boveneind Spijk", 143, 6],
	["Boven-Haastrecht", 204, 9],
	["Boven-Hardinxveld", 289, 9],
	["Bovenhuizen", 274, 7],
	["Bovenkarspel", 290, 3],
	["Bovenkerk", 118, 3],
	["Bovenkerk", 204, 9],
	["Boven-Leeuwen", 101, 6],
	["Bovenrijge", 60, 7],
	["Bovensluis", 49, 1],
	["Bovensmilde", 107, 0],
	["Bovenstad", 46, 9],
	["Bovenste Huis", 137, 1],
	["Bovenstreek", 291, 7],
	["Bovenstreek", 201, 7],
	["Bovenstreek", 292, 6],
	["Bovenstreek", 0, 0],
	["Bovenveen", 292, 6],
	["Boven-Veensloot", 212, 7],
	["Boxmeer", 228, 1],
	["Boxtel", 217, 1],
	["Braakhoek", 58, 1],
	["Braakhuizen", 206, 1],
	["Braakman", 153, 4],
	["Braamberg", 104, 7],
	["Braambosch", 1, 1],
	["Braamt", 155, 6],
	["Brabander", 254, 5],
	["Brachterbeek", 170, 5],
	["Brake", 32, 3],
	["Brakel", 12, 6],
	["Brakel", 37, 1],
	["De Brakel", 257, 2],
	["Brakkenstein", 211, 6],
	["Brammelo", 293, 2],
	["Brand", 51, 1],
	["Brand", 294, 1],
	["De Brand", 116, 10],
	["Brandeburen", 288, 8],
	["Brandemolen", 135, 5],
	["Brandevoort", 205, 1],
	["Brandt", 170, 5],
	["Brandwijk", 252, 9],
	["Brantgum", 16, 8],
	["Breda", 191, 1],
	["Bredelaar", 18, 6],
	["Brederwiede", 166, 2],
	["Bredevoort", 17, 6],
	["Bredius", 295, 3],
	["Breede", 227, 7],
	["Breedenbroek", 240, 6],
	["Breedeveen", 115, 10],
	["Breedschot", 70, 1],
	["Breehees", 169, 1],
	["Breemortel", 172, 1],
	["Breesaap", 296, 3],
	["Breeveld", 187, 10],
	["Breezand", 129, 3],
	["Breezanddijk", 96, 8],
	["Breggenbergen", 106, 0],
	["Bregtdorp", 3, 3],
	["Breklenkamp", 78, 2],
	["Brem", 37, 1],
	["Brem", 224, 1],
	["Bremberg", 147, 1],
	["Brembosch", 82, 1],
	["Breskens", 23, 4],
	["Breudijk", 187, 10],
	["Breugel", 19, 1],
	["Breukelen", 297, 10],
	["Breukeleveen (ged.)", 297, 10],
	["Breukeleveen (ged.)", 126, 3],
	["Breust", 298, 5],
	["Brielle", 299, 9],
	["Brigdamme", 139, 4],
	["Brijdorpe", 284, 4],
	["Briltil", 15, 7],
	["Brink", 295, 3],
	["Brinkheurne", 300, 6],
	["Brinkhoek", 144, 2],
	["Brinkmanshoek", 63, 6],
	["Britsum", 301, 8],
	["Britswert", 157, 8],
	["Broedergemeente", 149, 10],
	["Broek", 86, 8],
	["Broek", 67, 9],
	["Broek", 302, 3],
	["Broek", 165, 5],
	["Broek", 158, 5],
	["Broek", 135, 5],
	["Broek", 29, 5],
	["Broek", 303, 7],
	["Broek", 206, 1],
	["Broek in Waterland", 302, 3],
	["Broek op Langedijk", 304, 3],
	["Den Broek", 29, 5],
	["Het Broek", 64, 6],
	["Het Broek", 205, 1],
	["'t Broek", 211, 6],
	["Broekdijk", 292, 6],
	["Broeke", 63, 6],
	["Broekeind", 29, 5],
	["Broekenseind", 245, 1],
	["Broekerhaven", 290, 3],
	["Broekesluis", 6, 1],
	["Broekhem", 218, 5],
	["Broekheurne", 257, 2],
	["Broekhin", 142, 5],
	["Broekhoek", 225, 1],
	["Broekhorn", 305, 3],
	["Broekhoven", 224, 1],
	["Broekhoven", 306, 5],
	["Broekhoven", 1, 1],
	["Broekhuizen", 307, 0],
	["Broekhuizen", 127, 2],
	["Broekhuizen", 38, 5],
	["Broekhuizen", 29, 5],
	["Broekhuizenvorst", 29, 5],
	["Broekkant", 27, 1],
	["Broekkant", 249, 1],
	["Broekkant", 219, 1],
	["Broekland", 93, 2],
	["Broekland", 24, 6],
	["Broeksittard", 275, 5],
	["Broeksterwoude", 84, 8],
	["Broekvelden", 258, 9],
	["Broekzijde", 308, 1],
	["Brommelen", 306, 5],
	["Bronbeek", 105, 6],
	["Bronckhorst", 50, 6],
	["Bronkhorst", 50, 6],
	["Bronneger", 273, 0],
	["Bronnegerveen", 273, 0],
	["Bronsbergen", 309, 6],
	["Bronsveen", 310, 7],
	["Brouwershaven", 284, 4],
	["Brouwershoek", 63, 6],
	["Brouwhuis", 205, 1],
	["Bruchem", 12, 6],
	["Brucht", 62, 2],
	["Bruchterveld", 62, 2],
	["Brug", 34, 9],
	["Bruggen", 172, 1],
	["Bruggen", 263, 1],
	["Bruggen", 260, 1],
	["Bruggenhoek", 144, 2],
	["Bruggenmors", 257, 2],
	["Bruggerhuizen", 279, 1],
	["De Bruil", 63, 6],
	["Bruinehaar", 311, 2],
	["Bruinisse", 284, 4],
	["Bruisterbosch", 178, 5],
	["Brukske", 254, 5],
	["Brumhold", 141, 5],
	["Brummen", 312, 6],
	["Brunnepe", 243, 2],
	["Brunssum", 287, 5],
	["Brunsting", 107, 0],
	["Bruntinge", 107, 0],
	["Bruuk", 220, 6],
	["Buchten", 275, 5],
	["Budel", 219, 1],
	["Budschop", 259, 5],
	["Buggenum", 141, 5],
	["Buiksloot", 120, 3],
	["Buikstede", 313, 7],
	["Buinen", 273, 0],
	["Buinerveen", 273, 0],
	["De Buis", 70, 1],
	["Buitenhuizen", 274, 7],
	["Buitenhuizen", 106, 0],
	["Buitenkaag", 10, 3],
	["Buitenkerk", 258, 9],
	["Buitenpost", 69, 8],
	["Buitenstoof", 128, 4],
	["Buitenstverlaat", 272, 8],
	["Buitenveldert", 120, 3],
	["Buiten-Wittevrouwen", 92, 10],
	["Buitenwoel", 182, 7],
	["Buitenzorg", 128, 4],
	["Bulkem", 158, 5],
	["Bulkemsbroek", 158, 5],
	["Bulkenaar", 82, 1],
	["Bullenkamp", 109, 6],
	["In de Bullewijk", 314, 3],
	["Bult", 81, 8],
	["Bult", 172, 1],
	["De Bult", 207, 7],
	["De Bult", 166, 2],
	["Bunde", 306, 5],
	["Bungalowpark", 164, 1],
	["Bunkerke", 157, 8],
	["Bunne", 213, 0],
	["Bunnik", 315, 10],
	["Bunschoten", 256, 10],
	["De Bunt", 117, 10],
	["Burdaard", 253, 8],
	["Buren", 114, 8],
	["Buren", 11, 6],
	["Den Burg", 183, 3],
	["Burgemeester-Beinsdorp", 79, 7],
	["Burgerbrug", 35, 3],
	["Het Burger-Nieuwland", 183, 3],
	["Burgersdijk", 316, 9],
	["Burgerveen", 10, 3],
	["Burgervlotbrug", 35, 3],
	["Burgh", 284, 4],
	["De Burgh", 42, 1],
	["Burghorn (Polder)", 317, 3],
	["Burghsluis", 284, 4],
	["Burgum", 90, 8],
	["Burgumerdam", 90, 8],
	["Burgwerd", 96, 8],
	["Burum", 148, 8],
	["Bus", 225, 1],
	["De Bus", 277, 1],
	["Busch", 56, 3],
	["Busselte", 281, 0],
	["Bussereind", 173, 5],
	["Bussloo", 133, 6],
	["Bussum", 295, 3],
	["Buttinga", 81, 8],
	["Buttinge", 4, 4],
	["Buunderkamp", 318, 6],
	["Buurlo", 24, 6],
	["Buurmalsen", 71, 6],
	["Buurse", 293, 2],
	["De Buurt", 32, 3],
	["'t Buurtje", 35, 3],
	["Buurtsdijk", 116, 10],
	["Cabauw", 214, 10],
	["Caberg", 113, 5],
	["Cadier en Keer", 178, 5],
	["Cadzand", 23, 4],
	["Cadzand-Bad", 23, 4],
	["Calfven", 20, 1],
	["Californië", 91, 6],
	["Californië", 29, 5],
	["Calishoek", 49, 1],
	["Callantsoog", 35, 3],
	["Camerig", 319, 5],
	["Camp", 3, 3],
	["Camperduin", 3, 3],
	["Capelle", 162, 1],
	["Capelle aan den IJssel", 320, 9],
	["Carnisse", 181, 9],
	["Cartils", 202, 5],
	["Castelré", 164, 1],
	["Castenray", 254, 5],
	["Casteren", 245, 1],
	["Castert", 141, 5],
	["Castricum", 80, 3],
	["Catrijp", 3, 3],
	["Catsop", 321, 5],
	["Cattenbroek", 66, 10],
	["Caumer", 190, 5],
	["Cellemuiden", 144, 2],
	["Ceres", 140, 9],
	["Ceresdorp", 104, 7],
	["Chaam", 102, 1],
	["Chevremont", 250, 5],
	["Cillaarshoek", 322, 9],
	["Clinge", 39, 4],
	["Cobbeek", 83, 1],
	["De Cocksdorp", 183, 3],
	["Coelhorst", 116, 10],
	["Coevering", 206, 1],
	["Coevorden", 7, 0],
	["Coldenhove", 312, 6],
	["Colijnsplaat", 323, 4],
	["Collendoorn", 62, 2],
	["Colmont", 185, 5],
	["Colmschate", 130, 2],
	["Commandeurs", 146, 3],
	["Commissiepolle", 176, 8],
	["Corle", 300, 6],
	["Corneliahoeven", 175, 8],
	["Cornjum", 301, 8],
	["Cornwerd", 96, 8],
	["Cortenoever", 312, 6],
	["Corversbos", 324, 3],
	["Cothen", 325, 10],
	["Cottessen", 319, 5],
	["Coudewater", 263, 1],
	["Couwelaar", 102, 1],
	["Covik", 50, 6],
	["Craailo", 246, 3],
	["Crabbehof", 326, 9],
	["Cranendonck", 219, 1],
	["Crapoel", 202, 5],
	["Craubeek", 185, 5],
	["Creil", 180, 11],
	["Creutzberg", 233, 3],
	["CrÞvecoeur", 263, 1],
	["Crob", 327, 6],
	["Cromhoffsbleek", 257, 2],
	["Cromstrijen", 328, 9],
	["Cromvoirt", 221, 1],
	["Croy", 27, 1],
	["Cruquius", 10, 3],
	["Cuijk", 200, 1],
	["Culemborg", 329, 6],
	["Daarle", 330, 2],
	["Daarlerveen", 330, 2],
	["Daarlerveld", 330, 2],
	["Daelenbroek", 112, 5],
	["Dal", 202, 5],
	["Dale", 17, 6],
	["Dalem", 331, 9],
	["Dalem", 245, 1],
	["Dalen", 175, 8],
	["Dalen", 7, 0],
	["Dalerpeel", 7, 0],
	["Dalerveen", 7, 0],
	["Dalfsen", 127, 2],
	["Dalfserveld", 127, 2],
	["Dallingeweer", 122, 7],
	["Dalmsholte (ged.)", 127, 2],
	["Dalmsholte (ged.)", 136, 2],
	["Dam", 208, 3],
	["Dam", 56, 3],
	["Dam", 8, 5],
	["Dambord", 91, 6],
	["Damwoude", 84, 8],
	["Daniken", 119, 5],
	["Dannenberg", 232, 2],
	["Dantumadiel", 84, 8],
	["Darp", 281, 0],
	["Darthuizen", 115, 10],
	["Dassemus", 102, 1],
	["Dearsum", 85, 8],
	["Dedemsvaart", 62, 2],
	["Dedgum", 96, 8],
	["Deelen (ged.)", 105, 6],
	["Deelen (ged.)", 210, 6],
	["Deelshurk", 57, 1],
	["Deense Hoek", 27, 1],
	["Deest", 76, 6],
	["Den Deijl", 332, 9],
	["Deil", 71, 6],
	["Deinum", 203, 8],
	["Dekkershuizen", 122, 7],
	["Dekkerwald", 220, 6],
	["Delden", 50, 6],
	["Delden", 111, 2],
	["Deldenerbroek", 111, 2],
	["Deldeneresch", 111, 2],
	["Delfgauw", 333, 9],
	["Delfshaven", 286, 9],
	["Delfstrahuizen", 176, 8],
	["Delft", 40, 9],
	["Delfzijl", 122, 7],
	["De Dellen", 260, 1],
	["Delwijnen", 12, 6],
	["Dem", 190, 5],
	["Demen", 54, 1],
	["Demmerik", 44, 10],
	["Denekamp", 78, 2],
	["Denemarken", 274, 7],
	["Dennenburg", 54, 1],
	["Derp", 172, 1],
	["Deurne", 172, 1],
	["Deurningen", 78, 2],
	["Deursen", 54, 1],
	["Deurze", 0, 0],
	["Deuteren", 263, 1],
	["Deuteren", 160, 1],
	["Deventer", 130, 2],
	["Dichteren", 64, 6],
	["Didam", 155, 6],
	["Dieden", 54, 1],
	["Diefdijk (ged.)", 334, 9],
	["Diefdijk (ged.)", 266, 10],
	["Diekendaal", 8, 5],
	["Diemen", 335, 3],
	["Diemerbroek", 336, 10],
	["Diemerbrug", 335, 3],
	["Diepekuilen", 171, 1],
	["Diepenbroek", 206, 1],
	["Diependaal", 107, 0],
	["Diepenheim", 111, 2],
	["Diepenveen", 130, 2],
	["Dieperskant", 229, 1],
	["Diepswal", 247, 7],
	["Diepswal", 15, 7],
	["Dierdonk", 205, 1],
	["Dieren", 337, 6],
	["Diergaarde", 30, 5],
	["Diermen", 237, 6],
	["Diesdonk", 45, 1],
	["Dieskant", 263, 1],
	["Diessen", 169, 1],
	["Dieteren", 30, 5],
	["Diever", 281, 0],
	["Dieverbrug", 281, 0],
	["Dieze", 144, 2],
	["Diezerpoort", 144, 2],
	["Diffelen", 62, 2],
	["Dijk", 45, 1],
	["Dijk", 229, 1],
	["Dijken", 86, 8],
	["Dijkerhoek", 232, 2],
	["Dijkhuisjes", 284, 4],
	["Dijkhuizen", 278, 6],
	["Dijkhuizen", 106, 0],
	["Dijkmanshuizen", 183, 3],
	["Dijkshorn", 60, 7],
	["Dijksterburen", 96, 8],
	["Dijnselburg", 149, 10],
	["Dikbroeken", 273, 0],
	["Dilcht", 338, 7],
	["Dingen", 72, 7],
	["Dingstede", 339, 2],
	["Dinkelland", 78, 2],
	["Dinteloord", 248, 1],
	["Dintelsas", 248, 1],
	["Dinther", 225, 1],
	["Dinthersehoek", 225, 1],
	["Dinxperlo", 17, 6],
	["Dinxterveen", 166, 2],
	["Diphoorn", 7, 0],
	["Dirkshorn", 340, 3],
	["Dirksland", 341, 9],
	["Distelberg", 209, 1],
	["Diunt", 70, 1],
	["Dodewaard", 342, 6],
	["Doenrade", 119, 5],
	["Doesburg", 343, 6],
	["Doesburg", 210, 6],
	["Doeskwartier", 344, 9],
	["Doetinchem", 64, 6],
	["Doeveren", 6, 1],
	["Doeveren", 345, 1],
	["Doezum", 313, 7],
	["Doijum", 41, 8],
	["Dokkum", 16, 8],
	["Dolberg", 185, 5],
	["Den Dolder", 149, 10],
	["Doldersum", 281, 0],
	["Dombosch", 346, 1],
	["Domburg", 4, 4],
	["Dommelen", 57, 1],
	["Dommelsvoort", 200, 1],
	["Dompt", 171, 1],
	["Domwier", 85, 8],
	["Donderen", 213, 0],
	["Dongen", 347, 1],
	["Dongensevaart", 347, 1],
	["Dongjum", 41, 8],
	["Doniaburen", 96, 8],
	["Doniaga", 86, 8],
	["Donk", 137, 1],
	["Donk", 264, 1],
	["Donk", 165, 5],
	["Donk", 27, 1],
	["Donk", 225, 1],
	["De Donk", 252, 9],
	["Donkerbroek", 81, 8],
	["Donkereind", 44, 10],
	["Donkersvoort", 27, 1],
	["Donkervliet", 36, 10],
	["Donzel", 225, 1],
	["De Dood", 51, 1],
	["Doodenhoek", 225, 1],
	["Doodstil", 227, 7],
	["Doonheide", 171, 1],
	["Doorn", 115, 10],
	["De Doornakkers", 42, 1],
	["Doornenburg", 124, 6],
	["Doornhoek", 198, 1],
	["Doornik", 124, 6],
	["Doorning", 91, 6],
	["Doornspijk", 131, 6],
	["Doorwerth", 318, 6],
	["Doosje", 166, 2],
	["Dordrecht", 326, 9],
	["Dorkwerd", 291, 7],
	["Dorp", 313, 7],
	["Het Dorp", 105, 6],
	["Dorplein", 219, 1],
	["Dorregeest", 145, 3],
	["Dorshout", 229, 1],
	["Dorst", 14, 1],
	["Dortherhoek", 130, 2],
	["Douvergenhout", 239, 5],
	["Douwen", 303, 7],
	["Draai", 305, 3],
	["Draaibrug", 348, 9],
	["Draaibrug", 23, 4],
	["Draaierij", 207, 7],
	["Drachten", 272, 8],
	["Drachtstercompagnie", 272, 8],
	["Drechterland", 242, 3],
	["Dreischor", 284, 4],
	["Drempt", 50, 6],
	["Drentsdorp", 42, 1],
	["Dreumel", 101, 6],
	["Drie", 197, 6],
	["Drie Hoefijzers", 39, 4],
	["Drie Hoefijzers", 349, 1],
	["Driebergen", 115, 10],
	["Drieborg", 201, 7],
	["Driebruggen", 348, 9],
	["Driedorp", 132, 6],
	["Driehoek", 19, 1],
	["Driehoek", 70, 1],
	["Driehoek", 249, 1],
	["Driehoek", 49, 1],
	["Driehuis", 296, 3],
	["Driehuizen", 350, 3],
	["Driehuizen", 351, 3],
	["Driehuizen", 169, 1],
	["Driehuizen", 229, 1],
	["Driel", 18, 6],
	["Driemond", 120, 3],
	["Driene", 192, 2],
	["Dries", 108, 5],
	["Drieschouwen", 153, 4],
	["Driesprong", 210, 6],
	["De Driesprong", 63, 6],
	["Driessen", 165, 5],
	["Driesum", 84, 8],
	["Driewegen", 163, 4],
	["Driewegen", 153, 4],
	["Drijber", 107, 0],
	["Drijberscheveld", 107, 0],
	["Drimmelen", 349, 1],
	["Drogeham", 69, 8],
	["Drogt", 106, 0],
	["Drogteropslagen", 106, 0],
	["Drongelen", 6, 1],
	["Dronrijp", 203, 8],
	["Dronten", 234, 11],
	["De Droo", 59, 6],
	["Drooghe Weert", 352, 3],
	["Drostinnewijk", 247, 7],
	["Drouwen", 273, 0],
	["Drouwenermond", 273, 0],
	["Blauwestad", 201, 7],
	["Drouwenerveen", 273, 0],
	["Druisdijk", 102, 1],
	["Drumpt", 152, 6],
	["Drunen", 345, 1],
	["Druten", 76, 6],
	["Dubbeldam", 326, 9],
	["Dubbroek", 165, 5],
	["Duifhuis", 193, 1],
	["Duifhuis", 294, 1],
	["Duiksehoef", 159, 1],
	["Duin en Bosch", 80, 3],
	["Duinen", 353, 6],
	["Duiven", 59, 6],
	["Duivendijke", 284, 4],
	["Duivendrecht", 314, 3],
	["Duizel", 264, 1],
	["De Duizeldonk", 205, 1],
	["Dukenburg", 211, 6],
	["Dulder", 78, 2],
	["Dun", 169, 1],
	["Den Dungen", 198, 1],
	["Dunsborg", 50, 6],
	["Durgerdam", 120, 3],
	["Dusseldorp", 80, 3],
	["Dussen", 160, 1],
	["Duur", 262, 2],
	["Duurendseind", 54, 1],
	["Duurkenakker", 212, 7],
	["Duurswoude", 175, 8],
	["Duyn en Dael", 354, 1],
	["Dwarsdiep", 310, 7],
	["Dwarsdijk", 325, 10],
	["Dwarsgracht", 166, 2],
	["Dwingeloo", 281, 0],
	["Eagum", 85, 8],
	["Earnewâld", 90, 8],
	["Easterein", 157, 8],
	["Easterlittens", 157, 8],
	["Eastermar", 90, 8],
	["Easterwierum", 157, 8],
	["Ebbenbroek", 62, 2],
	["Echt", 30, 5],
	["Echteld", 342, 6],
	["Echten", 176, 8],
	["Echten", 106, 0],
	["Echtenerbrug", 176, 8],
	["Echterbosch", 30, 5],
	["Echt-Susteren", 30, 5],
	["Eck en Wiel", 11, 6],
	["Eckart", 42, 1],
	["Eckelrade", 178, 5],
	["Edam", 355, 3],
	["Edam-Volendam", 355, 3],
	["Ede", 210, 6],
	["Ederveen", 210, 6],
	["Ee", 16, 8],
	["Eede", 23, 4],
	["Eefde", 97, 6],
	["Eefsele", 356, 6],
	["Eekt", 292, 6],
	["Eekwerd", 357, 7],
	["Eekwerderdraai", 357, 7],
	["Eelde", 213, 0],
	["Eelderwolde", 213, 0],
	["Eelen", 330, 2],
	["Eembrugge", 168, 10],
	["Eemdijk", 256, 10],
	["Eemland", 168, 10],
	["Eemnes", 358, 10],
	["Eemshaven", 227, 7],
	["Eemsmond", 227, 7],
	["Eemster", 273, 0],
	["Eemster", 281, 0],
	["Eemswoude", 96, 8],
	["Eemten", 106, 0],
	["Een", 103, 0],
	["Een West", 103, 0],
	["De Eendracht", 7, 0],
	["Eendrachtspolder", 359, 9],
	["Eendragt", 153, 4],
	["Het Eenerveld", 103, 0],
	["Eenigenburg", 340, 3],
	["Eenrum", 303, 7],
	["Eenum", 357, 7],
	["Eerbeek", 312, 6],
	["Eerde", 136, 2],
	["Eerde", 229, 1],
	["Eerschot", 280, 1],
	["Eersel", 264, 1],
	["Eerste Exloërmond", 273, 0],
	["Eerste Valthermond", 273, 0],
	["Ees", 273, 0],
	["Eese", 166, 2],
	["Eesergroen", 273, 0],
	["Eeserveen", 7, 0],
	["Eeserveen", 273, 0],
	["Eesterga", 176, 8],
	["Eesveen", 166, 2],
	["Eethen", 6, 1],
	["Eext", 0, 0],
	["Eexta", 201, 7],
	["Eexterveen", 0, 0],
	["Eexterveensche kanaal", 0, 0],
	["Eexterzandvoort", 0, 0],
	["Effen", 191, 1],
	["Egbertsgaasten", 272, 8],
	["Egchel", 165, 5],
	["Egchelheide", 165, 5],
	["Egchelhoek", 165, 5],
	["Egede", 330, 2],
	["Egelshoek", 324, 3],
	["De Egge", 287, 5],
	["Egmond", 3, 3],
	["Egmond aan Den Hoef", 3, 3],
	["Egmond aan Zee", 3, 3],
	["Egmond-Binnen", 3, 3],
	["Egypte", 245, 1],
	["Eibergen", 63, 6],
	["Eibersburen", 313, 7],
	["Eygelshoven", 250, 5],
	["Eijndt", 165, 5],
	["Eijsden", 298, 5],
	["Eikberg", 191, 1],
	["Eikelenbosch", 164, 1],
	["Eikelenbosch", 29, 5],
	["Eikenheuvel", 193, 1],
	["Eikske", 38, 5],
	["Eiland", 20, 1],
	["Eiland", 170, 5],
	["Het Eiland", 56, 3],
	["Eilandspolder", 350, 3],
	["Eimeren", 18, 6],
	["Eind", 19, 1],
	["Eind", 259, 5],
	["Eind", 1, 1],
	["Eind van den Hout", 14, 1],
	["'t Eind", 209, 1],
	["Einde", 190, 5],
	["Einde", 142, 5],
	["Eindewege (ged.)", 163, 4],
	["Eindewege (ged.)", 33, 4],
	["Eindhoven", 42, 1],
	["Eindje", 47, 1],
	["Einighausen", 275, 5],
	["Eiteren", 55, 10],
	["Ekamp", 201, 7],
	["Ekehaar", 0, 0],
	["Ekenrooi", 13, 1],
	["d' Ekker", 83, 1],
	["Ekkersrijt", 19, 1],
	["Ekris", 360, 10],
	["Elahuizen", 174, 8],
	["Elba", 186, 3],
	["Elba", 242, 3],
	["Elburg", 131, 6],
	["Elde", 277, 1],
	["Elden", 18, 6],
	["Eldersloo", 0, 0],
	["Eldik", 342, 6],
	["Eldrik", 50, 6],
	["Elens", 303, 7],
	["Eleveld", 0, 0],
	["Elferink", 257, 2],
	["Elft", 208, 3],
	["Elim", 53, 0],
	["Elkenrade", 202, 5],
	["Elkerzee", 284, 4],
	["Ell", 141, 5],
	["Ellecom", 337, 6],
	["Ellemeet", 284, 4],
	["Ellerhei", 141, 5],
	["Ellerhuizen", 194, 7],
	["Ellersinghuizen", 79, 7],
	["Ellertshaar", 273, 0],
	["Ellewoutsdijk", 163, 4],
	["Elp", 107, 0],
	["Elsen", 111, 2],
	["Elsendorp", 171, 1],
	["Elsenerbroek", 111, 2],
	["Elshof", 262, 2],
	["Elshout", 345, 1],
	["Elsloo", 81, 8],
	["Elsloo", 321, 5],
	["Elspeet", 361, 6],
	["Elst", 354, 1],
	["Elst", 18, 6],
	["Elst", 43, 10],
	["Elsteren", 77, 5],
	["Elzen", 137, 1],
	["Elzenpas", 152, 6],
	["Den Elzent", 42, 1],
	["Elzet", 202, 5],
	["Emelang", 107, 0],
	["Emmaberg", 218, 5],
	["Emmadorp", 39, 4],
	["Emmeloord", 180, 11],
	["Emmen", 121, 0],
	["Emmen", 127, 2],
	["Emmer", 50, 6],
	["Emmer-Compascuum", 121, 0],
	["Emmer-Erfscheidenveen", 121, 0],
	["Emmermeer", 121, 0],
	["Emmerschans", 121, 0],
	["Emminkhuizen", 362, 10],
	["Empe", 312, 6],
	["Empel", 263, 1],
	["Emst", 278, 6],
	["Eng", 117, 10],
	["Eng en Kortenburgse Bossen", 363, 6],
	["De Eng", 59, 6],
	["Den Eng", 11, 6],
	["De Engel", 364, 9],
	["Engeland", 62, 2],
	["Engeland", 24, 6],
	["Engeland", 106, 0],
	["Engelbert", 291, 7],
	["Engelen", 263, 1],
	["Engelum", 203, 8],
	["Englum", 15, 7],
	["Engwerd", 85, 8],
	["Engwier", 96, 8],
	["Engwierum", 16, 8],
	["Enkhuizen", 365, 3],
	["Ens", 180, 11],
	["Enschede", 257, 2],
	["Enschot", 224, 1],
	["Enspijk", 71, 6],
	["Enter", 366, 2],
	["Enterbroek", 366, 2],
	["Enumatil", 247, 7],
	["Enzelens", 357, 7],
	["Epe", 278, 6],
	["Epen", 202, 5],
	["Eperheide", 202, 5],
	["Eppenhuizen", 227, 7],
	["Eppenzolder", 293, 2],
	["Epse", 97, 6],
	["Erica", 121, 0],
	["Erichem", 11, 6],
	["Erlecom", 195, 6],
	["Erlecom en Ooij", 195, 6],
	["Erm", 7, 0],
	["Ermelo", 197, 6],
	["Erp", 229, 1],
	["Esbeek", 169, 1],
	["Esch", 209, 1],
	["Escharen", 270, 1],
	["Eschoten", 210, 6],
	["Esdonk", 171, 1],
	["Esp", 19, 1],
	["Esp", 171, 1],
	["Espel", 180, 11],
	["Espelo", 232, 2],
	["Esperheide", 19, 1],
	["Essebroek", 11, 6],
	["Essen", 338, 7],
	["Essen", 184, 6],
	["Est", 327, 6],
	["Esveld", 184, 6],
	["Etenaken", 202, 5],
	["Etersheim", 154, 3],
	["Etsberg", 112, 5],
	["Etten", 240, 6],
	["Etten", 147, 1],
	["Etten-Leur", 147, 1],
	["Etzenrade", 239, 5],
	["Europoort", 286, 9],
	["Eursing", 107, 0],
	["Eursinge", 106, 0],
	["Eursinge", 281, 0],
	["Eursinge", 107, 0],
	["Euvelgunne", 291, 7],
	["Euvelwegen", 279, 1],
	["Euverem", 202, 5],
	["Everdingen", 266, 10],
	["Everinge", 163, 4],
	["Everland", 82, 1],
	["Everlo", 165, 5],
	["Eversdijk", 235, 4],
	["Everse", 280, 1],
	["Evertsoord", 29, 5],
	["Everwenninkhoek", 63, 6],
	["Ewer", 303, 7],
	["Van Ewijcksluis", 129, 3],
	["Ewijk", 231, 6],
	["Ewinkel", 200, 1],
	["Exel", 97, 6],
	["Exel-Tol", 97, 6],
	["Exloëboerkijl", 273, 0],
	["Exloërkijl", 273, 0],
	["Exloërmond", 273, 0],
	["Exloërveen", 273, 0],
	["Exloo", 273, 0],
	["Exmorra", 96, 8],
	["Exmorrazijl", 96, 8],
	["Eys", 202, 5],
	["Eyserheide", 202, 5],
	["Ezinge", 72, 7],
	["Ezumazijl", 16, 8],
	["Faan", 313, 7],
	["Farmsum", 122, 7],
	["Feanwâldsterwâl", 90, 8],
	["Feerwerd", 72, 7],
	["Felland", 338, 7],
	["Ferwerderadiel", 253, 8],
	["Ferwert", 253, 8],
	["Ferwoude", 96, 8],
	["Fiemel", 122, 7],
	["Fijnaart", 49, 1],
	["Finkeburen", 86, 8],
	["Finkum", 301, 8],
	["Finsterwolde", 201, 7],
	["Finsterwolderhamrik", 201, 7],
	["Firdgum", 41, 8],
	["Fivelzigt", 122, 7],
	["Flansum", 85, 8],
	["Fledderbosscherpolder", 60, 7],
	["Fleringen", 87, 2],
	["Flieren", 124, 6],
	["Fluitenberg", 53, 0],
	["Fochteloo", 81, 8],
	["Fokkershoek", 225, 1],
	["De Folgeren", 272, 8],
	["Follega", 176, 8],
	["Folsgare", 31, 8],
	["Fonden", 312, 6],
	["Formerhoek", 63, 6],
	["Formerum", 156, 8],
	["Fort", 106, 0],
	["Fort Ferdinandus", 153, 4],
	["'t Fort", 150, 1],
	["Fortmond", 262, 2],
	["Foudgum", 16, 8],
	["Foxel", 121, 0],
	["Foxham", 48, 7],
	["Foxhol", 48, 7],
	["Foxholsterbosch", 48, 7],
	["Foxwolde", 103, 0],
	["Fraamklap", 357, 7],
	["Franeker", 41, 8],
	["Frankhuis", 144, 2],
	["Frankrijk", 353, 6],
	["Franse Hoef", 245, 1],
	["Fransum", 15, 7],
	["Frederiksoord", 281, 0],
	["Friens", 85, 8],
	["Frieschepalen", 175, 8],
	["Frieswijk", 130, 2],
	["Friezenwijk", 143, 6],
	["Frik", 305, 3],
	["Fromberg", 185, 5],
	["Froombosch", 274, 7],
	["Gaag", 316, 9],
	["Gaal", 294, 1],
	["Gaanderen", 64, 6],
	["Gaarkeuken", 15, 7],
	["Gaarland", 274, 7],
	["In de Gaas", 158, 5],
	["Gaasp", 75, 3],
	["Gaasperdam", 75, 3],
	["Gaast", 86, 8],
	["Gaast", 96, 8],
	["De Gaasten", 272, 8],
	["Gaastmeer", 31, 8],
	["Gaddijk", 367, 9],
	["Gaete", 349, 1],
	["De Gagel", 260, 1],
	["Gageldonk", 191, 1],
	["Galamadammen", 288, 8],
	["Galberg", 200, 1],
	["Galder", 102, 1],
	["Gameren", 12, 6],
	["Gammelke", 78, 2],
	["Ganzedijk", 201, 7],
	["Ganzert", 11, 6],
	["Gapinge", 4, 4],
	["Garderbroek", 184, 6],
	["Garderen", 184, 6],
	["Garmerwolde", 60, 7],
	["Garminge", 107, 0],
	["Garnwerd", 72, 7],
	["Garrelsweer", 357, 7],
	["Garreweer", 134, 7],
	["Garsthuizen", 357, 7],
	["Garvelinkhoek", 63, 6],
	["Garyp", 90, 8],
	["Gassel", 270, 1],
	["Gasselte", 0, 0],
	["Gasselterboerveen", 0, 0],
	["Gasselterboerveenschemond", 0, 0],
	["Gasselternijveen", 0, 0],
	["Gasselternijveenschemond", 0, 0],
	["Gastel", 219, 1],
	["Gastelsveer", 283, 1],
	["Gasteren", 0, 0],
	["Gasthuis", 178, 5],
	["Gaternisse", 23, 4],
	["Gauw", 31, 8],
	["Gawege", 188, 4],
	["Gebergte", 47, 1],
	["Gebroek", 30, 5],
	["Geefsweer", 122, 7],
	["Geelbroek", 0, 0],
	["Geenhoven", 57, 1],
	["Geer", 67, 9],
	["Geer", 44, 10],
	["Geerdijk", 311, 2],
	["Geersbroek", 102, 1],
	["Geersdijk", 323, 4],
	["Geertruidenberg", 346, 1],
	["Geervliet", 34, 9],
	["Gees", 7, 0],
	["Geesbrug", 7, 0],
	["Geestdorp", 187, 10],
	["Geesteren", 87, 2],
	["Geesteren", 63, 6],
	["Geeuwenbrug", 281, 0],
	["Geffen", 354, 1],
	["Gein", 36, 10],
	["Gein", 75, 3],
	["Het Gein", 368, 10],
	["Geitenkamp", 105, 6],
	["Geitenwaard", 74, 6],
	["Gelderingen", 166, 2],
	["Geldermalsen", 71, 6],
	["Gelderse Buurt", 129, 3],
	["Gelderse Dijk", 292, 6],
	["Gelders-Veenendaal", 210, 6],
	["Gelderswoude", 369, 9],
	["Geldrop", 206, 1],
	["Geldrop-Mierlo", 206, 1],
	["Geleen", 275, 5],
	["Gelkenes", 370, 9],
	["Gellicum", 71, 6],
	["Geloo", 135, 5],
	["Gelselaar", 63, 6],
	["Gement", 54, 1],
	["Gement", 221, 1],
	["Gemert", 171, 1],
	["Gemert-Bakel", 171, 1],
	["Gemonde", 198, 1],
	["Gemullehoeken", 308, 1],
	["Genderen", 6, 1],
	["Gendringen", 240, 6],
	["Gendt", 124, 6],
	["Genemuiden", 167, 2],
	["Genenberg", 29, 5],
	["Geneneind", 171, 1],
	["Gening", 77, 5],
	["Genne", 144, 2],
	["Gennep", 42, 1],
	["Gennep", 8, 5],
	["Genoenhuis", 206, 1],
	["Genooi", 135, 5],
	["Genooierbergen", 135, 5],
	["Gerendal", 218, 5],
	["Gerheggen", 141, 5],
	["Gerkesklooster", 69, 8],
	["Gerner", 127, 2],
	["Gerns", 96, 8],
	["Gersloot", 271, 8],
	["Gerven", 237, 6],
	["Gerverscop", 187, 10],
	["De Gest", 208, 3],
	["Gestel", 42, 1],
	["Getfert", 257, 2],
	["Geulhem", 218, 5],
	["Geulle", 306, 5],
	["Geverik", 196, 5],
	["Gewande", 263, 1],
	["Geysteren", 254, 5],
	["Gieltjesdorp", 297, 10],
	["Giersbergen", 159, 1],
	["Giesbeek", 125, 6],
	["Giessen", 100, 1],
	["Giessenburg", 138, 9],
	["Giessendam", 289, 9],
	["Giessenlanden", 138, 9],
	["Giessen-Oudekerk", 138, 9],
	["Gietelo", 133, 6],
	["Gieten", 0, 0],
	["Gieterveen", 0, 0],
	["Giethmen", 136, 2],
	["Giethoorn", 166, 2],
	["Gijbeland", 252, 9],
	["Gijzel", 209, 1],
	["Gijzenrooi", 206, 1],
	["Gilden", 296, 3],
	["Gilze", 265, 1],
	["Gilze en Rijen", 265, 1],
	["Ginderdoor", 27, 1],
	["Ginderdoor", 102, 1],
	["Ginderover", 279, 1],
	["De Ginkel", 210, 6],
	["Ginneken", 191, 1],
	["Ginnum", 253, 8],
	["Glane", 230, 2],
	["Glanerbrug", 257, 2],
	["Glanerveld", 257, 2],
	["Glimmen", 338, 7],
	["De Glind", 184, 6],
	["Glindhorst", 184, 6],
	["De Glip", 371, 3],
	["Gnephoek", 25, 9],
	["Godlinze", 122, 7],
	["Goedereede", 372, 9],
	["Goënga", 31, 8],
	["Goëngahuizen", 272, 8],
	["Goes", 33, 4],
	["Goffert", 211, 6],
	["Goidschalxoord", 241, 9],
	["Goilberdingen", 329, 6],
	["Goingarijp", 86, 8],
	["Het Goirke", 224, 1],
	["Goirle", 37, 1],
	["Goldhoorn", 201, 7],
	["Gooi", 50, 6],
	["Gooium", 96, 8],
	["Goor", 111, 2],
	["Het Goor", 206, 1],
	["De Goorn", 151, 3],
	["Gorinchem", 331, 9],
	["Gorp", 169, 1],
	["Gorredijk", 175, 8],
	["Gorssel", 97, 6],
	["Gortel", 278, 6],
	["Gouda", 255, 9],
	["Gouderak", 373, 9],
	["Goudriaan", 252, 9],
	["Goudseweg", 204, 9],
	["Goudswaard", 374, 9],
	["Goutum", 161, 8],
	["Gouwe", 28, 3],
	["'t Goy", 375, 10],
	["Graaf", 214, 10],
	["Graafland", 370, 9],
	["Graafstroom", 252, 9],
	["Graauw", 39, 4],
	["Gracht (ged.)", 38, 5],
	["Gracht (ged.)", 250, 5],
	["Graetheide", 275, 5],
	["Grafhorst", 243, 2],
	["Graft", 376, 3],
	["Graft-De Rijp", 376, 3],
	["Graftdijk", 376, 3],
	["Gramsbergen", 62, 2],
	["Grashoek", 165, 5],
	["Graspeel", 294, 1],
	["Grathem", 141, 5],
	["Grauwe Kat", 96, 8],
	["Grauwe Polder", 147, 1],
	["Grave", 270, 1],
	["Gravekoop", 348, 9],
	["'s-Graveland", 286, 9],
	["'s-Graveland", 126, 3],
	["'s-Gravendeel", 241, 9],
	["Den Haag", 377, 9],
	["'s-Gravenmoer", 347, 1],
	["'s-Gravenmoerse Vaart", 347, 1],
	["'s-Gravenpolder", 163, 4],
	["'s-Gravenschans", 274, 7],
	["Gravensloot 's-", 187, 10],
	["'s-Gravenwaard", 74, 6],
	["'s-Gravenweg", 359, 9],
	["'s-Gravenzande", 378, 9],
	["Grazen", 102, 1],
	["Grebbe", 43, 10],
	["Greffeling", 101, 6],
	["Greffelkamp", 155, 6],
	["Greidhoek", 203, 8],
	["Greonterp", 31, 8],
	["Greup", 241, 9],
	["Grevenbicht", 275, 5],
	["Griendtsveen", 29, 5],
	["Grientsveen", 121, 0],
	["Griete", 153, 4],
	["Grieth", 125, 6],
	["Griffenstein", 149, 10],
	["Grijpskerk", 15, 7],
	["Grijpskerke", 4, 4],
	["Grijssloot", 303, 7],
	["Grijzegrubben", 5, 5],
	["Grobbendonck", 37, 1],
	["Groede", 23, 4],
	["Groenekan", 65, 10],
	["Groeneweg", 359, 9],
	["Groenewoud", 224, 1],
	["Groeningen", 228, 1],
	["Groenlanden", 195, 6],
	["Groenlo", 356, 6],
	["Groenstraat", 169, 1],
	["Groenveld", 340, 3],
	["Groes", 225, 1],
	["Groesbeek", 220, 6],
	["Groeskuilen", 171, 1],
	["Groessen", 59, 6],
	["Groet", 3, 3],
	["De Groeve", 213, 0],
	["Groeze", 165, 5],
	["Grolloo", 0, 0],
	["Groningen", 291, 7],
	["Gronsveld", 298, 5],
	["Groot Dochteren", 97, 6],
	["Groot Loo", 169, 1],
	["Groot-Abeele", 379, 4],
	["Groot-Ammers", 370, 9],
	["Groot-Doenrade", 119, 5],
	["Groote Aard", 83, 1],
	["Groote Haar", 331, 9],
	["Op de Groote Heide", 279, 1],
	["Groote Hoeven", 47, 1],
	["Groote Horst", 77, 5],
	["Groote Keeten", 35, 3],
	["Groote Lindt", 52, 9],
	["Groote Peel", 171, 1],
	["Groote Polder", 49, 1],
	["Grootebroek", 290, 3],
	["Grootegast", 313, 7],
	["Grootgenhout", 196, 5],
	["Grootschermer", 350, 3],
	["Groot-Wetsinge", 72, 7],
	["Grosthuizen", 151, 3],
	["Grote en Kleine Heide", 135, 5],
	["Grote Koolwijk", 54, 1],
	["Grote Zilk", 380, 9],
	["Grou", 85, 8],
	["Grubbenvorst", 29, 5],
	["Gulpen", 202, 5],
	["Gulpen-Wittem", 202, 5],
	["Gun", 29, 5],
	["Guttecoven", 275, 5],
	["Gytsjerk", 90, 8],
	["Haaften", 327, 6],
	["Haagje", 115, 10],
	["'t Haagje", 166, 2],
	["Haagoord", 6, 1],
	["Haagse-Beemden", 191, 1],
	["Haaksbergen", 293, 2],
	["Haakswold", 106, 0],
	["De Haal", 381, 3],
	["Haalderen", 124, 6],
	["Haaldersbroek", 56, 3],
	["Haamstede", 284, 4],
	["Haanrade", 250, 5],
	["Haansberg", 147, 1],
	["'t Haantje", 301, 8],
	["'t Haantje", 7, 0],
	["'t Haantje", 382, 9],
	["Haanwijk", 187, 10],
	["Haanwijk", 198, 1],
	["Haar", 363, 6],
	["Haar", 115, 10],
	["De Haar", 261, 7],
	["De Haar", 7, 0],
	["De Haar", 62, 2],
	["De Haar", 63, 6],
	["De Haar", 256, 10],
	["Ter Haar", 79, 7],
	["Haaren", 209, 1],
	["Haarle", 330, 2],
	["Haarle", 87, 2],
	["Haarlem", 383, 3],
	["Haarlemmerliede", 384, 3],
	["Haarlemmerliede en Spaarnwoude", 384, 3],
	["Haarlemmermeer", 10, 3],
	["Haarlo", 63, 6],
	["Haarsteeg", 345, 1],
	["Haart", 17, 6],
	["Haarzuilens", 92, 10],
	["Haasdal", 5, 5],
	["Haastrecht", 204, 9],
	["Haelen", 141, 5],
	["Haelensche Broek", 141, 5],
	["Haerst", 144, 2],
	["Hagenkamp", 42, 1],
	["Hagestein", 266, 10],
	["Haghorst", 169, 1],
	["Haiink", 82, 1],
	["Hal", 209, 1],
	["Halder", 198, 1],
	["Halderberge", 283, 1],
	["Haler", 141, 5],
	["Halerbrug", 107, 0],
	["Halfweg", 339, 2],
	["Halfweg", 384, 3],
	["Halfweg", 364, 9],
	["Halfweg", 213, 0],
	["Hall", 312, 6],
	["Halle", 50, 6],
	["Hallum", 253, 8],
	["Hallumer Hoek", 253, 8],
	["Halsteren", 150, 1],
	["Halte", 172, 1],
	["Halvinkhuizen", 237, 6],
	["Ham", 229, 1],
	["Ham", 250, 5],
	["De Ham", 116, 10],
	["Den Ham", 207, 7],
	["Den Ham", 15, 7],
	["Den Ham", 92, 10],
	["Den Ham", 311, 2],
	["Het Ham", 249, 1],
	["Hamdijk", 201, 7],
	["Hamersveld", 61, 10],
	["Hamingen", 339, 2],
	["Hamshorn", 69, 8],
	["Handel", 171, 1],
	["Haneburen", 175, 8],
	["Hanetange", 79, 7],
	["Hank", 74, 6],
	["Hank", 160, 1],
	["Hankate", 330, 2],
	["Hanssum", 141, 5],
	["Hansweert", 188, 4],
	["Hantum", 16, 8],
	["Hantumeruitburen", 16, 8],
	["Hantumhuizen", 16, 8],
	["Hanzewijk", 243, 2],
	["Hapert", 245, 1],
	["Haps", 200, 1],
	["Harbrinkhoek", 87, 2],
	["Harculo", 144, 2],
	["'t Harde", 131, 6],
	["Hardenberg", 62, 2],
	["Hardenberg", 201, 7],
	["Harderwijk", 353, 6],
	["Harderwijk", 28, 3],
	["Hardeweer", 72, 7],
	["Hardinxveld-Giessendam", 289, 9],
	["Hare", 7, 0],
	["Haren", 338, 7],
	["Haren", 54, 1],
	["Harenermolen", 338, 7],
	["Harenkarspel", 340, 3],
	["Harfsen", 97, 6],
	["Hargen", 3, 3],
	["Harich", 174, 8],
	["Haringhuizen", 186, 3],
	["Harkema", 69, 8],
	["Harkstede", 274, 7],
	["Harles", 319, 5],
	["Harlingen", 98, 8],
	["Harmelen", 187, 10],
	["Harmelerwaard", 187, 10],
	["Harpel", 79, 7],
	["Harreveld", 356, 6],
	["Harskamp", 210, 6],
	["Harssens", 291, 7],
	["'t Hart", 117, 10],
	["Hartwerd", 96, 8],
	["Haskerdijken", 86, 8],
	["Haskerhorne", 86, 8],
	["Haskerland", 86, 8],
	["De Haspel", 247, 7],
	["Hasselt", 224, 1],
	["Hasselt", 135, 5],
	["Hasselt", 167, 2],
	["Hasselterdijk", 144, 2],
	["Hatenboer", 142, 5],
	["Hatert", 211, 6],
	["Hatertse Heide", 211, 6],
	["Hattem", 226, 6],
	["Hattemerbroek", 292, 6],
	["De Haukes", 208, 3],
	["Haule", 81, 8],
	["Haulerwijk", 81, 8],
	["Hauwert", 32, 3],
	["Havelt", 229, 1],
	["Havelte", 281, 0],
	["Havelterberg", 281, 0],
	["Havenbuurt", 302, 3],
	["Havikkerwaard", 337, 6],
	["Hayum", 96, 8],
	["Hazelaar", 82, 1],
	["Hazelberg", 225, 1],
	["Hazeldonk", 70, 1],
	["Hazeldonk", 49, 1],
	["Hazenkamp", 135, 5],
	["Hazerswoude Dorp", 215, 9],
	["Hazerswoude Rijndijk", 215, 9],
	["Hedel", 91, 6],
	["Hedel", 285, 1],
	["Hedikhuizen", 345, 1],
	["Hee", 156, 8],
	["Heeg", 31, 8],
	["Heel", 170, 5],
	["Heelsum", 318, 6],
	["Heelweg", 240, 6],
	["Heemse", 62, 2],
	["Heemserveen", 62, 2],
	["Heemskerk", 146, 3],
	["Heemskerkerduin", 146, 3],
	["Heemstede", 371, 3],
	["De Heen", 248, 1],
	["Heensche Polders", 248, 1],
	["Heenvliet", 34, 9],
	["Heer", 113, 5],
	["Heerde", 222, 6],
	["Heereburen", 15, 7],
	["'s-Heerenberg", 155, 6],
	["'s-Heerenbroek", 243, 2],
	["'s-Heerenhoek", 163, 4],
	["Heerenveen", 271, 8],
	["Heerewaarden", 91, 6],
	["Heerhugowaard", 305, 3],
	["Heerjansdam", 52, 9],
	["Heerle", 82, 1],
	["Heerlen", 190, 5],
	["Heerlerbaan", 190, 5],
	["Heerlerheide", 190, 5],
	["Heers", 83, 1],
	["Heerstraat", 218, 5],
	["Hees", 211, 6],
	["Hees", 117, 10],
	["Hees", 106, 0],
	["De Hees", 264, 1],
	["De Hees", 29, 5],
	["Heesakker", 219, 1],
	["Heesbeen", 345, 1],
	["Heesch", 225, 1],
	["Heeseind", 263, 1],
	["Heesselt", 327, 6],
	["Heeswijk", 66, 10],
	["Heeswijk", 225, 1],
	["Heeswijk Dinther", 225, 1],
	["Heeten", 93, 2],
	["Heetveld", 166, 2],
	["Heeze", 279, 1],
	["Heeze-Leende", 279, 1],
	["Hefswal", 227, 7],
	["Hegebeintum", 253, 8],
	["Hegelsom", 29, 5],
	["Hegge", 278, 6],
	["Hegge", 119, 5],
	["Hei", 108, 5],
	["Heiakker", 141, 5],
	["Heibloem", 141, 5],
	["Heide", 86, 8],
	["Heide", 155, 6],
	["Heide", 385, 6],
	["Heide", 141, 5],
	["Heide", 170, 5],
	["Heide", 135, 5],
	["Heide", 254, 5],
	["Heide", 30, 5],
	["De Heide", 29, 5],
	["Heidenhoek", 50, 6],
	["Hei-en Boeicop", 67, 9],
	["Heiereind", 1, 1],
	["Heierhoeve", 135, 5],
	["Heihoek", 54, 1],
	["Heihoek", 200, 1],
	["Ter Heijde", 378, 9],
	["Heijen", 8, 5],
	["Heijendaal", 211, 6],
	["Heijenoord", 105, 6],
	["Heijenrade", 202, 5],
	["Heijenrath", 202, 5],
	["Heijningen", 49, 1],
	["Heijplaat", 286, 9],
	["Heikant", 39, 4],
	["Heikant", 164, 1],
	["Heikant", 224, 1],
	["Heikant", 193, 1],
	["Heikant", 83, 1],
	["Heikant", 13, 1],
	["Heikant", 244, 5],
	["Heikant", 27, 1],
	["Heikant", 219, 1],
	["Heikant", 102, 1],
	["Heikant", 245, 1],
	["Heikantse Hoeve", 198, 1],
	["Heike", 83, 1],
	["Heilaren", 225, 1],
	["Heilig Landstichting", 220, 6],
	["Heiligeboom", 308, 1],
	["Heiligerlee", 201, 7],
	["Heille", 23, 4],
	["Heiloo", 267, 3],
	["Heilust", 250, 5],
	["Heimolen", 20, 1],
	["Heinenoord", 241, 9],
	["Heinist", 263, 1],
	["Heinkenszand", 163, 4],
	["Heino", 93, 2],
	["Heisterbrug", 119, 5],
	["Heistraat", 14, 1],
	["Heistraat", 83, 1],
	["Heitrak", 172, 1],
	["Hekelingen", 367, 9],
	["Hekendorp", 336, 10],
	["Hekkens", 8, 5],
	["Heksenberg", 190, 5],
	["Helden", 165, 5],
	["Heldensedijk", 165, 5],
	["Den Helder", 352, 3],
	["Helenaveen", 172, 1],
	["Helhoek", 386, 9],
	["Helkant", 349, 1],
	["Hell", 237, 6],
	["Helle", 5, 5],
	["Hellebroek", 5, 5],
	["De Hellen", 37, 1],
	["Hellendoorn", 330, 2],
	["Hellevoetsluis", 387, 9],
	["Helling", 254, 5],
	["Hellouw", 327, 6],
	["Hellum", 274, 7],
	["Helmond", 205, 1],
	["Helsdingen", 266, 10],
	["Helvoirt", 209, 1],
	["Helwerd", 227, 7],
	["Helwijk", 49, 1],
	["Helzenhoek", 354, 1],
	["Hem", 242, 3],
	["Hembrug", 56, 3],
	["Hemelum", 288, 8],
	["Hemert", 96, 8],
	["Hemmen", 338, 7],
	["Hemmen", 18, 6],
	["Hempens", 161, 8],
	["Hemrik", 175, 8],
	["Hendrik-Ido-Ambacht", 388, 9],
	["Hengeland", 77, 5],
	["Hengelo", 192, 2],
	["Hengelo", 50, 6],
	["Hengevelde", 111, 2],
	["Hengforden", 262, 2],
	["Hengstdijk", 39, 4],
	["Hengstheuvel", 193, 1],
	["Hensbroek", 151, 3],
	["Henxel", 300, 6],
	["Herbaijum", 41, 8],
	["Herfte", 144, 2],
	["Herike", 111, 2],
	["Op den Hering", 239, 5],
	["Herkenbosch", 112, 5],
	["Herkenrade", 178, 5],
	["Herkingen", 341, 9],
	["Hermalen", 277, 1],
	["Hernen", 109, 6],
	["Herongerberg", 135, 5],
	["Herpen", 54, 1],
	["Herpt", 345, 1],
	["Hersel", 47, 1],
	["Hert", 165, 5],
	["Herten", 142, 5],
	["Hertme", 276, 2],
	["Den Bosch", 263, 1],
	["Herveld", 18, 6],
	["Herwen", 74, 6],
	["Herwijnen", 143, 6],
	["Herxen", 262, 2],
	["Hesens", 157, 8],
	["Heseveld", 211, 6],
	["Hesselingen", 307, 0],
	["Hessum", 127, 2],
	["Heteren", 18, 6],
	["Heugde", 141, 5],
	["Heugem", 113, 5],
	["Heugemerveld", 113, 5],
	["Heukelom", 308, 1],
	["Heukelom", 77, 5],
	["Heukelum", 143, 6],
	["Heul", 283, 1],
	["De Heul", 381, 3],
	["Heumen", 385, 6],
	["Heuneind", 224, 1],
	["Heure", 63, 6],
	["Heurne", 17, 6],
	["Heurne", 63, 6],
	["De Heurne", 17, 6],
	["Heusden", 45, 1],
	["Heusden", 345, 1],
	["Heusdenhout", 191, 1],
	["Heuvel", 191, 1],
	["Heuvel", 19, 1],
	["Heuvel", 229, 1],
	["Heuvel", 225, 1],
	["Heuvel", 245, 1],
	["De Heuvel", 13, 1],
	["Heuvelberg", 229, 1],
	["Heuvels", 54, 1],
	["Heuvelstraat", 308, 1],
	["De Heuven", 240, 6],
	["Heveadorp", 318, 6],
	["Heveringen", 386, 9],
	["Heveskes", 122, 7],
	["Heythuysen", 141, 5],
	["Hezelaar", 217, 1],
	["Hezelaar", 198, 1],
	["Hezingen", 87, 2],
	["Hiaure", 16, 8],
	["Hichtum", 96, 8],
	["Hidaard", 157, 8],
	["Hien", 342, 6],
	["Hierden", 353, 6],
	["Hieslum", 96, 8],
	["Hijken", 107, 0],
	["Hijkersmilde", 107, 0],
	["Hijum", 301, 8],
	["Hil", 147, 1],
	["Hilaard", 157, 8],
	["Hilakker", 171, 1],
	["Hillegersberg", 286, 9],
	["Hillegom", 140, 9],
	["Hilleshagen", 202, 5],
	["De Hilte", 0, 0],
	["Hilvarenbeek", 169, 1],
	["Hilversum", 324, 3],
	["Hilversumse Meent", 324, 3],
	["Hindeloopen", 288, 8],
	["Hinderdam", 126, 3],
	["Hingen", 30, 5],
	["Hinnaard", 157, 8],
	["Hintham", 263, 1],
	["Hippolytushoef", 208, 3],
	["Hitland", 359, 9],
	["Hitsberg", 275, 5],
	["Hitzum", 41, 8],
	["Hobbelrade", 196, 5],
	["Hobrede", 154, 3],
	["Hodenpijl", 316, 9],
	["Hoedekenskerke", 163, 4],
	["Hoef", 237, 6],
	["De Hoef", 44, 10],
	["Hoek", 231, 6],
	["Hoek", 153, 4],
	["Hoek", 229, 1],
	["Hoek van Holland", 286, 9],
	["De Hoek", 10, 3],
	["De Hoek", 367, 9],
	["Den Hoek", 249, 1],
	["'t Hoekje", 159, 1],
	["Hoekske", 49, 1],
	["Hoeksmeer", 357, 7],
	["Hoenderbos", 193, 1],
	["Hoenderloo (ged.)", 24, 6],
	["Hoenderloo (ged.)", 210, 6],
	["Hoenkoop", 336, 10],
	["Hoensbroek", 190, 5],
	["Hoenwaard", 226, 6],
	["Hoenzadriel", 91, 6],
	["Hoetmansmeer", 310, 7],
	["Hoeve", 57, 1],
	["Hoeve", 124, 6],
	["De Hoeve", 251, 8],
	["Hoevelaken", 132, 6],
	["Hoeven", 193, 1],
	["Hoeven", 259, 5],
	["Hoeven", 171, 1],
	["Hoeven", 283, 1],
	["De Hoeven", 133, 6],
	["Hoeveneind", 191, 1],
	["Hoeves", 277, 1],
	["Hof", 165, 5],
	["Hof", 1, 1],
	["Hof van Twente", 111, 2],
	["Achter het Hof", 283, 1],
	["'t Hof", 27, 1],
	["Hofgeest", 296, 3],
	["Höfke", 202, 5],
	["Hofwegen", 252, 9],
	["Hoge Dennen", 149, 10],
	["Hoge Giessen", 138, 9],
	["Hoge Mors", 389, 9],
	["Hoge Rijndijk", 369, 9],
	["Hoge Zijde", 25, 9],
	["Hogebieren", 186, 3],
	["Hogebrug", 336, 10],
	["Hogeland", 257, 2],
	["Hogendijk", 248, 1],
	["Hogenkamp", 226, 6],
	["Hogeweg", 243, 2],
	["Ter Hole", 39, 4],
	["Holendrecht", 314, 3],
	["Holevoet", 390, 6],
	["Holijsloot", 120, 3],
	["Holk", 132, 6],
	["Holkerveen", 132, 6],
	["Hollandsche Rading", 65, 10],
	["Hollandscheveld", 53, 0],
	["Hollum", 114, 8],
	["De Holm", 247, 7],
	["Holset", 319, 5],
	["Holsloot", 7, 0],
	["Holst", 112, 5],
	["Holte", 104, 7],
	["Holten", 144, 2],
	["Holten", 232, 2],
	["Holterhoek", 63, 6],
	["Holthe", 107, 0],
	["Holthees", 228, 1],
	["Holtheme", 62, 2],
	["Holthone", 62, 2],
	["Holthuizen", 155, 6],
	["Holthuizen", 125, 6],
	["Holtinge", 281, 0],
	["Holtum", 275, 5],
	["Holwerd", 16, 8],
	["Holwierde", 122, 7],
	["Holwinde", 227, 7],
	["Holz", 250, 5],
	["Hommert (ged.)", 5, 5],
	["Hommert (ged.)", 119, 5],
	["Hommerts", 31, 8],
	["Homoet", 18, 6],
	["Hondsdijk", 215, 9],
	["Honesch", 293, 2],
	["Hongerige Wolf", 201, 7],
	["Honselersdijk", 378, 9],
	["Hontenisse", 39, 4],
	["Honthem", 178, 5],
	["Hoofddorp", 10, 3],
	["Hoofdplaat", 23, 4],
	["Hoogblokland", 138, 9],
	["Hoogbroek", 342, 6],
	["Hoog-Buurlo", 24, 6],
	["Hoog-Caestert", 298, 5],
	["Hoogcasteren", 245, 1],
	["Hoogcruts", 178, 5],
	["Hoogduurswolde", 81, 8],
	["Hooge Berkt", 1, 1],
	["Hooge Enk", 131, 6],
	["Hooge Hexel", 366, 2],
	["Hooge Mierde", 58, 1],
	["Hooge Zandschel", 159, 1],
	["Hooge Zwaluwe", 349, 1],
	["Hoogebiezen", 229, 1],
	["Hoogedijk", 153, 4],
	["Hoogeind", 391, 6],
	["Hoogeind", 334, 9],
	["Hoogeind", 37, 1],
	["Hoogeind", 169, 1],
	["Hoogeloon", 245, 1],
	["Hoogemeeden", 15, 7],
	["Hoogen-Aarle", 171, 1],
	["Hoogendijk", 56, 3],
	["Hoogengraven", 136, 2],
	["Hoogenweg", 62, 2],
	["Hoogerheide", 20, 1],
	["Hoogerot", 292, 6],
	["Hoogersmilde", 107, 0],
	["Hooge-Vaart", 162, 1],
	["Hoogeveen", 53, 0],
	["Hoogewaard", 67, 9],
	["Hoogewaard", 215, 9],
	["Hoogeweg", 23, 4],
	["Hoogezand", 48, 7],
	["Hoogezand-Sappemeer", 48, 7],
	["Hooghalen", 107, 0],
	["Hoogkamp", 105, 6],
	["Hoogkarspel", 242, 3],
	["Hoog-Keppel", 50, 6],
	["Hoogkerk", 291, 7],
	["Hoogland", 116, 10],
	["Hooglanderveen", 116, 10],
	["Hoogmade", 94, 9],
	["Hoogmeren", 11, 6],
	["Hoograven", 368, 10],
	["Hoog Soeren", 24, 6],
	["Hoogstraat", 141, 5],
	["De Hoogte", 291, 7],
	["Hoogvliet", 286, 9],
	["Hoogwatum", 122, 7],
	["Hoogwoud", 28, 3],
	["Hoog-Zuthem", 144, 2],
	["Hooilandseweg", 227, 7],
	["Hooipolder", 346, 1],
	["Den Hool", 7, 0],
	["Hoonhorst", 127, 2],
	["Hoonte", 63, 6],
	["Hoorn", 207, 7],
	["Hoorn", 156, 8],
	["Hoorn", 222, 6],
	["Hoorn", 177, 3],
	["Hoorn", 25, 9],
	["Den Hoorn", 183, 3],
	["Den Hoorn", 316, 9],
	["Hoornaar", 138, 9],
	["Hoorndervenen", 207, 7],
	["Hoorneboeg", 324, 3],
	["Hoornsedijk", 338, 7],
	["Hoornsterzwaag", 271, 8],
	["Hoorzik", 91, 6],
	["Hopel (ged.)", 38, 5],
	["Hopel (ged.)", 250, 5],
	["Hoptille", 157, 8],
	["Horick", 259, 5],
	["Horickheide", 259, 5],
	["Horn", 290, 3],
	["Horn", 141, 5],
	["De Horn", 233, 3],
	["De Horn", 75, 3],
	["Den Horn", 15, 7],
	["Hornhuizen", 303, 7],
	["Horssen", 76, 6],
	["Horst", 197, 6],
	["Horst", 220, 6],
	["Horst", 29, 5],
	["Horst aan de Maas", 29, 5],
	["De Horst", 108, 5],
	["De Horst", 103, 0],
	["Horsten", 104, 7],
	["Horsthoek", 222, 6],
	["Horszak", 54, 1],
	["Horzik", 198, 1],
	["Houberg", 74, 6],
	["Hout", 206, 1],
	["Hout en Oijen", 165, 5],
	["Den Hout", 242, 3],
	["Den Hout", 14, 1],
	["Houtakker", 169, 1],
	["Hout-Blerick", 135, 5],
	["Houtdijken", 187, 10],
	["Houtdorp", 197, 6],
	["Houten", 375, 10],
	["Houten", 170, 5],
	["Houtens", 19, 1],
	["Houtgoor", 102, 1],
	["Houthem", 218, 5],
	["Houthuizen", 29, 5],
	["Houtigehage", 272, 8],
	["Houtrakpolder", 384, 3],
	["De Houw", 303, 7],
	["Houwerzijl", 303, 7],
	["Hoven", 309, 6],
	["Hugten", 219, 1],
	["Huij", 200, 1],
	["Huijbergen", 20, 1],
	["Huinen", 237, 6],
	["Huis ter Heide", 149, 10],
	["Huis ter Heide", 103, 0],
	["Huisduinen", 352, 3],
	["Huisseling", 54, 1],
	["Huissen", 124, 6],
	["Huizen", 392, 3],
	["De Huizen", 62, 2],
	["Huizinge", 357, 7],
	["Huizum", 161, 8],
	["Hulhuizen", 124, 6],
	["De Hulk", 151, 3],
	["Huls", 158, 5],
	["Hulsberg", 5, 5],
	["Hulsdonk", 70, 1],
	["Hulsdonk", 82, 1],
	["Hulsel", 58, 1],
	["Hulsen", 330, 2],
	["Hulsen", 306, 5],
	["Hulsen", 259, 5],
	["Hulshorst", 361, 6],
	["Hulst", 39, 4],
	["Den Hulst", 339, 2],
	["Hulstheuvel", 193, 1],
	["Hulten", 265, 1],
	["Hultje", 193, 1],
	["Humcoven", 306, 5],
	["Hummelo", 50, 6],
	["Hunnecum", 5, 5],
	["Hunsel", 141, 5],
	["Huppel", 300, 6],
	["Hupsel", 63, 6],
	["Hurdegaryp", 90, 8],
	["De Hurk", 42, 1],
	["Hurkske", 229, 1],
	["Hurpesch", 202, 5],
	["Hurwenen", 91, 6],
	["Hushoven", 108, 5],
	["Husken", 190, 5],
	["Hussenberg", 306, 5],
	["De Hut", 202, 5],
	["Huygevoort", 285, 1],
	["Idaarderadeel", 85, 8],
	["Idaerd", 85, 8],
	["Idsegahuizum", 96, 8],
	["Idserdaburen", 96, 8],
	["Idskenhuizen", 86, 8],
	["Ter Idzard", 251, 8],
	["Idzega", 31, 8],
	["Iens", 157, 8],
	["IJhorst", 339, 2],
	["IJlst", 31, 8],
	["IJmuiden", 296, 3],
	["IJpelaarseind", 191, 1],
	["IJpelo", 366, 2],
	["IJsselham", 166, 2],
	["IJsselmonde", 286, 9],
	["IJsselmuiden", 243, 2],
	["IJsselstein", 55, 10],
	["IJzendijke", 23, 4],
	["IJzendoorn", 342, 6],
	["IJzeren", 218, 5],
	["IJzerenbrug", 387, 9],
	["IJzerlo", 17, 6],
	["IJzevoorde", 64, 6],
	["Illikhoven", 275, 5],
	["Den Ilp", 394, 3],
	["Ilpendam", 302, 3],
	["Ilpenstein", 394, 3],
	["Imbosch", 395, 6],
	["Imstenrade", 190, 5],
	["Indijk", 31, 8],
	["Indoornik", 18, 6],
	["Ingber", 202, 5],
	["Ingen", 11, 6],
	["It Heidenskip", 288, 8],
	["Itens", 157, 8],
	["Itteren", 113, 5],
	["Ittersum", 144, 2],
	["Ittervoort", 141, 5],
	["Jaarsveld", 214, 10],
	["Jabeek", 239, 5],
	["Jacobswoude", 94, 9],
	["Jagerswijk", 48, 7],
	["'t Jagertje", 39, 4],
	["Jankenberg", 150, 1],
	["Jannum", 253, 8],
	["Jarringa", 81, 8],
	["Jekerdal", 113, 5],
	["Jellum", 157, 8],
	["Jelsum", 301, 8],
	["Jet", 157, 8],
	["Jipsingboermussel", 79, 7],
	["Jipsingboertange", 79, 7],
	["Jipsinghuizen", 79, 7],
	["Jirnsum", 85, 8],
	["Jislum", 253, 8],
	["Jisp", 396, 3],
	["Jistrum", 90, 8],
	["Jonen", 166, 2],
	["Jonkerland", 175, 8],
	["Jonkershuizen", 96, 8],
	["Jonkersvaart", 261, 7],
	["Joppe", 97, 6],
	["Jorwert", 157, 8],
	["Joure", 86, 8],
	["Jousterp", 96, 8],
	["Jouswerd", 31, 8],
	["Jouswier", 16, 8],
	["De Jouwer", 313, 7],
	["Jubbega", 271, 8],
	["Jubbega-Schurega", 271, 8],
	["Jukwerd", 134, 7],
	["Julianadorp", 352, 3],
	["Junne", 136, 2],
	["Jutphaas", 368, 10],
	["Jutrijp", 31, 8],
	["Kaag", 94, 9],
	["Kaagdorp", 94, 9],
	["Kaag en Braassem", 94, 9],
	["Kaakhorn", 303, 7],
	["Kaalheide", 250, 5],
	["Kaarschot", 70, 1],
	["Kaart", 156, 8],
	["Kaathoven", 225, 1],
	["Kaatsheuvel", 159, 1],
	["Kabel", 10, 3],
	["Kade", 49, 1],
	["Kadijk", 46, 9],
	["Kadoelen", 166, 2],
	["Kakert", 38, 5],
	["Kalenberg", 166, 2],
	["Het Kalf", 56, 3],
	["Kalisbuurt", 333, 9],
	["Kalkwijk", 48, 7],
	["Kallenbroek", 184, 6],
	["Kallenkote", 166, 2],
	["Kalsdonk", 82, 1],
	["Kalslagen", 9, 3],
	["Kalteren", 281, 0],
	["Kalverdijk", 340, 3],
	["Kameren", 225, 1],
	["Kamerik", 187, 10],
	["Kamp", 77, 5],
	["Kamp 'De Vossenbosch'", 366, 2],
	["Kampen", 243, 2],
	["Kampen", 39, 4],
	["De Kampen", 186, 3],
	["De Kampen", 96, 8],
	["Kampereiland", 243, 2],
	["Kamperland", 323, 4],
	["Kamperpoort", 144, 2],
	["Kampershoek", 259, 5],
	["Kamperveen", 243, 2],
	["Kamperzeedijk", 167, 2],
	["Kanis", 187, 10],
	["Kantens", 227, 7],
	["Het Kantje", 225, 1],
	["Kapel", 124, 6],
	["Kapel-Avezaath (ged.)", 152, 6],
	["Kapel-Avezaath (ged.)", 11, 6],
	["Kapelle", 235, 4],
	["Kapellebrug", 39, 4],
	["Kapelpolder", 397, 9],
	["Kasen", 306, 5],
	["Kasteren", 217, 1],
	["Katendrecht", 286, 9],
	["Katerbosch", 244, 5],
	["Katham", 355, 3],
	["Kathoek", 151, 3],
	["Katlijk", 271, 8],
	["Kats", 323, 4],
	["Katsberg", 165, 5],
	["Katspolder", 153, 4],
	["Kattenbosch", 58, 1],
	["Kattendijke", 33, 4],
	["Katwijk", 398, 9],
	["Katwijk", 200, 1],
	["Katwijk", 333, 9],
	["Katwijk aan den  Rijn", 398, 9],
	["Katwijk aan Zee", 398, 9],
	["Katwolde", 144, 2],
	["Katwoude", 302, 3],
	["Kavelingen", 273, 0],
	["Kedichem", 334, 9],
	["Keent", 54, 1],
	["Keent", 108, 5],
	["Keersop", 57, 1],
	["Keijenborg", 50, 6],
	["Keinsmerbrug", 317, 3],
	["Keizerbosch", 141, 5],
	["Keizersdijk", 322, 9],
	["Keizersveer", 160, 1],
	["Kekerdom", 195, 6],
	["Keldonk", 229, 1],
	["Kelmond", 196, 5],
	["Kelpen", 141, 5],
	["De Kemp", 142, 5],
	["Kempkens", 229, 1],
	["Kenwerd", 15, 7],
	["Kerckebosch", 149, 10],
	["Kerensheide", 321, 5],
	["Kerk-Avezaath (ged.)", 152, 6],
	["Kerk-Avezaath (ged.)", 11, 6],
	["Kerkberg", 135, 5],
	["Kerkbuurt", 340, 3],
	["Kerkbuurt", 381, 3],
	["Kerkbuurt", 302, 3],
	["Kerkdriel", 91, 6],
	["Kerkeburen", 85, 8],
	["Kerkeinde", 160, 1],
	["Kerkelanden", 324, 3],
	["Kerkenbosch", 106, 0],
	["Kerkenveld", 106, 0],
	["Kerkhoven", 308, 1],
	["Kerkrade", 250, 5],
	["Kerkwerve", 284, 4],
	["Kerkwijk", 12, 6],
	["Kerkwijk", 344, 9],
	["Kersbergen", 149, 10],
	["Kerspel-Goor", 111, 2],
	["Kessel", 399, 1],
	["Kessel", 165, 5],
	["Kesseleik", 165, 5],
	["Kesteren", 342, 6],
	["Keten", 320, 9],
	["Kethel", 236, 9],
	["Keunenhoek", 219, 1],
	["Keup", 165, 5],
	["Keuperheide", 165, 5],
	["Keuter", 29, 5],
	["Keyenberg", 318, 6],
	["Kibbelgaarn", 182, 7],
	["Kibbelveen", 7, 0],
	["De Kie", 41, 8],
	["De Kiel", 7, 0],
	["Kielwindeweer", 48, 7],
	["Kiesterzijl", 41, 8],
	["Kievitsdel", 318, 6],
	["Kievitshaar", 62, 2],
	["Kievitsheide", 165, 5],
	["Kievitswaard", 160, 1],
	["Kijfhoek", 52, 9],
	["Kijkduin", 377, 9],
	["Kijkuit", 153, 4],
	["Kilder", 155, 6],
	["Kille", 160, 1],
	["Kimswerd", 96, 8],
	["Kinderbos", 217, 1],
	["Kinderdijk (ged.)", 88, 9],
	["Kinderdijk (ged.)", 400, 9],
	["Kingmatille", 41, 8],
	["Kinkhoven", 141, 5],
	["Kinnum", 156, 8],
	["Kitskensberg", 142, 5],
	["Klaarstraat", 259, 5],
	["Klaaswaal", 328, 9],
	["Kladde", 248, 1],
	["Klappenberg", 147, 1],
	["Klarenbeek", 105, 6],
	["Klarenbeek (ged.)", 24, 6],
	["Klarenbeek (ged.)", 133, 6],
	["Klarendal", 105, 6],
	["Klatering", 107, 0],
	["Klazienaveen", 121, 0],
	["Ter Kleef", 383, 3],
	["Klei", 303, 7],
	["De Klei", 401, 9],
	["Klein Amsterdam", 115, 10],
	["Klein Dochteren", 97, 6],
	["Klein Garnwerd", 72, 7],
	["Klein Genhout", 196, 5],
	["Klein Linden", 200, 1],
	["Klein Wetsinge", 72, 7],
	["Klein-Brabant", 23, 4],
	["Kleinder-Liempde", 217, 1],
	["Klein-Doenrade", 119, 5],
	["Klein-Dongen", 347, 1],
	["Kleine Drieromers", 161, 8],
	["Kleine Hoeven", 47, 1],
	["Kleine Horst", 77, 5],
	["Kleine Huisjes", 303, 7],
	["Kleine Meers", 321, 5],
	["Kleine Sluis", 129, 3],
	["Kleine Voort", 169, 1],
	["Kleine Zilk", 380, 9],
	["Kleine-Lindt", 52, 9],
	["Kleinemeer", 48, 7],
	["Klein-Groningen", 175, 8],
	["Klein-Harkstede", 274, 7],
	["Klein-Oekel", 70, 1],
	["Klein-Oosterwijk", 334, 9],
	["Klein-Schoot", 219, 1],
	["Klein-Ulsda", 207, 7],
	["Klein-Zundert", 70, 1],
	["De Klem", 322, 9],
	["Kleverskerke", 139, 4],
	["Klijndijk", 273, 0],
	["Klimmen", 185, 5],
	["Kling", 239, 5],
	["Klingelbeek", 105, 6],
	["Klingelsberg", 287, 5],
	["Klinkenberg", 11, 6],
	["Kloetinge", 33, 4],
	["De Klomp", 210, 6],
	["Achter het Klooster", 141, 5],
	["Kloosterbosch", 250, 5],
	["Kloosterburen", 303, 7],
	["Kloosterdijk", 136, 2],
	["Kloosterhaar", 62, 2],
	["Kloosterhoek", 263, 1],
	["Klooster-Lidlum", 41, 8],
	["Kloosterveen", 22, 0],
	["Kloosterzande", 39, 4],
	["De Klosse", 166, 2],
	["Kluis", 385, 6],
	["Klundert", 49, 1],
	["Klutsdorp", 150, 1],
	["Knegsel", 264, 1],
	["De Knijp", 227, 7],
	["Knikkerdorp", 77, 5],
	["De Knipe", 271, 8],
	["Knolle", 81, 8],
	["West-Knollendam", 56, 3],
	["Kockengen", 297, 10],
	["Koedijk", 95, 3],
	["Koedood (ged.)", 181, 9],
	["Koedood (ged.)", 89, 9],
	["Het Koegras", 352, 3],
	["Koehool", 41, 8],
	["Koehoorn", 107, 0],
	["Koekange", 106, 0],
	["Koekangerveld", 106, 0],
	["Koevering", 280, 1],
	["Koevering", 248, 1],
	["Koewacht", 153, 4],
	["Kokkelert", 30, 5],
	["Koldenburg", 81, 8],
	["Kolderveen", 307, 0],
	["Kolderveense Bovenboer", 307, 0],
	["Kolderwolde", 174, 8],
	["Kolham", 274, 7],
	["Koggenland", 151, 3],
	["Kolhol", 357, 7],
	["Kolhorn", 186, 3],
	["Kollum", 148, 8],
	["Kollumerpomp", 148, 8],
	["Kollumerzwaag", 148, 8],
	["Kommerdijk", 124, 6],
	["Kommerzijl", 15, 7],
	["Koningsbosch", 30, 5],
	["Koningsbuurt", 41, 8],
	["Koningshoeven", 224, 1],
	["Koningslust", 165, 5],
	["Koog aan de Zaan", 56, 3],
	["Koog Zaandijk", 56, 3],
	["De Koog", 183, 3],
	["De Koog", 145, 3],
	["Kooihuizen", 96, 8],
	["Kooldert", 193, 1],
	["De Koolhof", 172, 1],
	["Koolwijk", 204, 9],
	["Koolwijk", 54, 1],
	["Kooten", 69, 8],
	["Kootstertille", 69, 8],
	["Kootwijk", 184, 6],
	["Kootwijkerbroek", 184, 6],
	["De Kooy", 352, 3],
	["Kop van 't Land", 326, 9],
	["De Kop", 91, 6],
	["Kopstukken", 104, 7],
	["Korendijk", 374, 9],
	["Korengarst", 212, 7],
	["Korn", 160, 1],
	["Kornhorn", 313, 7],
	["Kornwerderzand", 96, 8],
	["Korrewegwijk", 291, 7],
	["Korte Akkeren", 255, 9],
	["Korte Akkers", 182, 7],
	["Korte Heide", 165, 5],
	["Kortehemmen", 272, 8],
	["Kortendijk", 82, 1],
	["Kortenhoef", 126, 3],
	["Kortenhoeven", 67, 9],
	["Kortenoord", 359, 9],
	["Korteraar", 21, 9],
	["Kortezwaag", 175, 8],
	["Kortgene", 323, 4],
	["Kortgerecht", 334, 9],
	["Kort-Haarlem", 255, 9],
	["Kortland (polder)", 402, 9],
	["Kortrijk", 297, 10],
	["Kortwoude", 69, 8],
	["Korvel", 224, 1],
	["Kostverloren", 118, 3],
	["Kostverloren", 201, 7],
	["Kostverlorenbocht", 118, 3],
	["Kostvlies", 0, 0],
	["Het Kotman", 257, 2],
	["Kotten", 300, 6],
	["Koudekerk aan den Rijn", 215, 9],
	["Koudekerke", 4, 4],
	["Koudenhoek", 207, 7],
	["Koudenhoek", 18, 6],
	["Koudhoorn", 237, 6],
	["Koudum", 288, 8],
	["Koufurderrige", 31, 8],
	["Koulen", 185, 5],
	["Kraan", 259, 5],
	["De Kraan", 224, 1],
	["Kraanmeer", 229, 1],
	["Kraanven", 159, 1],
	["De Kraats", 210, 6],
	["Krabbendam", 340, 3],
	["Krabbendijke", 188, 4],
	["Krachtighuizen", 237, 6],
	["Kraggenburg", 180, 11],
	["Krakeel", 53, 0],
	["Kralingen", 341, 9],
	["Kralingen", 286, 9],
	["Kraloo", 106, 0],
	["Kranenburg", 50, 6],
	["Kranendijk", 68, 9],
	["Krassum", 72, 7],
	["Krauwelgorsse Polder", 49, 1],
	["Kreek", 49, 1],
	["Kreielt", 264, 1],
	["Kreijel", 259, 5],
	["Kreijl", 279, 1],
	["Kreileroord", 403, 3],
	["Kreitsberg", 294, 1],
	["Krewerd", 122, 7],
	["Krichelberg", 250, 5],
	["De Krim", 62, 2],
	["Krimpen aan de Lek", 404, 9],
	["Krimpen aan den IJssel", 402, 9],
	["Kring van Dorth", 97, 6],
	["Kroddeburen", 60, 7],
	["De Kroeven", 82, 1],
	["Kromme Mijdrecht", 44, 10],
	["Kromme Rade", 126, 3],
	["Kromme-Elleboog", 201, 7],
	["Krommenie", 56, 3],
	["Krommeniedijk", 56, 3],
	["Kromwijk", 187, 10],
	["Kronenberg", 29, 5],
	["Kronenburg", 118, 3],
	["De Kroost", 149, 10],
	["Kropswolde", 48, 7],
	["De Krosselt", 135, 5],
	["Kruiningen", 188, 4],
	["Kruiningergors", 386, 9],
	["Kruis", 279, 1],
	["'t Kruis", 305, 3],
	["Kruisberg", 64, 6],
	["Kruisdijk", 23, 4],
	["Kruisdorp", 39, 4],
	["Kruiselwerk", 310, 7],
	["Kruishaar", 132, 6],
	["Kruisland", 248, 1],
	["Kruisschot", 27, 1],
	["Kruisstraat", 263, 1],
	["Kruisstraat", 283, 1],
	["Kruisweg", 223, 9],
	["Kruisweg", 303, 7],
	["Kûbaard", 157, 8],
	["Kudelstaart", 9, 3],
	["Kuikhorne (ged.)", 69, 8],
	["Kuikhorne (ged.)", 84, 8],
	["Kuilensrode", 58, 1],
	["Kuinre", 166, 2],
	["Kuitaart", 39, 4],
	["Kuivezand", 283, 1],
	["Kulsdom", 63, 6],
	["Kunrade", 185, 5],
	["Kuttingen", 202, 5],
	["Kuzemer", 313, 7],
	["Kuzemerbalk", 313, 7],
	["Kwaalburg", 102, 1],
	["Kwadendamme", 163, 4],
	["Kwadijk", 154, 3],
	["De Kwakel", 179, 3],
	["Kwartier", 49, 1],
	["Kwintsheul", 378, 9],
	["Laag Zuthem", 93, 2],
	["Laag-Blokland", 252, 9],
	["Laag-Caestert", 298, 5],
	["Laag-Dalem", 331, 9],
	["Laag-Dalen", 143, 6],
	["Laageinde", 71, 6],
	["Laaghalen", 107, 0],
	["Laaghalerveen", 107, 0],
	["Laag-Keppel", 50, 6],
	["Laagnieuwkoop", 92, 10],
	["Laagraven", 368, 10],
	["Laag-Soeren (ged.)", 312, 6],
	["Laag-Soeren (ged.)", 337, 6],
	["Laak", 170, 5],
	["Laak", 141, 5],
	["De Laan", 346, 1],
	["Laar", 209, 1],
	["Laar", 198, 1],
	["Laar", 224, 1],
	["Laar", 5, 5],
	["Laar", 108, 5],
	["Laar", 219, 1],
	["De Laar", 105, 6],
	["Het Laar", 27, 1],
	["'t Laar", 278, 6],
	["Laarbeek", 27, 1],
	["Laarbroek", 45, 1],
	["Laareind", 43, 10],
	["Laareind", 265, 1],
	["Laareind", 13, 1],
	["Laares", 257, 2],
	["Laarstraat", 278, 6],
	["Laaxum", 288, 8],
	["Lage Berkt", 1, 1],
	["Lage Birk", 116, 10],
	["Lage Giessen", 138, 9],
	["Lage Mierde", 58, 1],
	["'t Lage van de weg", 227, 7],
	["Lage Vuursche", 168, 10],
	["Lage Zandschel", 159, 1],
	["Lage Zijde", 25, 9],
	["Lage Zwaluwe", 349, 1],
	["Lagebiezen", 229, 1],
	["Lagebroek", 187, 10],
	["Lagekant", 354, 1],
	["Lageland", 274, 7],
	["Lagenheuvel", 193, 1],
	["Lagenwaard (ged.)", 25, 9],
	["Lagenwaard (ged.)", 215, 9],
	["Lageweide", 92, 10],
	["Lakemond", 18, 6],
	["Lakerveld", 67, 9],
	["Lalleweer", 122, 7],
	["Lambertschaag", 32, 3],
	["Lammerenburg", 4, 4],
	["Lammerweg", 79, 7],
	["Lamswaarde", 39, 4],
	["Land van Kleef", 159, 1],
	["Landerd", 294, 1],
	["Landerum", 156, 8],
	["Landgraaf", 38, 5],
	["Landhorst", 249, 1],
	["Landsmeer", 394, 3],
	["Lansingerland", 223, 9],
	["Landsrade", 202, 5],
	["Langbroek", 325, 10],
	["Langdonk", 82, 1],
	["Lange Heide", 165, 5],
	["Lange Linschoten", 336, 10],
	["Lange Weide", 348, 9],
	["Lange Wijk", 69, 8],
	["Langeberg", 287, 5],
	["Langedam", 23, 4],
	["Langedijk", 304, 3],
	["De Langedijk", 317, 3],
	["Langedijke", 81, 8],
	["Langeheit", 56, 3],
	["Langel", 54, 1],
	["Langelille", 251, 8],
	["Langelo", 293, 2],
	["Langelo", 103, 0],
	["Langen", 97, 6],
	["Langenboom", 260, 1],
	["Langendijk", 51, 1],
	["Langenholte", 144, 2],
	["Langenoord", 116, 10],
	["Langeraar", 21, 9],
	["Langerak", 64, 6],
	["Langerak", 214, 10],
	["Langerak", 370, 9],
	["Langereis (ged.)", 186, 3],
	["Langereis (ged.)", 28, 3],
	["Langeveen", 87, 2],
	["Langeweegje", 163, 4],
	["Langeweg", 49, 1],
	["Langezwaag", 175, 8],
	["De Langstraat", 68, 9],
	["Langweer", 86, 8],
	["Lankes", 193, 1],
	["Lankhorst", 339, 2],
	["Lapstreek", 292, 6],
	["Laren", 97, 6],
	["Laren", 405, 3],
	["De Laren", 229, 1],
	["Laskwerd", 134, 7],
	["Lathum", 125, 6],
	["Lattrop", 78, 2],
	["Laude", 79, 7],
	["Laudermarke", 79, 7],
	["Lauderzwarteveen", 79, 7],
	["Lauradorp", 38, 5],
	["Lauwerecht", 92, 10],
	["Lauwersoog", 303, 7],
	["Lauwerzijl", 15, 7],
	["Lede", 342, 6],
	["Ledeacker", 249, 1],
	["Leegheide", 165, 5],
	["Leegkerk", 291, 7],
	["Leek", 247, 7],
	["Leemdobben", 79, 7],
	["Leemhorst", 135, 5],
	["Leende", 279, 1],
	["Leenderstrijp", 279, 1],
	["Leenhof (ged.)", 38, 5],
	["Leenhof (ged.)", 190, 5],
	["Leens", 303, 7],
	["Leensel", 45, 1],
	["Leerbroek", 67, 9],
	["Leerdam", 334, 9],
	["Leermens", 357, 7],
	["Leersum", 115, 10],
	["Leesten", 309, 6],
	["Leeuw", 5, 5],
	["Leeuwarden", 161, 8],
	["Leeuwarderadeel", 301, 8],
	["Leeuwen", 173, 5],
	["Leeuwen", 142, 5],
	["Leeuwte", 106, 0],
	["Legeduurswolde", 81, 8],
	["Legemeer", 86, 8],
	["Legert", 29, 5],
	["Leggeloo", 281, 0],
	["Legh", 102, 1],
	["Leiden", 406, 9],
	["Leiderdorp", 344, 9],
	["Leidschendam", 407, 9],
	["Leidschendam-Voorburg", 407, 9],
	["Leidschenveen", 377, 9],
	["Leijen", 339, 2],
	["Leijenbroek", 275, 5],
	["Leijenburg", 377, 9],
	["Leimuiden", 94, 9],
	["Leimuiderbrug", 10, 3],
	["Lekdijk", 115, 10],
	["Lekkerkerk", 404, 9],
	["Lekkerterp", 85, 8],
	["Lekkum", 161, 8],
	["Lellens", 60, 7],
	["Lelystad", 408, 11],
	["Lemel", 245, 1],
	["Lemele", 136, 2],
	["Lemelerveld", 127, 2],
	["Lemiers", 319, 5],
	["Lemmer", 176, 8],
	["Lemselo", 409, 2],
	["Lemsterland", 176, 8],
	["Lengel", 155, 6],
	["Lennisheuvel", 217, 1],
	["Lent", 211, 6],
	["Lenthe", 127, 2],
	["Leons", 157, 8],
	["Lepelstraat", 150, 1],
	["Lerop", 112, 5],
	["De Lethe", 207, 7],
	["Lettelbert", 247, 7],
	["Lettele", 130, 2],
	["Leudal", 141, 5],
	["Leuken", 77, 5],
	["Leuken", 108, 5],
	["Leunen", 254, 5],
	["Leur", 109, 6],
	["Leur", 147, 1],
	["Leurke", 137, 1],
	["Leusbroek", 61, 10],
	["Leusden", 61, 10],
	["Leutes", 11, 6],
	["Leuth", 195, 6],
	["Leutingewolde", 103, 0],
	["Leuvenheim", 312, 6],
	["Leuvenum", 197, 6],
	["Leveroij", 259, 5],
	["Lewedorp", 163, 4],
	["Lexmond", 67, 9],
	["De Leye", 253, 8],
	["De Leyen", 186, 3],
	["Lhee", 281, 0],
	["Lheebroek", 281, 0],
	["Libeek", 178, 5],
	["Lichtaard", 253, 8],
	["Lichtenberg", 240, 6],
	["Lichtenberg", 116, 10],
	["Lichtenvoorde", 356, 6],
	["Liemeer", 21, 9],
	["Liempde", 217, 1],
	["Lienden", 11, 6],
	["De Lier", 378, 9],
	["Lierderholthuis", 93, 2],
	["Lieren", 24, 6],
	["Lierop", 47, 1],
	["Lies", 156, 8],
	["Lies", 191, 1],
	["Lieseind", 277, 1],
	["Lieshout", 27, 1],
	["Liessel", 172, 1],
	["Liesveld", 370, 9],
	["Lievelde", 356, 6],
	["Lievendaal", 42, 1],
	["Lieveren", 103, 0],
	["Lieving", 107, 0],
	["Lijnden", 10, 3],
	["Lijnden", 18, 6],
	["Lijndonk", 191, 1],
	["Limbricht", 275, 5],
	["Limmel", 113, 5],
	["Limmen", 80, 3],
	["Linde", 251, 8],
	["Linde", 130, 2],
	["Linde", 50, 6],
	["Linde", 106, 0],
	["Linde", 311, 2],
	["Linden", 200, 1],
	["Lindenheuvel", 275, 5],
	["Lingewaal", 143, 6],
	["Lingewaard", 124, 6],
	["Lingewijk", 331, 9],
	["Lingsfort", 135, 5],
	["Linne", 170, 5],
	["Linschoten", 66, 10],
	["Lintelo", 17, 6],
	["Lintvelde", 63, 6],
	["Lioessens", 16, 8],
	["Lippenhuizen", 175, 8],
	["Lisse", 364, 9],
	["Lisserbroek", 10, 3],
	["Lith", 399, 1],
	["Lithoijen", 399, 1],
	["Littenseradiel", 157, 8],
	["De Lobben", 375, 10],
	["Lobith", 74, 6],
	["Lobrink", 278, 6],
	["Lochem", 97, 6],
	["Locht (ged.)", 190, 5],
	["Locht (ged.)", 250, 5],
	["De Locht", 171, 1],
	["Lochtenburg", 49, 1],
	["Lochuizen", 63, 6],
	["Loenen", 24, 6],
	["Loenen", 410, 10],
	["Loenen aan de Vecht", 410, 10],
	["Loenersloot", 410, 10],
	["Loënga", 393, 8],
	["Loerbeek", 155, 6],
	["Loeswijk", 206, 1],
	["Loete", 215, 9],
	["Logt", 137, 1],
	["De Logt", 308, 1],
	["Loil", 155, 6],
	["Lollum", 96, 8],
	["Lombok", 105, 6],
	["Lomm", 135, 5],
	["Longerhouw", 96, 8],
	["Lonneker", 257, 2],
	["Loo", 7, 0],
	["Loo", 130, 2],
	["Loo", 59, 6],
	["Loo", 63, 6],
	["Loo", 193, 1],
	["Loo", 165, 5],
	["Loo", 1, 1],
	["Het Loo", 24, 6],
	["'t Loo", 292, 6],
	["De Loofaert", 198, 1],
	["Looieind", 229, 1],
	["Looierheide", 8, 5],
	["Look", 232, 2],
	["'t Look", 83, 1],
	["Loon", 22, 0],
	["Loon", 13, 1],
	["Loon op Zand", 159, 1],
	["Loons Hoekje", 159, 1],
	["Loopers Kapelle", 284, 4],
	["Loosbroek", 225, 1],
	["Loosdorp", 334, 9],
	["Loosdrecht", 126, 3],
	["Loosdrechtse Bos", 324, 3],
	["Loosduinen", 377, 9],
	["Looveer", 124, 6],
	["Loozen", 62, 2],
	["Lopik", 214, 10],
	["Lopikerkapel", 214, 10],
	["Loppersum", 357, 7],
	["Losdorp", 122, 7],
	["Losser", 230, 2],
	["Lottum", 29, 5],
	["Loven", 224, 1],
	["Lovendaal", 29, 5],
	["Loveren", 164, 1],
	["Loveren", 1, 1],
	["Lubbinge", 106, 0],
	["Lucaswolde", 261, 7],
	["Ter Lucht", 316, 9],
	["Luchthaven Schiphol", 10, 3],
	["Luddeweer", 274, 7],
	["Luinjeberd", 271, 8],
	["Luissel", 217, 1],
	["Lula", 48, 7],
	["Lunen", 109, 6],
	["Lunetten", 221, 1],
	["Lunteren", 210, 6],
	["Luntershoek", 39, 4],
	["Lutjebroek", 290, 3],
	["Lutjegast", 313, 7],
	["Lutjelollum", 41, 8],
	["Lutjeloo", 207, 7],
	["Lutjewijtwerd", 357, 7],
	["Lutjewinkel", 186, 3],
	["Lutkepost", 69, 8],
	["Lutsborg", 338, 7],
	["De Lutte", 230, 2],
	["Luttelgeest", 180, 11],
	["Lutten", 62, 2],
	["Luttenberg", 93, 2],
	["Lutterade", 275, 5],
	["Lutterveld", 11, 6],
	["Luxwoude", 175, 8],
	["Luyksgestel", 1, 1],
	["Lytshuzen", 31, 8],
	["De Lytse Geast", 90, 8],
	["Maalbroek", 142, 5],
	["Maaldrift", 332, 9],
	["Maarheeze", 219, 1],
	["Maarhuizen", 72, 7],
	["Maarland", 298, 5],
	["Maarn", 115, 10],
	["Maarsbergen", 115, 10],
	["Ter Maarsch", 104, 7],
	["Maarssen", 411, 10],
	["Maarssenbroek", 411, 10],
	["Maartensdijk", 65, 10],
	["Maartensdijk", 92, 10],
	["Aan de Maas", 306, 5],
	["Maasband", 321, 5],
	["Maasbommel", 101, 6],
	["Maasbracht", 170, 5],
	["Maasbree", 165, 5],
	["Maasdam", 241, 9],
	["Maasdijk", 101, 6],
	["Maasdijk", 378, 9],
	["Maasdonk", 354, 1],
	["Maasdriel", 91, 6],
	["Maashees", 228, 1],
	["Maasgouw", 170, 5],
	["Maaskantje", 198, 1],
	["Maasland", 316, 9],
	["Maasniel", 142, 5],
	["Maassluis", 397, 9],
	["Maastricht", 113, 5],
	["Maastricht-Airport", 196, 5],
	["Maasvlakte", 286, 9],
	["Maatsehei", 193, 1],
	["Macharen", 54, 1],
	["Made", 349, 1],
	["Magele", 311, 2],
	["Magrette", 153, 4],
	["Majella", 92, 10],
	["Makkinga", 81, 8],
	["Makkum", 157, 8],
	["Makkum", 96, 8],
	["Makkum", 107, 0],
	["Malburgen", 105, 6],
	["Malden", 385, 6],
	["Maliskamp", 263, 1],
	["Mallem", 63, 6],
	["Mamelis", 319, 5],
	["Mander", 87, 2],
	["Manderveen", 87, 2],
	["Manen", 210, 6],
	["Mantgum", 157, 8],
	["Mantinge", 107, 0],
	["Maranatha (Zustercomplex)", 264, 1],
	["Maren", 399, 1],
	["De Marne", 303, 7],
	["Maren-Kessel", 399, 1],
	["Margraten", 178, 5],
	["Maria Gewanden", 190, 5],
	["Maria Parochie", 87, 2],
	["Mariadorp", 298, 5],
	["Mariaheide", 229, 1],
	["Mariahoeve", 377, 9],
	["Mariahoop", 30, 5],
	["Mariahout", 27, 1],
	["Mariarade", 190, 5],
	["Mariënberg", 62, 2],
	["Mariëndaal", 105, 6],
	["Mariëndijk", 378, 9],
	["Mariënheem", 93, 2],
	["Mariënvelde", 356, 6],
	["Mariënwaard", 113, 5],
	["Marijenkampen", 166, 2],
	["Markelerbroek", 111, 2],
	["Markelo", 111, 2],
	["Marken", 302, 3],
	["Markenbinnen", 376, 3],
	["Markluiden", 222, 6],
	["Marknesse", 180, 11],
	["Markvelde", 111, 2],
	["Marle", 330, 2],
	["Marle", 262, 2],
	["Marrum", 253, 8],
	["De Mars", 11, 6],
	["Marsdijk", 11, 6],
	["Marssum", 203, 8],
	["Marsum", 134, 7],
	["Martenshoek", 48, 7],
	["Marum", 261, 7],
	["Marwijksoord", 0, 0],
	["Mastenbroek (ged.)", 243, 2],
	["Mastenbroek (ged.)", 167, 2],
	["Mastwijk", 66, 10],
	["Maten", 79, 7],
	["Mathijseind", 171, 1],
	["Matsloot", 103, 0],
	["Maurik", 11, 6],
	["Maxet", 141, 5],
	["Mechelen", 202, 5],
	["Meddo", 300, 6],
	["Medemblik", 32, 3],
	["Meeden", 212, 7],
	["Meedhuizen", 122, 7],
	["De Meele", 127, 2],
	["Meemortel", 219, 1],
	["De Meene", 50, 6],
	["De Meente", 251, 8],
	["Meer", 311, 2],
	["Meerdijk", 162, 1],
	["Meeren", 260, 1],
	["Meerestein", 233, 3],
	["Meerkerk", 67, 9],
	["Meerland", 201, 7],
	["Meerlo", 29, 5],
	["De Meern", 92, 10],
	["Meers", 321, 5],
	["Meerssen", 306, 5],
	["Meertenpolder", 11, 6],
	["Meerveldhoven", 83, 1],
	["Meerven", 264, 1],
	["Meerwijck", 48, 7],
	["Meerwijk", 263, 1],
	["Meeuwen", 6, 1],
	["Meeuwenplaat", 286, 9],
	["Meezenbroek", 190, 5],
	["Megchelen", 240, 6],
	["Megelsum", 29, 5],
	["Megen", 54, 1],
	["Meierkamp", 295, 3],
	["Meije (ged.)", 258, 9],
	["Meije (ged.)", 187, 10],
	["Meijel", 165, 5],
	["Meijldoorn", 277, 1],
	["Meinerswijk", 105, 6],
	["Mekkelholt", 257, 2],
	["Mekkelhorst", 230, 2],
	["Melderslo", 29, 5],
	["Melick", 112, 5],
	["Meliskerke", 4, 4],
	["Melissant", 341, 9],
	["Melle", 193, 1],
	["Melleschet", 319, 5],
	["Mellinkmaat", 356, 6],
	["Menaldum", 203, 8],
	["Mengelenberg", 155, 6],
	["Mennonietenbuurt", 44, 10],
	["Mensingeweer", 303, 7],
	["Menterwolde", 212, 7],
	["Menzel", 225, 1],
	["Meppel", 307, 0],
	["Meppen", 7, 0],
	["Merkelbeek", 239, 5],
	["Merm", 18, 6],
	["Merselo", 254, 5],
	["Mertel", 224, 1],
	["Merum", 357, 7],
	["Merum", 142, 5],
	["Mesch", 298, 5],
	["Meteren", 71, 6],
	["Meterik", 29, 5],
	["Metslawier", 16, 8],
	["Meulunteren-De Valk", 210, 6],
	["Mheer", 178, 5],
	["Midbuul", 219, 1],
	["Middel", 56, 3],
	["Middel", 262, 2],
	["Middelaar", 244, 5],
	["Middelbeers", 285, 1],
	["Middelbert", 291, 7],
	["Middelburg", 348, 9],
	["Middelburg", 139, 4],
	["Middeldijk", 181, 9],
	["Middelharnis", 189, 9],
	["Middelie", 154, 3],
	["Middelijk", 29, 5],
	["Middelkoop", 67, 9],
	["Middelrode", 198, 1],
	["Middelsluis", 328, 9],
	["Middelstum", 357, 7],
	["Middenbeemster", 199, 3],
	["Midden-Delfland", 316, 9],
	["Midden-Drenthe", 107, 0],
	["Middenmeer", 403, 3],
	["Middentocht", 396, 3],
	["Middenveld", 107, 0],
	["Midlaren", 213, 0],
	["Midlum", 98, 8],
	["Midsland", 156, 8],
	["Midwolda", 201, 7],
	["Midwolde", 247, 7],
	["Midwoud", 32, 3],
	["Midzomer", 281, 0],
	["Miedum", 41, 8],
	["Miedum", 161, 8],
	["Mierlo", 206, 1],
	["Mierlo-Hout", 205, 1],
	["Mijdrecht", 44, 10],
	["Mijnden", 410, 10],
	["Mijnsheerenland", 241, 9],
	["Mijzenpolder", 350, 3],
	["Mijzerkoog", 151, 3],
	["Mijzijde", 187, 10],
	["Mildam", 271, 8],
	["Mildert", 259, 5],
	["Milheeze", 171, 1],
	["Mill", 260, 1],
	["Mill en Sint Hubert", 260, 1],
	["Millen", 30, 5],
	["Millengen", 127, 2],
	["Millingen aan de Rijn", 412, 6],
	["Milsbeek", 8, 5],
	["Milschot", 171, 1],
	["Milt", 240, 6],
	["Mingersberg", 185, 5],
	["Minkeloos", 138, 9],
	["Minkmaat", 257, 2],
	["Minnertsga", 238, 8],
	["Mirns", 174, 8],
	["Miste", 300, 6],
	["Moddergat", 16, 8],
	["De Moer", 159, 1],
	["Het Moer", 281, 0],
	["Moerbeek", 186, 3],
	["Moerdijk", 49, 1],
	["De Moeren", 70, 1],
	["Moergestel", 308, 1],
	["Moerhuizen", 359, 9],
	["Moerkapelle", 359, 9],
	["Moerkerken", 241, 9],
	["Moerslag", 178, 5],
	["Moerstraten", 82, 1],
	["Moesdijk", 108, 5],
	["Moesel", 108, 5],
	["Moespot-Leeuwte", 166, 2],
	["Molecaten", 292, 6],
	["'s-Molenaarsbuurt", 25, 9],
	["Molenaarsgraaf", 252, 9],
	["Molenbaan", 165, 5],
	["Molenbeek", 105, 6],
	["Molenberg", 190, 5],
	["Moleneind", 101, 6],
	["Moleneind", 191, 1],
	["Moleneind", 159, 1],
	["Moleneind", 285, 1],
	["Moleneind", 126, 3],
	["Molengat", 260, 1],
	["Molenheide", 260, 1],
	["Molenhoek", 76, 6],
	["Molenhoek", 39, 4],
	["Molenhoek", 263, 1],
	["Molenhoek (ged.)", 385, 6],
	["Molenhoek (ged.)", 244, 5],
	["Molenpolder", 12, 6],
	["Molenrij", 303, 7],
	["Molenschot", 265, 1],
	["Molenstraat", 209, 1],
	["Molenstraat", 159, 1],
	["Molenveld", 264, 1],
	["Molenvliet", 128, 4],
	["Molenwijk", 137, 1],
	["Molenwijk", 378, 9],
	["Molkwerum", 288, 8],
	["Molsberg", 158, 5],
	["Monnickendam", 302, 3],
	["Monnikenhuizen", 105, 6],
	["Monster", 378, 9],
	["Montferland", 155, 6],
	["Montfoort", 66, 10],
	["Montfort", 112, 5],
	["Mook", 244, 5],
	["Mook en Middelaar", 244, 5],
	["Mookhoek", 322, 9],
	["Moordhuizen", 101, 6],
	["Moordrecht", 359, 9],
	["Moorst", 360, 10],
	["Moorveld", 306, 5],
	["Moosdijk", 172, 1],
	["Morige", 207, 7],
	["Morra", 16, 8],
	["Morsche Hoef", 229, 1],
	["Mortel", 171, 1],
	["Mortel", 141, 5],
	["Moscou", 53, 0],
	["Mossel", 210, 6],
	["Mossel", 50, 6],
	["Mostheuvel", 264, 1],
	["Muggenbeet", 166, 2],
	["Muggenhol", 83, 1],
	["Muggenhool", 1, 1],
	["Muiden", 413, 3],
	["Muiderberg", 413, 3],
	["Muijeveld", 126, 3],
	["Muisbroek", 138, 9],
	["Mullegen", 292, 6],
	["Mun", 294, 1],
	["Mûnein", 90, 8],
	["Munnekeburen", 251, 8],
	["Munnekemoer", 79, 7],
	["Munnekezijl", 148, 8],
	["Munnikenheide", 51, 1],
	["Munnikenland", 241, 9],
	["Munsel", 217, 1],
	["Munstergeleen", 275, 5],
	["Muntel", 263, 1],
	["Muntendam", 212, 7],
	["Murmerwoude", 84, 8],
	["Musschemig", 190, 5],
	["Mussel", 104, 7],
	["Musselkanaal", 104, 7],
	["De Naald", 233, 3],
	["Naaldwijk", 378, 9],
	["Naarden", 414, 3],
	["Naardermeer", 413, 3],
	["Naastenbest", 26, 1],
	["Nabbegat", 294, 1],
	["Nabben", 135, 5],
	["Nachtegaal", 29, 5],
	["Nagelbeek", 119, 5],
	["Nagele", 180, 11],
	["Nansum", 122, 7],
	["Napels", 201, 7],
	["Nattenhoven", 321, 5],
	["Nauerna", 56, 3],
	["Nazareth", 113, 5],
	["Neck (ged.)", 415, 3],
	["Neck (ged.)", 396, 3],
	["Nederasselt", 385, 6],
	["Neder-Betuwe", 342, 6],
	["Neder-Hardinxveld", 289, 9],
	["Nederheide", 57, 1],
	["Nederheide", 171, 1],
	["Nederhemert", 12, 6],
	["Nederhorst Den Berg", 126, 3],
	["Nederland", 166, 2],
	["Nederlangbroek", 325, 10],
	["Nederlek", 404, 9],
	["Nederweert", 259, 5],
	["Nederweerterdijk", 165, 5],
	["Nederwoud", 210, 6],
	["Neede", 63, 6],
	["Neer", 141, 5],
	["Neerbeek", 196, 5],
	["Neerbosch", 211, 6],
	["Neerbroek", 137, 1],
	["Neerdorp", 232, 2],
	["Neerijnen", 327, 6],
	["Neeritter", 141, 5],
	["Neerkant", 172, 1],
	["Neerloon", 54, 1],
	["Neersteind", 76, 6],
	["Neerstraat", 171, 1],
	["Negenhuizen", 316, 9],
	["Nergena", 210, 6],
	["Nerhoven", 265, 1],
	["Nes", 85, 8],
	["Nes", 16, 8],
	["Nes", 114, 8],
	["Nes", 118, 3],
	["De Nes", 317, 3],
	["Nessersluis (ged.)", 118, 3],
	["Nessersluis (ged.)", 44, 10],
	["Netersel", 245, 1],
	["Nettelhorst", 97, 6],
	["Netterden", 240, 6],
	["Niawier", 16, 8],
	["Nibbixwoud", 32, 3],
	["Niebert", 261, 7],
	["Niedorp", 186, 3],
	["Niehove", 15, 7],
	["Niekerk", 313, 7],
	["Niekerk", 303, 7],
	["Niemeskant", 193, 1],
	["Nierhoven", 5, 5],
	["Niersen", 278, 6],
	["Niesoord", 201, 7],
	["Nietap", 103, 0],
	["Nieuw Amerika", 174, 8],
	["Nieuw Gastel", 283, 1],
	["Nieuwaal", 12, 6],
	["Nieuw-Amsterdam", 121, 0],
	["Nieuw-Annerveen", 0, 0],
	["Nieuw-Balinge", 107, 0],
	["Nieuw-Beerta", 201, 7],
	["Nieuw-Beijerland", 374, 9],
	["Nieuw-Bergen", 77, 5],
	["Nieuwborg", 135, 5],
	["Nieuw-Borgvliet", 150, 1],
	["Nieuw-Buinen", 273, 0],
	["Nieuw-Dijk", 155, 6],
	["Nieuw-Dordrecht", 121, 0],
	["Nieuwdorp", 163, 4],
	["Nieuwdorp", 321, 5],
	["Nieuwdorp (Bontebrug)", 240, 6],
	["Nieuw-Duinkerken", 56, 3],
	["Nieuwe Abeele", 379, 4],
	["Nieuwe Bildtdijk", 238, 8],
	["Nieuwe Bildtzijl", 238, 8],
	["Nieuwe Brug", 271, 8],
	["Nieuwe Brug", 10, 3],
	["Nieuwe Compagnie", 48, 7],
	["Nieuwe Heide", 239, 5],
	["Nieuwe Koedood", 181, 9],
	["Nieuwe Krim", 7, 0],
	["Nieuwe Meer", 10, 3],
	["Nieuwe Molen", 153, 4],
	["Nieuwe Molen", 150, 1],
	["Nieuwe Pekela", 310, 7],
	["Nieuwe Schans", 101, 6],
	["Nieuwe Statenzijl", 201, 7],
	["Nieuwe Tuinen", 378, 9],
	["Nieuwe Wetering", 94, 9],
	["Nieuwe Zijlen", 16, 8],
	["Nieuwebrug", 86, 8],
	["Nieuwebrug", 136, 2],
	["Nieuwediep", 0, 0],
	["Nieuwegein", 368, 10],
	["Nieuwehorne", 271, 8],
	["Nieuwemolen", 49, 1],
	["Nieuwendam", 120, 3],
	["Nieuwendijk", 374, 9],
	["Nieuwendijk", 160, 1],
	["Nieuwenhagen", 38, 5],
	["Nieuwenhoorn", 387, 9],
	["Nieuwenhuishoek", 63, 6],
	["Nieuwe-Niedorp", 186, 3],
	["Nieuwer Amstel", 118, 3],
	["Nieuwerbrug", 258, 9],
	["Nieuwerhoek", 410, 10],
	["Nieuwerkerk", 284, 4],
	["Nieuwerkerk aan den IJssel", 359, 9],
	["Nieuweroord", 53, 0],
	["Nieuwersluis", 410, 10],
	["Nieuwer-Ter-Aa", 297, 10],
	["Nieuweschans", 201, 7],
	["Het Nieuweschild", 183, 3],
	["Nieuweschoot", 271, 8],
	["Nieuwesluis", 129, 3],
	["Nieuwe-Tonge", 189, 9],
	["Nieuwe-Vaart", 162, 1],
	["Nieuwe-Wetering", 65, 10],
	["Nieuw-Gassel", 200, 1],
	["Nieuwgraaf", 59, 6],
	["Nieuw-Haamstede", 284, 4],
	["Nieuw-Heeten", 93, 2],
	["Nieuw-Helvoet", 387, 9],
	["Nieuwkerk", 37, 1],
	["Nieuwkoop", 21, 9],
	["Nieuwkuijk", 345, 1],
	["Nieuwland", 116, 10],
	["Nieuwland", 139, 4],
	["Nieuwland", 67, 9],
	["Nieuwlande", 7, 0],
	["Nieuwlande", 53, 0],
	["Nieuw-Lekkerland", 400, 9],
	["Nieuwleusen", 127, 2],
	["Nieuw-Loosdrecht", 126, 3],
	["Nieuw-Lotbroek", 190, 5],
	["Nieuw-Maarsseveen", 411, 10],
	["Nieuw-Millingen", 24, 6],
	["Nieuw-Namen", 39, 4],
	["Nieuwolda", 201, 7],
	["Nieuwpoort", 370, 9],
	["Nieuw-Reemst", 210, 6],
	["Nieuw-Roden", 103, 0],
	["Nieuw-Scheemda", 201, 7],
	["Nieuw-Schoonebeek", 121, 0],
	["Nieuwstad", 122, 7],
	["Nieuwstad", 243, 2],
	["Nieuwstad", 131, 6],
	["Nieuwstadt", 30, 5],
	["Nieuwveen", 21, 9],
	["Nieuw-Vennep", 10, 3],
	["Nieuwvliet", 23, 4],
	["Nieuw-Vossemeer", 248, 1],
	["Nieuw-Weerdinge", 121, 0],
	["Nieuw-Wehl", 64, 6],
	["Nieuw-Zuilen", 92, 10],
	["Nieuw-Zwinderen", 7, 0],
	["Niezijl", 15, 7],
	["Niftrik", 109, 6],
	["Nigtevecht", 410, 10],
	["Nij Altoenae", 238, 8],
	["Nij Beets", 175, 8],
	["Nijbroek", 133, 6],
	["Nijbuorren", 288, 8],
	["Nijeberkoop", 81, 8],
	["Nijega", 272, 8],
	["Nijega", 288, 8],
	["Nijehaske", 86, 8],
	["Nijeholtpade", 251, 8],
	["Nijeholtwolde", 251, 8],
	["Nijelamer", 251, 8],
	["Nijemirdum", 174, 8],
	["Nijenbeker", 133, 6],
	["Nijenrode", 297, 10],
	["Nijensleek", 281, 0],
	["Nijentap", 281, 0],
	["Nijetrijne", 251, 8],
	["Nijeveen", 307, 0],
	["Nijeveense Bovenboer", 307, 0],
	["Nijezijl", 31, 8],
	["Nijhoven", 164, 1],
	["Nijhuizum", 288, 8],
	["Nijken-Strubben-Hoogschans", 141, 5],
	["Nijkerk", 132, 6],
	["Nijkerkerveen", 132, 6],
	["Nijland", 31, 8],
	["Nijlande", 0, 0],
	["Nijmegen", 211, 6],
	["Nijnsel", 280, 1],
	["Nijstad", 53, 0],
	["Nijstad", 78, 2],
	["Nijswiller", 202, 5],
	["Nijverdal", 330, 2],
	["Nimmerdor", 116, 10],
	["Nispen", 82, 1],
	["Nisse", 163, 4],
	["Nistelrode", 225, 1],
	["Noardburgum", 90, 8],
	["Noetsele", 330, 2],
	["Nolde", 106, 0],
	["Nollen", 95, 3],
	["Nooitgedacht", 0, 0],
	["Noorbeek", 178, 5],
	["De Noord", 305, 3],
	["Noord-Bakkum", 80, 3],
	["Noordbarge", 121, 0],
	["Noordbeemster", 199, 3],
	["Noord-Beveland", 323, 4],
	["Noordbroek", 212, 7],
	["Noorddijk", 291, 7],
	["Noorddijk", 151, 3],
	["Noordeinde", 292, 6],
	["Noordeinde", 376, 3],
	["Noordeinde", 25, 9],
	["Noordeinde", 223, 9],
	["Noordeinde", 21, 9],
	["Noordeloos", 138, 9],
	["Noorden", 21, 9],
	["Noord-End", 80, 3],
	["Noordenveld", 103, 0],
	["Noorder Kolonie", 310, 7],
	["Noorderburen", 15, 7],
	["Noorderhoogebrug", 194, 7],
	["Noorderhoogebrug", 291, 7],
	["Noorder-Koggenland", 32, 3],
	["Noorderlegmeerpolder (ged.)", 118, 3],
	["Noorderlegmeerpolder (ged.)", 179, 3],
	["Noordermeer", 32, 3],
	["Noordgeest", 150, 1],
	["Noordgouwe", 284, 4],
	["Noordhoek", 49, 1],
	["Noordhorn", 15, 7],
	["Noordijk", 63, 6],
	["Noordink", 50, 6],
	["Noordkant", 249, 1],
	["Noord-Kethel", 236, 9],
	["Noordlaren", 338, 7],
	["Noord-Meer", 311, 2],
	["Noordoostpolder", 180, 11],
	["Noordpolderzijl", 227, 7],
	["Noordschans", 49, 1],
	["Noord-Scharwoude", 304, 3],
	["Noordsche Bosch", 56, 3],
	["Noordscheschut", 53, 0],
	["Noordse Dorp", 21, 9],
	["Noordsebuurt", 21, 9],
	["Noord-Sleen", 7, 0],
	["Noordstraat", 39, 4],
	["Noordveen", 121, 0],
	["Noordwelle", 284, 4],
	["Noordwijk", 261, 7],
	["Noordwijk", 401, 9],
	["Noordwijk", 106, 0],
	["Noordwijk aan Zee", 401, 9],
	["Noordwijk-Binnen", 401, 9],
	["Noordwijkerhout", 380, 9],
	["Noordwolde", 194, 7],
	["Noordwolde", 251, 8],
	["Noordzijde", 258, 9],
	["Nootdorp", 333, 9],
	["Norden", 237, 6],
	["Norg", 103, 0],
	["Norgervaart", 103, 0],
	["Notel", 285, 1],
	["Notendaal", 248, 1],
	["Notsel", 102, 1],
	["Notter", 366, 2],
	["Noukoop", 333, 9],
	["Nude", 363, 6],
	["Nuijeneind", 171, 1],
	["Nuinhof", 5, 5],
	["Nuis", 261, 7],
	["Den Nul", 262, 2],
	["Nuland", 354, 1],
	["Nuld", 237, 6],
	["Nulland", 250, 5],
	["Numansdorp", 328, 9],
	["Numero Dertien", 182, 7],
	["Nummer Eén", 23, 4],
	["Nunhem", 141, 5],
	["Nunspeet", 361, 6],
	["Nuth", 5, 5],
	["Nutter", 78, 2],
	["Obbicht", 275, 5],
	["Obdam", 151, 3],
	["Obergum", 72, 7],
	["Ochten", 342, 6],
	["Odijk", 315, 10],
	["Odiliapeel", 193, 1],
	["Odoorn", 273, 0],
	["Odoornerveen", 273, 0],
	["Oeffelt", 228, 1],
	["Oegstgeest", 389, 9],
	["Oekel", 70, 1],
	["Oeken", 312, 6],
	["Oele", 192, 2],
	["Oene", 278, 6],
	["Oensel (ged.)", 196, 5],
	["Oensel (ged.)", 5, 5],
	["Oentsjerk", 90, 8],
	["Oerle", 224, 1],
	["Oerle", 83, 1],
	["Oetelaar", 277, 1],
	["Den Oever", 208, 3],
	["Oevereind", 30, 5],
	["Offem", 401, 9],
	["Offenbeek", 173, 5],
	["Offerkamp", 142, 5],
	["Offingawier", 393, 8],
	["Ofwegen", 94, 9],
	["Ohé", 170, 5],
	["Ohé en Laak", 170, 5],
	["Oijen", 399, 1],
	["Oirlo", 254, 5],
	["Oirsbeek", 119, 5],
	["Oirschot", 285, 1],
	["Oisterwijk", 308, 1],
	["Okkenbroek", 130, 2],
	["Olburgen", 50, 6],
	["Oldambt", 201, 7],
	["Old Eibergen", 63, 6],
	["Oldeberkoop", 81, 8],
	["Oldebroek", 292, 6],
	["Oldeholtpade", 251, 8],
	["Oldeholtwolde", 251, 8],
	["Oldehove", 15, 7],
	["Oldekerk", 313, 7],
	["Oldelamer", 251, 8],
	["Oldemarkt", 166, 2],
	["Oldendiever", 281, 0],
	["Oldeneel", 144, 2],
	["Oldengaarde", 281, 0],
	["Oldenhave", 106, 0],
	["Oldenzaal", 409, 2],
	["Oldenzijl", 227, 7],
	["Oldeouwer", 86, 8],
	["Oldetrijne", 251, 8],
	["Oldorp", 227, 7],
	["Olen", 19, 1],
	["Oler", 141, 5],
	["Olgerbuurt", 291, 7],
	["Oliemolenes", 257, 2],
	["Oling", 134, 7],
	["Olland", 280, 1],
	["Olst", 262, 2],
	["Olst-Wijhe", 262, 2],
	["Olterterp", 175, 8],
	["Ommel", 45, 1],
	["Ommelanderwijk", 182, 7],
	["Ommen", 136, 2],
	["Ommeren", 11, 6],
	["Ommerschans", 136, 2],
	["Omval", 95, 3],
	["Onderdendam", 194, 7],
	["Onderdijk", 351, 3],
	["Onder-Eindt", 165, 5],
	["Onderwierum", 194, 7],
	["Ondiep", 92, 10],
	["Onna", 166, 2],
	["Onnen", 338, 7],
	["Ons Belang", 117, 10],
	["Onstwedde", 104, 7],
	["Oog in Al", 92, 10],
	["Ooij", 195, 6],
	["Ooij", 125, 6],
	["Ooij", 342, 6],
	["Ooijen", 29, 5],
	["Ool", 142, 5],
	["Oolde", 97, 6],
	["Ooltgensplaat", 68, 9],
	["Oomsberg", 104, 7],
	["Den Oord", 375, 10],
	["Oordeel", 164, 1],
	["Oosseld", 64, 6],
	["Oost", 298, 5],
	["Oostbeemster", 199, 3],
	["Oostbroek", 65, 10],
	["Oostburg", 23, 4],
	["Oostbuurt", 378, 9],
	["Oostdijk", 372, 9],
	["Oostdijk", 387, 9],
	["Oostdijk", 188, 4],
	["Oostdorp", 3, 3],
	["Oostdorp", 332, 9],
	["Oosteind", 416, 9],
	["Oosteind", 14, 1],
	["Oosteind", 51, 1],
	["Oosteinde", 9, 3],
	["Oosteinde", 140, 9],
	["Oosteinde", 227, 7],
	["Oosteinde", 106, 0],
	["Oosteinderpoelpolder", 118, 3],
	["Oost Gelre", 356, 6],
	["Oostelbeers", 285, 1],
	["Oostendam", 268, 9],
	["Oostendorp", 131, 6],
	["Oostenrijk", 29, 5],
	["Oosterbeek", 318, 6],
	["Oosterbierum", 41, 8],
	["Oosterblokker", 242, 3],
	["Oosterboer", 307, 0],
	["Oosterboorn", 85, 8],
	["Oosterbroek", 213, 0],
	["Oosterbuurt", 80, 3],
	["Ooster-Dalfsen", 127, 2],
	["Oosterdijk", 365, 3],
	["Oostereinde", 201, 7],
	["Oosterend", 156, 8],
	["Oosterend", 183, 3],
	["Oosterens", 193, 1],
	["Oostererf", 56, 3],
	["Oosterhaar", 338, 7],
	["Oosterhei", 168, 10],
	["Oosterheide", 14, 1],
	["Oosterhesselen", 7, 0],
	["Oosterholt", 243, 2],
	["Oosterhoogebrug", 291, 7],
	["Oosterhout", 211, 6],
	["Oosterhout", 14, 1],
	["Oosterhout", 18, 6],
	["Oosterhuis", 62, 2],
	["Oosterhuizen", 24, 6],
	["Oosterik", 279, 1],
	["Oostering", 106, 0],
	["Oosterklief", 208, 3],
	["Oosterland", 208, 3],
	["Oosterland", 284, 4],
	["Oosterleek", 242, 3],
	["Oosternieland", 227, 7],
	["Oosterstreek", 251, 8],
	["Oostertuinen", 233, 3],
	["Oostervalge", 227, 7],
	["Oosterwijk", 50, 6],
	["Oosterwijk", 334, 9],
	["Oosterwijk", 102, 1],
	["Oosterwijk-Zuidbroek", 146, 3],
	["Oosterwijtwerd", 357, 7],
	["Oosterwijzend", 32, 3],
	["Oosterwolde", 81, 8],
	["Oosterwolde", 292, 6],
	["Oosterzand", 313, 7],
	["Oosterzee", 176, 8],
	["Oostflakkee", 68, 9],
	["Oost-Friesland", 155, 6],
	["Oost-Graftdijk", 376, 3],
	["Oosthem", 31, 8],
	["Oosthem", 96, 8],
	["Oosthoek", 374, 9],
	["Oosthuizen", 154, 3],
	["Oostkapelle", 4, 4],
	["Oost-Knollendam", 396, 3],
	["Oostlaar", 82, 1],
	["Oost-Maarland", 298, 5],
	["Oostmahorn", 16, 8],
	["Oostmijzen", 151, 3],
	["Oostpolder", 255, 9],
	["Oostrum", 16, 8],
	["Oostrum", 254, 5],
	["Oost-Souburg", 379, 4],
	["Ooststellingwerf", 81, 8],
	["Oostum", 72, 7],
	["Oostveld", 201, 7],
	["Oost-Vlieland", 417, 8],
	["Oostvoorne", 386, 9],
	["Oostwold", 247, 7],
	["Oostwold", 201, 7],
	["Oostwolder Hamrik", 201, 7],
	["Oostwolder Polder", 201, 7],
	["Oostwold-Slochteren", 274, 7],
	["Oostwoud", 32, 3],
	["Oostzaan", 381, 3],
	["Oostzijderveld", 56, 3],
	["Oost-Zwaagdijk", 351, 3],
	["Ootmarsum", 78, 2],
	["Ooyerhoek", 309, 6],
	["Opeinde", 272, 8],
	["Opende", 313, 7],
	["Ophemert", 327, 6],
	["Opheusden", 342, 6],
	["Ophoven", 141, 5],
	["Ophoven", 30, 5],
	["Ophoven", 275, 5],
	["Ophuis", 69, 8],
	["Opijnen", 327, 6],
	["Oploo", 249, 1],
	["Opmeer", 28, 3],
	["Oppenhuizen", 31, 8],
	["Opperburen", 272, 8],
	["Opperdoes", 32, 3],
	["Opperduit", 404, 9],
	["Opsterland", 175, 8],
	["Opwierde", 134, 7],
	["Oranje", 107, 0],
	["Oranjedorp", 121, 0],
	["Oranjeoord", 49, 1],
	["Oranjepolder", 378, 9],
	["Oranjewijk", 243, 2],
	["Oranjewoud", 271, 8],
	["Orden", 24, 6],
	["Orthen", 263, 1],
	["Orvelte", 107, 0],
	["Osdorp", 120, 3],
	["Osen", 170, 5],
	["Oshaar", 106, 0],
	["Osingahuizen", 31, 8],
	["Ospel", 259, 5],
	["Ospeldijk", 259, 5],
	["Oss", 54, 1],
	["Osse", 284, 4],
	["Ossenbroek", 200, 1],
	["Ossendrecht", 20, 1],
	["Ossenisse", 39, 4],
	["Ossenwaard", 74, 6],
	["Ossenwaard", 266, 10],
	["Ossenzijl", 166, 2],
	["Ostaaijen", 70, 1],
	["Osterbos", 29, 5],
	["Oterdum", 122, 7],
	["Oterdumerwarven", 122, 7],
	["Oterleek", 350, 3],
	["Othene", 153, 4],
	["Otterlo", 210, 6],
	["Ottersum", 8, 5],
	["Otterweg", 176, 8],
	["Ottoland", 252, 9],
	["Otweg", 25, 9],
	["Oud Gastel", 283, 1],
	["Oud Verlaat", 359, 9],
	["Oud Zevenaar", 125, 6],
	["Oud-Aa", 297, 10],
	["Oud-Ade", 94, 9],
	["Oud-Alblas", 252, 9],
	["Oud-Annerveen", 0, 0],
	["Oud-Appelscha", 81, 8],
	["Oud-Avereest", 62, 2],
	["Oud-Beijerland", 418, 9],
	["Oud-Bodegraven", 258, 9],
	["Oud-Caberg", 113, 5],
	["Oud-Diemen", 335, 3],
	["Oud-Dijk", 155, 6],
	["Ouddorp", 372, 9],
	["Oud-Drimmelen", 349, 1],
	["Oude Bildtdijk", 238, 8],
	["Oude Bildtzijl", 238, 8],
	["Oude IJsselstreek", 240, 6],
	["Oude Koedood", 89, 9],
	["Oude Land", 183, 3],
	["Oude Leede", 333, 9],
	["Oude Leije", 301, 8],
	["Oude Maasdijk", 101, 6],
	["Oude Meer", 10, 3],
	["Oude Molen", 130, 2],
	["Oude Molen", 268, 9],
	["Oude Molen", 150, 1],
	["Oude Pekela", 310, 7],
	["Oude Roodehaan", 291, 7],
	["Oude Wetering", 94, 9],
	["Oude Willem", 281, 0],
	["Oudedijk", 201, 7],
	["Oudedijk", 303, 7],
	["Oudega", 272, 8],
	["Oudega", 174, 8],
	["Oudega", 31, 8],
	["Oudehaske", 86, 8],
	["Oudehorne", 271, 8],
	["Oudelande", 163, 4],
	["Oudelandsdijk", 396, 3],
	["Oudelandsdijk", 378, 9],
	["Oudemirdum", 174, 8],
	["Oudemolen", 49, 1],
	["Oudemolen", 213, 0],
	["Oud-Empel", 263, 1],
	["Oudenbosch", 283, 1],
	["Oudendijk", 151, 3],
	["Oudendijk", 374, 9],
	["Oudendijk", 322, 9],
	["Oudendijk", 100, 1],
	["Oudendijkse Polder", 94, 9],
	["Oudenhoorn", 34, 9],
	["Oude-Niedorp", 186, 3],
	["Oudenmolen", 279, 1],
	["Oudenrijn", 92, 10],
	["Ouder-Amstel", 314, 3],
	["Ouderkerk", 314, 3],
	["Ouderkerk", 373, 9],
	["Ouderkerk aan de Amstel", 314, 3],
	["Ouderkerk aan den IJssel", 373, 9],
	["Oudeschans", 207, 7],
	["Oudeschild", 183, 3],
	["Oudeschip", 227, 7],
	["Oudeschoot", 271, 8],
	["Oudesluis", 35, 3],
	["Oudesluis", 328, 9],
	["Oude-Tonge", 68, 9],
	["Oudewaard", 342, 6],
	["Oudewater", 336, 10],
	["Oudeweg", 115, 10],
	["Oudeweg", 348, 9],
	["Oudezijl", 201, 7],
	["Oudheusden", 345, 1],
	["Oudijk", 242, 3],
	["Oud-Kamerik", 187, 10],
	["Oudkarspel", 304, 3],
	["Oud-Kethel", 236, 9],
	["Oud-Kortenhoef", 126, 3],
	["Oudland", 283, 1],
	["Oud-Leusden", 61, 10],
	["Oudleusen", 127, 2],
	["Oud-Loosdrecht", 126, 3],
	["Oud-Maarsseveen", 411, 10],
	["Oud-Ootmarsum", 78, 2],
	["Oudorp", 95, 3],
	["Oud-Over", 410, 10],
	["Oud-Reemst", 210, 6],
	["Oud-Reeuwijk", 348, 9],
	["Oud-Roosteren", 30, 5],
	["Oud-Sabbinge", 33, 4],
	["Oud-Schoterland", 86, 8],
	["Oudshoorn", 25, 9],
	["Oud-Valkenburg", 218, 5],
	["Oudveld", 229, 1],
	["Oud-Vossemeer", 128, 4],
	["Oud-Wulven", 375, 10],
	["Oud-Zuilen", 411, 10],
	["Oukoop", 297, 10],
	["Ouwe Gouwe", 255, 9],
	["Ouwerkerk", 284, 4],
	["Ouwsterhaule", 86, 8],
	["Ouwster-Nijega", 86, 8],
	["Oventje", 294, 1],
	["Overakker", 191, 1],
	["Overakker", 206, 1],
	["Overasselt", 385, 6],
	["Overberg", 115, 10],
	["Overberg", 20, 1],
	["Overbetuwe", 18, 6],
	["Overboeicop", 334, 9],
	["Overbroek", 190, 5],
	["Overbroek", 254, 5],
	["Overburen", 251, 8],
	["Over-Diemen", 335, 3],
	["Overdinkel", 230, 2],
	["Overeys", 202, 5],
	["Overhaelen", 141, 5],
	["Overheek", 185, 5],
	["Overheicop", 334, 9],
	["Overhoven", 275, 5],
	["Overlangbroek", 325, 10],
	["Overlangel", 54, 1],
	["Overloon", 228, 1],
	["Overmaat", 105, 6],
	["Overmeer", 126, 3],
	["Over-Ouderkerk", 118, 3],
	["Overschie", 286, 9],
	["Overschild", 274, 7],
	["Overschot", 171, 1],
	["Overslag", 153, 4],
	["Overslingeland", 138, 9],
	["Overveen", 73, 3],
	["Overwhere", 415, 3],
	["Ovezande", 163, 4],
	["Oxe", 130, 2],
	["Paal", 39, 4],
	["Paal", 23, 4],
	["Paarlo", 112, 5],
	["Paasberg", 105, 6],
	["Paasloo", 166, 2],
	["De Paauw", 332, 9],
	["De Paauwen", 274, 7],
	["Paauwenburg", 379, 4],
	["Pade", 28, 3],
	["Padhuis", 7, 0],
	["Paesens", 16, 8],
	["Palemig", 190, 5],
	["Palenberg", 38, 5],
	["Pallert", 79, 7],
	["Pals", 391, 6],
	["De Pan", 332, 9],
	["De Pan", 245, 1],
	["Panheel", 170, 5],
	["Pannerden", 74, 6],
	["Panningen", 165, 5],
	["Papekop", 336, 10],
	["Papenbeek", 77, 5],
	["Papendijk", 354, 1],
	["Papendrecht", 416, 9],
	["Papenhoven", 275, 5],
	["Papenveer", 21, 9],
	["Papenvoort", 0, 0],
	["Park Leeuwenbergh", 407, 9],
	["Parrega", 96, 8],
	["Partij Wittem", 202, 5],
	["Pasop", 247, 7],
	["Passart", 190, 5],
	["Passewaaij", 152, 6],
	["Paterswolde (ged.)", 338, 7],
	["Paterswolde (ged.)", 213, 0],
	["Pathmos", 257, 2],
	["Pauluspolder", 39, 4],
	["Peebos", 313, 7],
	["Peelo", 22, 0],
	["Peel en Maas", 165, 5],
	["Peelse Huis", 137, 1],
	["Peelstraat", 137, 1],
	["De Peelstraat", 249, 1],
	["Peest", 103, 0],
	["Peij", 30, 5],
	["Peins", 41, 8],
	["Peize", 103, 0],
	["Peizermade", 103, 0],
	["Peizerweg", 291, 7],
	["Peizerwold", 103, 0],
	["Pekela", 310, 7],
	["Peking", 168, 10],
	["Pelikaan", 49, 1],
	["Pelsendijk", 248, 1],
	["Pendrecht", 286, 9],
	["Peperga", 251, 8],
	["Perenboom", 160, 1],
	["Pernis", 286, 9],
	["Persingen", 195, 6],
	["Pesaken", 202, 5],
	["Pesse", 53, 0],
	["Petersburg", 81, 8],
	["Petten", 35, 3],
	["Peursum", 138, 9],
	["Philippine", 153, 4],
	["Philipsdorp", 42, 1],
	["Philipswijk (=Bliksembosch)", 19, 1],
	["Philisteinsche Polder", 3, 3],
	["Piaam", 96, 8],
	["Pieperij", 106, 0],
	["Piepert", 202, 5],
	["Pierik", 144, 2],
	["Pieriksmars", 130, 2],
	["Piershil", 374, 9],
	["Pieterburen", 303, 7],
	["Pietersbierum", 41, 8],
	["Pieterzijl", 15, 7],
	["Pijlsweerd", 92, 10],
	["Pijnacker", 333, 9],
	["Pijnacker-Nootdorp", 333, 9],
	["Pijnenburg", 117, 10],
	["Pindorp", 82, 1],
	["Pingjum", 96, 8],
	["De Plaats", 200, 1],
	["Plaggenborg", 79, 7],
	["Plankendorp", 323, 4],
	["De Plas", 243, 2],
	["Plasmolen", 244, 5],
	["Plattenburg", 105, 6],
	["Platteweg", 348, 9],
	["Platvoet", 130, 2],
	["Plenkershoven", 113, 5],
	["Plenkert", 218, 5],
	["Poederoijen", 12, 6],
	["Poederoijensehoek", 12, 6],
	["Bij de Poel", 9, 3],
	["Poeldijk", 378, 9],
	["Poeldonk (Brug)", 198, 1],
	["De Poffert", 15, 7],
	["Pol", 170, 5],
	["De Pol", 62, 2],
	["De Pol", 133, 6],
	["De Pol", 103, 0],
	["De Pol", 166, 2],
	["Polanen", 66, 10],
	["Polder de Nieuwe Ban", 160, 1],
	["Polder Galekop", 368, 10],
	["Polen", 122, 7],
	["Polle", 86, 8],
	["De Pollen", 311, 2],
	["Polsbroek", 214, 10],
	["Polsbroekerdam", 214, 10],
	["Ponte", 23, 4],
	["Poortugaal", 89, 9],
	["Poortvliet", 128, 4],
	["Poppenhuizen", 85, 8],
	["Poppenwier", 85, 8],
	["Portengen", 297, 10],
	["Ten Post", 60, 7],
	["Posterenk", 133, 6],
	["Posterholt", 112, 5],
	["Praets", 105, 6],
	["Prattenburg", 43, 10],
	["Presikhaaf", 105, 6],
	["Prickart", 158, 5],
	["Princenhage", 191, 1],
	["Prins Alexanderpolder", 286, 9],
	["Prinsenbeek", 191, 1],
	["Prinsenkamp", 132, 6],
	["Prinsland", 248, 1],
	["Proosdijveld", 113, 5],
	["Puiflijk", 76, 6],
	["De Punt", 213, 0],
	["Punthorst", 339, 2],
	["Purmer", 302, 3],
	["Purmerend", 415, 3],
	["Purmerland", 394, 3],
	["Putbroek", 30, 5],
	["Puth", 119, 5],
	["Putte", 20, 1],
	["Putten", 237, 6],
	["Puttershoek", 241, 9],
	["Pyramide", 23, 4],
	["Quabeek", 239, 5],
	["Quatre Bras", 97, 6],
	["Raaieind", 29, 5],
	["Raalte", 93, 2],
	["Raam", 209, 1],
	["Raam", 193, 1],
	["Raamberg", 70, 1],
	["Raamsdonk", 346, 1],
	["Raamsdonksveer", 346, 1],
	["Raaphorst", 332, 9],
	["Raar", 306, 5],
	["Raard", 16, 8],
	["Raath", 239, 5],
	["Rade", 126, 3],
	["Radio Kootwijk", 24, 6],
	["Radewijk", 62, 2],
	["Raerd", 85, 8],
	["Rafelder", 240, 6],
	["Rakens", 102, 1],
	["Rakt", 193, 1],
	["'t Rammetje", 244, 5],
	["Rande", 130, 2],
	["Randenbroekkwartier", 116, 10],
	["Randenburg", 348, 9],
	["Randwijck", 118, 3],
	["Randwijk", 18, 6],
	["Ransdaal", 185, 5],
	["Ransdorp", 120, 3],
	["Ranum", 72, 7],
	["Rapenburg (Stoppeldijk)", 39, 4],
	["Raren", 319, 5],
	["Rasquert", 72, 7],
	["Ratum", 300, 6],
	["Ravensgat", 171, 1],
	["Ravenstein", 54, 1],
	["Ravenswaaij", 11, 6],
	["Ravenswoud", 81, 8],
	["Reahûs", 157, 8],
	["Recht van Terleede", 334, 9],
	["Rechteren", 127, 2],
	["Rechtvaart", 159, 1],
	["Rectum", 366, 2],
	["Redichem", 329, 6],
	["Reduzum", 85, 8],
	["Reek", 294, 1],
	["Reestlanden", 62, 2],
	["Reeuwijk", 348, 9],
	["Reeuwijksebrug", 348, 9],
	["Regge", 366, 2],
	["Reiderland", 201, 7],
	["Het Reidland", 194, 7],
	["Reijerscop", 187, 10],
	["Reijmerstok", 202, 5],
	["Reimerswaal", 188, 4],
	["De Reit", 224, 1],
	["Reitsum", 253, 8],
	["Rekken", 63, 6],
	["Remmerden", 43, 10],
	["Remswerd", 31, 8],
	["Ren", 171, 1],
	["Renesse", 284, 4],
	["Renkum", 318, 6],
	["Rennebourg", 79, 7],
	["Rennemig", 190, 5],
	["Renswoude", 362, 10],
	["Ressen", 211, 6],
	["Retersbeek", 185, 5],
	["Reth", 164, 1],
	["Retranchement", 23, 4],
	["Reuken", 5, 5],
	["Reusel", 58, 1],
	["Reusel-De Mierden", 58, 1],
	["Reutje", 112, 5],
	["Reutum", 87, 2],
	["Reuver", 173, 5],
	["Reuzenhoek", 153, 4],
	["Rewerd", 157, 8],
	["Rha", 50, 6],
	["Rheden", 337, 6],
	["Rhederbrug-Oost", 207, 7],
	["Rhee", 22, 0],
	["Rheeze", 62, 2],
	["Rheezerveen", 62, 2],
	["Rhenen", 43, 10],
	["Rhenoy", 71, 6],
	["Rhienderen", 312, 6],
	["Rhoon", 89, 9],
	["Rhoonse Veer", 89, 9],
	["Ribbelt", 257, 2],
	["Ridderbuurt", 25, 9],
	["Ridderkerk", 268, 9],
	["Riebroek", 254, 5],
	["Ried", 41, 8],
	["Riel", 42, 1],
	["Riel", 37, 1],
	["Rien", 157, 8],
	["De Riet", 2, 2],
	["Riethorst", 244, 5],
	["Riethoven", 1, 1],
	["Rietmolen", 63, 6],
	["De Rietschoof", 12, 6],
	["Rietveld", 187, 10],
	["Rietveld", 138, 9],
	["Rietveld", 215, 9],
	["Rijckholt", 298, 5],
	["Rijen", 265, 1],
	["Rijkel", 173, 5],
	["Rijkerswoerd", 105, 6],
	["Rijkevoort", 228, 1],
	["Rijksdorp", 332, 9],
	["Rijksweg", 77, 5],
	["De Rijlst", 86, 8],
	["Rijndijk", 419, 9],
	["De Rijndijk", 215, 9],
	["Rijneveld", 215, 9],
	["Rijngebied", 92, 10],
	["Rijnsaterwoude", 94, 9],
	["Rijnsburg", 398, 9],
	["Rijnwaarden", 74, 6],
	["Rijnwoude", 215, 9],
	["Rijp", 340, 3],
	["De Rijp", 376, 3],
	["De Rijp", 253, 8],
	["Rijpelberg", 205, 1],
	["Rijpwetering", 94, 9],
	["Rijs", 174, 8],
	["Rijsbergen", 70, 1],
	["Rijsdam", 79, 7],
	["Rijsenburg", 115, 10],
	["Rijsenhout", 10, 3],
	["Rijsoord", 268, 9],
	["Rijssen", 232, 2],
	["Rijssen-Holten", 232, 2],
	["Rijswijk", 11, 6],
	["Rijswijk", 382, 9],
	["Rijswijk", 100, 1],
	["Rijt", 1, 1],
	["Rilland", 188, 4],
	["Rilland-Bath", 188, 4],
	["Rimburg", 38, 5],
	["Rimpeld", 77, 5],
	["Rinkesfort", 165, 5],
	["Rinkveld", 45, 1],
	["Rinnegom", 3, 3],
	["Rinsumageest", 84, 8],
	["Rips", 171, 1],
	["Rith", 191, 1],
	["Ritthem", 379, 4],
	["Rivierenwijk", 92, 10],
	["Rixtel", 27, 1],
	["Rockanje", 386, 9],
	["Roden", 103, 0],
	["Rodenrijs", 223, 9],
	["Roderesch", 103, 0],
	["Roderveld", 103, 0],
	["Roderwolde", 103, 0],
	["Roekebosch", 166, 2],
	["Roelage", 79, 7],
	["Roelofarendsveen", 94, 9],
	["Roelshoek", 188, 4],
	["Roer", 142, 5],
	["Roerdalen", 112, 5],
	["Roermond", 142, 5],
	["Roerstelberg", 159, 1],
	["Roestenberg", 264, 1],
	["Roeven", 259, 5],
	["Rogat", 307, 0],
	["Roggel", 141, 5],
	["Roggel en Neer", 141, 5],
	["Roggelsedijk", 165, 5],
	["Rohel", 420, 8],
	["Rolaf", 248, 1],
	["Rolde", 0, 0],
	["Rolduc", 250, 5],
	["Roligt", 141, 5],
	["Rollepaal", 62, 2],
	["Rome", 91, 6],
	["Ronde Broek", 166, 2],
	["De Ronde Venen", 44, 10],
	["Rondeblesse", 166, 2],
	["Ronduite", 166, 2],
	["Roodehaan", 291, 7],
	["Roodenhoek", 23, 4],
	["Roode-Polder", 23, 4],
	["Roodeput", 158, 5],
	["Roodeschool", 227, 7],
	["Roodeschuur", 69, 8],
	["Roodevaart", 49, 1],
	["Roodkerk", 84, 8],
	["Roodvoet", 11, 6],
	["Roombeek", 257, 2],
	["Roomveld", 257, 2],
	["Roond", 217, 1],
	["Roosendaal", 82, 1],
	["Rooskenskant", 29, 5],
	["Roosteren", 30, 5],
	["Rooth", 165, 5],
	["'t Rooth", 178, 5],
	["Rooversbroek", 364, 9],
	["Rosanderpolder", 318, 6],
	["Rosengarten", 275, 5],
	["Rosmalen", 263, 1],
	["Rosmolenbuurt", 56, 3],
	["Rossum", 91, 6],
	["Rossum", 78, 2],
	["Rosveld", 259, 5],
	["Roswinkel", 121, 0],
	["Rothem", 306, 5],
	["Rotstergaast", 86, 8],
	["Rotsterhaule", 86, 8],
	["Rott", 319, 5],
	["De Rotte", 223, 9],
	["Rotterdam", 286, 9],
	["Rottevalle", 272, 8],
	["Rottum", 86, 8],
	["Rottum", 227, 7],
	["Rottumeroog", 227, 7],
	["Rouveen", 339, 2],
	["Roverberg", 39, 4],
	["Rozenburg", 10, 3],
	["Rozenburg", 421, 9],
	["Rozendaal", 395, 6],
	["Rozendaal", 204, 9],
	["Rucphen", 51, 1],
	["Ruigahuizen", 174, 8],
	["Ruigeweide", 336, 10],
	["Ruigezand", 15, 7],
	["Ruigoord", 384, 3],
	["Ruimel", 198, 1],
	["Ruinen", 106, 0],
	["Ruinerweide", 106, 0],
	["Ruinerwold", 106, 0],
	["Ruischerbrug", 291, 7],
	["Ruiten", 274, 7],
	["Ruitenveen", 127, 2],
	["Rukven", 225, 1],
	["Rul", 279, 1],
	["Rumelaar", 360, 10],
	["Rumpen", 287, 5],
	["Rumpt", 307, 0],
	["Rumpt", 71, 6],
	["Runrot", 354, 1],
	["Rustenburg", 151, 3],
	["Buurtschap Rutbeek", 257, 2],
	["Rutten", 180, 11],
	["Ruurlo", 63, 6],
	["Ruurloschebroek", 63, 6],
	["Ryptsjerk", 90, 8],
	["Saaksum", 15, 7],
	["Saasveld", 78, 2],
	["Saaxumhuizen", 72, 7],
	["Salvert", 41, 8],
	["Sambeek", 228, 1],
	["Sandebuur", 103, 0],
	["Sander", 147, 1],
	["Sanderbout", 275, 5],
	["Sandfirden", 31, 8],
	["Santfort", 141, 5],
	["Santpoort-Noord", 296, 3],
	["Santpoort-Zuid", 296, 3],
	["Sappemeer", 48, 7],
	["Sas van Gent", 153, 4],
	["Sasput", 23, 4],
	["Sassenheim", 422, 9],
	["Sauwerd", 72, 7],
	["Schaapbulten", 122, 7],
	["Schaarsbergen", 105, 6],
	["Schadewijk", 264, 1],
	["Schadijk", 29, 5],
	["Schadron", 193, 1],
	["Schaesberg", 38, 5],
	["Schaft", 57, 1],
	["Schagen", 317, 3],
	["Schagerbrug", 35, 3],
	["Schaijk", 294, 1],
	["Schalkhaar", 130, 2],
	["Schalkwijk", 375, 10],
	["Schalkwijk", 383, 3],
	["Schalsum", 41, 8],
	["Schandelo", 135, 5],
	["Schans", 101, 6],
	["Schans", 172, 1],
	["Schans", 160, 1],
	["Schans", 283, 1],
	["Schans", 141, 5],
	["De Schans", 62, 2],
	["De Schans", 150, 1],
	["Schapenbout", 153, 4],
	["Schapenmeent", 414, 3],
	["Schapershoek", 39, 4],
	["Schardam", 154, 3],
	["Scharendijke", 284, 4],
	["Scharl", 288, 8],
	["Scharlo", 162, 1],
	["Scharmer", 274, 7],
	["Scharn", 113, 5],
	["Scharnegoutum", 31, 8],
	["Scharsterbrug", 86, 8],
	["Scharwoude", 151, 3],
	["Schaveren", 278, 6],
	["Scheemda", 201, 7],
	["Scheemdermeer", 201, 7],
	["Scheemderzwaag", 201, 7],
	["Scheerwolde", 166, 2],
	["Scheide", 254, 5],
	["Schelfhorst", 213, 0],
	["Schelle", 144, 2],
	["Schellingwoude", 120, 3],
	["Schellinkhout", 242, 3],
	["Schelluinen", 138, 9],
	["Schelm", 172, 1],
	["Schenkel", 320, 9],
	["Schenkeldijk", 241, 9],
	["Schenkeldijk", 374, 9],
	["Schermer", 350, 3],
	["Schermerdijk", 350, 3],
	["Schermerhorn", 350, 3],
	["Scherpenering", 83, 1],
	["Scherpenisse", 128, 4],
	["Scherpenzeel", 251, 8],
	["Scherpenzeel", 390, 6],
	["Schettens", 96, 8],
	["Scheulder", 178, 5],
	["Scheveningen", 377, 9],
	["Schey", 178, 5],
	["Schiebroek", 286, 9],
	["Schiedam", 236, 9],
	["Het Schier", 281, 0],
	["Schiermonnikoog", 423, 8],
	["Schietecoven", 306, 5],
	["Schieveen", 286, 9],
	["Schieven", 22, 0],
	["Schijf", 51, 1],
	["Schijndel", 277, 1],
	["Schilberg", 30, 5],
	["Schilberg (ged.)", 178, 5],
	["Schilberg (ged.)", 202, 5],
	["Schildwolde", 274, 7],
	["Schillersheide", 141, 5],
	["Schilligeham", 72, 7],
	["Schimmert", 5, 5],
	["Schin op Geul", 218, 5],
	["Schingen", 203, 8],
	["Schinnen", 119, 5],
	["Schinveld", 239, 5],
	["Schipborg", 0, 0],
	["Schiphol", 10, 3],
	["Schiphol-Rijk", 10, 3],
	["Schiphorst", 307, 0],
	["Schipluiden", 316, 9],
	["Schoonbron", 218, 5],
	["Schoondijke", 23, 4],
	["Schoondorp", 128, 4],
	["Schoonebeek", 121, 0],
	["Schoonenburg", 385, 6],
	["Schoonhoven", 424, 9],
	["Schoonloo", 0, 0],
	["Schoonoord", 7, 0],
	["Schoonouwen", 204, 9],
	["Schoonrewoerd", 334, 9],
	["Schoonveld", 221, 1],
	["Schoor", 16, 8],
	["Schoor", 259, 5],
	["Schoordijk", 219, 1],
	["Schoorl", 3, 3],
	["Schoorldam (ged.)", 3, 3],
	["Schoorldam (ged.)", 340, 3],
	["Schoorveld", 165, 5],
	["Schoot", 83, 1],
	["Schoot", 219, 1],
	["'t Schoot", 42, 1],
	["Schore", 235, 4],
	["Schorebrug", 188, 4],
	["'t Schot", 79, 7],
	["Schoten-Uiterdijken", 176, 8],
	["Schotsheuvel", 354, 1],
	["Schottershuizen", 106, 0],
	["Schouwen", 303, 7],
	["Schouwen-Duiveland", 284, 4],
	["Schouwerzijl", 303, 7],
	["Schraard", 96, 8],
	["Schreurserve", 257, 2],
	["Schrieversheide", 190, 5],
	["Schuddebeurs", 39, 4],
	["Schuddebeurs", 284, 4],
	["Schuddebeurs", 349, 1],
	["Schuilenburg", 330, 2],
	["Schuilingsoord", 213, 0],
	["Schuinesloot", 62, 2],
	["Schulpstet", 80, 3],
	["Schurenberg", 190, 5],
	["Schuring", 328, 9],
	["Schuttersveld", 257, 2],
	["Schutwijk", 121, 0],
	["Schuwacht", 404, 9],
	["Schweiberg", 202, 5],
	["Sebaldeburen", 313, 7],
	["Seeryp", 156, 8],
	["Seghwaert", 425, 9],
	["Selissen", 217, 1],
	["Sellingen", 79, 7],
	["Sellingerbeetse", 79, 7],
	["Selmien", 175, 8],
	["Selwerd", 291, 7],
	["Selwerd", 15, 7],
	["Sempke", 345, 1],
	["Sengelsbroek", 1, 1],
	["Separatiedijk", 188, 4],
	["Seppe", 283, 1],
	["Serooskerke", 4, 4],
	["Serooskerke", 284, 4],
	["Seters", 14, 1],
	["Sevenum", 29, 5],
	["Sexbierum", 41, 8],
	["Sibbe", 218, 5],
	["Sibculo", 62, 2],
	["Sibrandabuorren", 85, 8],
	["Siddeburen", 274, 7],
	["Siddebuursterveen", 274, 7],
	["Siebengewald", 77, 5],
	["Siegerswoude", 175, 8],
	["'t Siep", 274, 7],
	["Siepelveen", 121, 0],
	["Sigerswâld", 90, 8],
	["Sijbekarspel", 32, 3],
	["Silvolde", 240, 6],
	["Simonshaven", 34, 9],
	["Simonshoek", 165, 5],
	["Simpelveld", 158, 5],
	["Sinderen", 240, 6],
	["Sinnevelt", 383, 3],
	["Sinselbeek", 202, 5],
	["Sint Agatha", 200, 1],
	["Sint Andries", 91, 6],
	["Sint Anna", 211, 6],
	["Sint Anna ter Muiden", 23, 4],
	["Sint Annaland", 128, 4],
	["St.-Annaparochie", 238, 8],
	["Sint Annen", 60, 7],
	["Sint Annerhuisjes", 194, 7],
	["Sint Anthoniepolder", 241, 9],
	["Sint Anthonis", 249, 1],
	["Sint Antoniusbank", 218, 5],
	["Sint Geertruid", 178, 5],
	["Sint Gerlach", 218, 5],
	["Sint Hubert", 260, 1],
	["Sint Isidorushoeve", 293, 2],
	["St.-Jacobiparochie", 238, 8],
	["Sint Jansklooster", 166, 2],
	["Sint Jansteen", 39, 4],
	["Sint Johannesga", 86, 8],
	["Sint Joosland", 139, 4],
	["Sint Joost", 30, 5],
	["Sint Josefparochie", 172, 1],
	["Sint Kruis", 23, 4],
	["Sint Laurens", 139, 4],
	["Sint Maarten", 340, 3],
	["Sint Maartensbrug", 35, 3],
	["Sint Maartensdijk", 128, 4],
	["Sint Maartensvlotbrug", 35, 3],
	["Sint Marten", 105, 6],
	["Sint Nicolaasga", 86, 8],
	["Sint Odiliënberg", 112, 5],
	["Sint Pancras", 304, 3],
	["Sint Philipsland", 128, 4],
	["Sint Pieter", 113, 5],
	["Sint Vitusholt", 201, 7],
	["Sint Willebrord", 51, 1],
	["Sintmaheerdt", 247, 7],
	["Sint-Michielsgestel", 198, 1],
	["Sint-Oedenrode", 280, 1],
	["Sirjansland", 284, 4],
	["Sittard", 275, 5],
	["Sittard-Geleen", 275, 5],
	["Slabroek", 193, 1],
	["Slagharen", 62, 2],
	["Slagveld", 147, 1],
	["Slangenburg", 64, 6],
	["Slappeterp", 203, 8],
	["Sleen", 7, 0],
	["Sleeuwijk", 160, 1],
	["Slek", 30, 5],
	["Slenaken", 202, 5],
	["Slibbroek", 169, 1],
	["Slichtenhorst", 132, 6],
	["Sliedrecht", 426, 9],
	["Slijkenburg", 251, 8],
	["Slijk-Ewijk", 18, 6],
	["Slijkplaat", 23, 4],
	["Slijkwell", 91, 6],
	["Slikkerveer", 268, 9],
	["Slochteren", 274, 7],
	["Slootdijk", 410, 10],
	["Slootdorp", 403, 3],
	["Sloten", 120, 3],
	["Sloten", 174, 8],
	["Sloterdijk", 120, 3],
	["Sluipwijk", 348, 9],
	["Sluis", 39, 4],
	["Sluis", 67, 9],
	["Sluis", 23, 4],
	["Sluis-Aardenburg", 23, 4],
	["Sluiskil", 153, 4],
	["Smakt", 254, 5],
	["Smalbroek-Ter Horst", 107, 0],
	["Smalle Ee", 272, 8],
	["Smallebrugge", 31, 8],
	["Smallingerland", 272, 8],
	["Smeerling", 104, 7],
	["Smeermaas", 113, 5],
	["Smerp", 208, 3],
	["Smidstraat", 141, 5],
	["Smilde", 107, 0],
	["Smitshoek", 181, 9],
	["Smorenhoek", 195, 6],
	["Snakkerburen", 161, 8],
	["Sneek", 393, 8],
	["Snelrewaard", 336, 10],
	["Snepseind", 285, 1],
	["Snijdersberg", 306, 5],
	["Snikzwaag", 86, 8],
	["Snippeling", 130, 2],
	["Snodenhoek", 18, 6],
	["Snorrenhoef", 61, 10],
	["Soerel", 131, 6],
	["Soerendonk", 219, 1],
	["Soest", 117, 10],
	["Soestdijk (ged.)", 168, 10],
	["Soestdijk (ged.)", 117, 10],
	["Soestduinen", 117, 10],
	["Soesterberg", 117, 10],
	["Soesterkwartier", 116, 10],
	["Soeterbeek", 165, 5],
	["Solwerd", 134, 7],
	["Someren", 47, 1],
	["Someren-Eind", 47, 1],
	["Somerensche Heide", 47, 1],
	["Sommelsdijk", 189, 9],
	["Son", 19, 1],
	["Son en Breugel", 19, 1],
	["Sondel", 174, 8],
	["Sonnega", 251, 8],
	["Sonniuswijk", 19, 1],
	["Sonsbeek", 105, 6],
	["Sopsum", 41, 8],
	["Spaansch-Huisken", 30, 5],
	["Spaarndam", 384, 3],
	["Spaarndammerbuurt", 296, 3],
	["Spaarndam-West", 383, 3],
	["Spaarnwoude", 384, 3],
	["Spakenburg", 256, 10],
	["Spanbroek", 28, 3],
	["Spanga", 251, 8],
	["Spangen", 286, 9],
	["Spankeren", 337, 6],
	["Spannenburg", 86, 8],
	["Spannum", 157, 8],
	["Sparrenburg", 263, 1],
	["Spaubeek", 196, 5],
	["Speers", 85, 8],
	["Spekholzerheide", 250, 5],
	["Spelberg", 257, 2],
	["Spengen", 297, 10],
	["Speuld", 197, 6],
	["Spier", 107, 0],
	["Spierdijk", 151, 3],
	["Spijk", 122, 7],
	["Spijk", 74, 6],
	["Spijk", 143, 6],
	["Spijk", 6, 1],
	["Spijkenisse", 367, 9],
	["Spijkerboor", 396, 3],
	["Spijkerboor", 0, 0],
	["Straat en Thuserhof Spik", 142, 5],
	["Spitsbergen", 212, 7],
	["Sponturfwijk", 62, 2],
	["Spoolde", 144, 2],
	["Spoorbuurt", 129, 3],
	["Spoordonk", 285, 1],
	["Sprang", 162, 1],
	["Sprang-Capelle", 162, 1],
	["Sprangsevaart", 162, 1],
	["Sprokkelbosch", 263, 1],
	["De Spronk", 292, 6],
	["Sprundel", 51, 1],
	["Spui", 153, 4],
	["Spurk", 198, 1],
	["Spurkt", 165, 5],
	["Staalduinen", 378, 9],
	["Staartsche Duinen", 20, 1],
	["Stad aan 't Haringvliet", 189, 9],
	["Stad Delden", 111, 2],
	["Stadbroek", 275, 5],
	["Stadse Dijk", 49, 1],
	["Stadskanaal", 104, 7],
	["Stadsveld", 257, 2],
	["Stakenborg", 79, 7],
	["Stalberg", 135, 5],
	["Stampersgat", 283, 1],
	["Standdaarbuiten", 49, 1],
	["Stapel", 106, 0],
	["Staphorst", 339, 2],
	["Starnmeer", 376, 3],
	["Starnmeerpolder", 396, 3],
	["Startenhuizen", 357, 7],
	["Startenhuizen", 227, 7],
	["Starting", 80, 3],
	["Statendam", 346, 1],
	["Stationsbuurt", 188, 4],
	["Stavenisse", 128, 4],
	["Staverden", 197, 6],
	["Stavoren", 288, 8],
	["Stede Broec", 290, 3],
	["Stedum", 357, 7],
	["Steeg", 29, 5],
	["De Steeg", 337, 6],
	["Steegsbroek", 254, 5],
	["Steelhoven", 14, 1],
	["Steenbergen", 248, 1],
	["Steenbergen", 103, 0],
	["Steendam", 274, 7],
	["Steenderen", 50, 6],
	["Steenenkamer", 133, 6],
	["Steenenkruis", 128, 4],
	["Steenoven", 14, 1],
	["Steenoven", 165, 5],
	["Steenovens", 153, 4],
	["Steenplaats", 322, 9],
	["Steensel", 264, 1],
	["Steenwijk", 166, 2],
	["Steenwijkerland", 166, 2],
	["Steenwijkerwold", 166, 2],
	["Steenwijksmoer", 7, 0],
	["Stegen", 45, 1],
	["Stegeren", 136, 2],
	["Steggerda", 251, 8],
	["Steijl", 135, 5],
	["Stein", 204, 9],
	["Stein", 321, 5],
	["Steinenburg", 65, 10],
	["Stekkenberg", 220, 6],
	["Stellendam", 372, 9],
	["Sterenborg", 104, 7],
	["Sterksel", 279, 1],
	["Stevenfenne", 257, 2],
	["Stevensbeek", 249, 1],
	["Stevensweert", 170, 5],
	["Stieltjeskanaal", 7, 0],
	["Stiens", 301, 8],
	["Stipdonk", 47, 1],
	["Stiphout", 205, 1],
	["Stippelberg", 171, 1],
	["Stitswerd", 227, 7],
	["Stobben", 79, 7],
	["Stogger", 165, 5],
	["Stokhem", 202, 5],
	["Stokkelaarsbrug", 36, 10],
	["Stokkelen", 264, 1],
	["Stokkum", 155, 6],
	["Stokkum", 111, 2],
	["Stokt", 29, 5],
	["Stolpen", 35, 3],
	["Stolpervlotbrug", 35, 3],
	["Stolwijk", 204, 9],
	["Stolwijkersluis (ged.)", 255, 9],
	["Stolwijkersluis (ged.)", 204, 9],
	["Stompetoren", 350, 3],
	["Stompwijk", 407, 9],
	["Stoof", 283, 1],
	["Stootshorn", 212, 7],
	["Stormpolder", 402, 9],
	["Stougjesdijk", 241, 9],
	["Stoutenburg", 61, 10],
	["Stox", 165, 5],
	["Strabeek", 218, 5],
	["Strabrecht", 279, 1],
	["Stramproy", 108, 5],
	["Straten", 285, 1],
	["Strateris", 259, 5],
	["Stratum", 42, 1],
	["Streefkerk", 370, 9],
	["Streek", 0, 0],
	["De Streek", 227, 7],
	["Streukel", 144, 2],
	["Strevelshoek", 268, 9],
	["Strijbeek", 102, 1],
	["Strijen", 322, 9],
	["Strijenham", 128, 4],
	["Strijensas", 322, 9],
	["Strijp", 382, 9],
	["Strijp", 42, 1],
	["Strijp", 27, 1],
	["Strijpe", 386, 9],
	["Strikberg", 349, 1],
	["Stroe", 184, 6],
	["Stroe", 208, 3],
	["Stroet", 340, 3],
	["Stroobos", 69, 8],
	["Stroodorp", 323, 4],
	["Strooivledder", 281, 0],
	["Strucht", 218, 5],
	["Stuifakker", 386, 9],
	["Stuifzand", 53, 0],
	["Stuivezand", 70, 1],
	["Stuivezand", 349, 1],
	["Sumar", 90, 8],
	["Surhuisterveen", 69, 8],
	["Surhuizum", 69, 8],
	["Susteren", 30, 5],
	["Suttum", 72, 7],
	["Suwâld", 90, 8],
	["Swaanwert", 157, 8],
	["Swalmen", 142, 5],
	["Swartbroek", 108, 5],
	["Sweikhuizen", 119, 5],
	["Swichum", 161, 8],
	["Swier", 5, 5],
	["Swifterbant", 234, 11],
	["Swolgen", 29, 5],
	["Taarlo", 213, 0],
	["Tabakshof", 66, 10],
	["Tange", 104, 7],
	["Tappersheul", 336, 10],
	["Tasdijk", 39, 4],
	["Teckop", 187, 10],
	["Teeffelen", 399, 1],
	["Teerns", 161, 8],
	["Tegelen", 135, 5],
	["Telgt", 197, 6],
	["Tempel", 348, 9],
	["Terband", 271, 8],
	["Terblijt", 218, 5],
	["Terborg", 240, 6],
	["Terdiek", 186, 3],
	["Tereyken", 171, 1],
	["Tergracht (ged.)", 90, 8],
	["Tergracht (ged.)", 253, 8],
	["Terhagen", 321, 5],
	["Terheijden", 349, 1],
	["Terheijl", 103, 0],
	["Terherne", 85, 8],
	["Terhofstede", 23, 4],
	["Terhorst", 178, 5],
	["Terkaple", 86, 8],
	["Terlet", 395, 6],
	["Terlinden", 178, 5],
	["Termaar", 178, 5],
	["Termaar", 185, 5],
	["Termunten", 122, 7],
	["Termunterzijl", 122, 7],
	["Ternaard", 16, 8],
	["Terneuzen", 153, 4],
	["Teroele", 86, 8],
	["Terover", 102, 1],
	["Terschelling", 156, 8],
	["Terschuren", 190, 5],
	["Terschuur", 184, 6],
	["Tersluis", 242, 3],
	["Tersoal", 85, 8],
	["Terstraten", 5, 5],
	["Tervoorst", 5, 5],
	["Tervoort", 191, 1],
	["Terwinselen (ged.)", 38, 5],
	["Terwinselen (ged.)", 250, 5],
	["Terwisga", 81, 8],
	["Terwispel", 175, 8],
	["Terwolde", 133, 6],
	["Terworm", 190, 5],
	["Terziet", 202, 5],
	["Teteringen", 191, 1],
	["Teuge", 133, 6],
	["Texel", 183, 3],
	["Teylingen", 422, 9],
	["Thamerdal", 179, 3],
	["Theereheide", 198, 1],
	["Thesinge", 60, 7],
	["Thij", 166, 2],
	["Tholen", 128, 4],
	["Thorn", 170, 5],
	["Thull", 119, 5],
	["Tichelwurk", 301, 8],
	["Tiel", 152, 6],
	["Tielse Hoeve", 198, 1],
	["Tiendeveen", 53, 0],
	["Tiendweg-West", 404, 9],
	["Tiengemeten", 374, 9],
	["Tienhoven", 411, 10],
	["Tienhoven", 67, 9],
	["Tienray", 29, 5],
	["Tiggelt", 70, 1],
	["Tijnje", 175, 8],
	["De Tike", 272, 8],
	["Tilburg", 224, 1],
	["Tilligte", 78, 2],
	["Tinallinge", 72, 7],
	["Tinte", 386, 9],
	["Tirns", 31, 8],
	["Tivoli", 42, 1],
	["Tjaard", 161, 8],
	["Tjabbesoord", 207, 7],
	["Tjalhuizum", 31, 8],
	["Tjalleberd", 271, 8],
	["Tjallewal", 317, 3],
	["Tjamsweer", 134, 7],
	["Tjerkgaast", 86, 8],
	["Tjerkwerd", 96, 8],
	["Tjoene", 130, 2],
	["Tjuchem", 274, 7],
	["Tolberg", 82, 1],
	["Tolbert", 247, 7],
	["Toldijk", 50, 6],
	["Toldijk", 106, 0],
	["Tolkamer", 74, 6],
	["Tolke", 317, 3],
	["Tollebeek", 180, 11],
	["Tonden", 312, 6],
	["Tongelaar", 200, 1],
	["Tongelre", 42, 1],
	["Tongeren", 278, 6],
	["Tongeren", 217, 1],
	["Tongeren", 262, 2],
	["Tongerlo", 165, 5],
	["Tongerlo", 29, 5],
	["Tonnekreek", 49, 1],
	["Tonsel (ged.)", 197, 6],
	["Tonsel (ged.)", 353, 6],
	["Toom", 219, 1],
	["Toornwerd", 357, 7],
	["Tragel", 39, 4],
	["Tragel", 23, 4],
	["Tranendal", 201, 7],
	["Transvaal", 168, 10],
	["Treebeek (ged.)", 287, 5],
	["Treebeek (ged.)", 190, 5],
	["Den Treek", 61, 10],
	["Trent", 294, 1],
	["Tricht", 71, 6],
	["Triemen", 148, 8],
	["Trimunt", 261, 7],
	["Trintelen", 202, 5],
	["Tripscompagnie", 212, 7],
	["Tritzum", 41, 8],
	["Trompenberg", 324, 3],
	["Tronde", 81, 8],
	["Tubantia", 257, 2],
	["Tubbergen", 87, 2],
	["Tuikwerd", 122, 7],
	["Tuil", 327, 6],
	["Tuindorp", 92, 10],
	["Tuindorp", 236, 9],
	["Tuindorp", 42, 1],
	["Tuindorp Broekheurne", 257, 2],
	["Tuindorp Bruggemors", 257, 2],
	["Tuindorp Dolfia", 257, 2],
	["Tuindorp Meerdervoort", 52, 9],
	["Tuindorp Onnen", 338, 7],
	["Tuindorp Oostzaan", 120, 3],
	["Tuindorp Slotermeer", 120, 3],
	["Tuinhoek", 199, 3],
	["Tuinstad Slotervaart", 120, 3],
	["Tuitjenhorn", 340, 3],
	["Tuk", 166, 2],
	["Tull en 't Waal", 375, 10],
	["Tungelroy", 108, 5],
	["Turkeije", 23, 4],
	["Tusschen de Bruggen", 112, 5],
	["Tusschenloegen", 212, 7],
	["Tussenklappen", 212, 7],
	["Tussenlanen", 46, 9],
	["Twaalfmorgen", 348, 9],
	["Tweede Exloërmond", 273, 0],
	["Tweede Tol", 326, 9],
	["Tweede Valthermond", 273, 0],
	["Tweehuizen", 122, 7],
	["Tweemanspolder", 359, 9],
	["Twekkelerveld", 257, 2],
	["Twekkelo (ged.)", 257, 2],
	["Twekkelo (ged.)", 192, 2],
	["Twello", 133, 6],
	["Twenterand", 311, 2],
	["Twijzel", 69, 8],
	["Twijzelerheide", 69, 8],
	["Twisk", 32, 3],
	["Twist", 249, 1],
	["Tynaarlo", 213, 0],
	["Tytsjerk", 90, 8],
	["Tytsjerksteradiel", 90, 8],
	["Tzum", 41, 8],
	["Tzummarum", 41, 8],
	["Ubach over Worms", 38, 5],
	["Ubachsberg", 185, 5],
	["Ubbena", 22, 0],
	["Ubbergen", 195, 6],
	["Ubroek", 135, 5],
	["Uddel", 24, 6],
	["Uden", 193, 1],
	["Udenhout", 224, 1],
	["Uffelse", 141, 5],
	["Uffelte", 281, 0],
	["Ugchelen", 24, 6],
	["Uilesprong", 175, 8],
	["Uitdam", 302, 3],
	["Uiteinde", 122, 7],
	["Uiteinde", 272, 8],
	["Uiterburen", 212, 7],
	["Uiterwaard", 124, 6],
	["Uitgeest", 145, 3],
	["Uithoorn", 179, 3],
	["Uithuizen", 227, 7],
	["Uithuizermeeden", 227, 7],
	["Uitweg", 214, 10],
	["Uitwellingerga", 31, 8],
	["Uitwierde", 122, 7],
	["Uitwijk", 100, 1],
	["Ulestraten", 306, 5],
	["Ulft", 240, 6],
	["Ulfterhoek", 29, 5],
	["Ulicoten", 164, 1],
	["Ullingen", 249, 1],
	["Ulrum", 303, 7],
	["Ulsda", 201, 7],
	["Ulvenhout", 191, 1],
	["Ureterp", 175, 8],
	["Urk", 427, 11],
	["Urkhoven", 42, 1],
	["Urmond", 321, 5],
	["Ursem", 151, 3],
	["Ursum", 350, 3],
	["Usquert", 227, 7],
	["Usselo", 257, 2],
	["Utrecht", 92, 10],
	["Utrechtse Heuvelrug", 115, 10],
	["Vaals", 319, 5],
	["Vaalwaard", 125, 6],
	["Vaartkant", 147, 1],
	["Vaartwijk", 153, 4],
	["Vaassen", 278, 6],
	["Vaesrade (ged.)", 190, 5],
	["Vaesrade (ged.)", 5, 5],
	["Val", 153, 4],
	["Valburg", 18, 6],
	["Valenberg", 385, 6],
	["Valendries", 109, 6],
	["Valkenburg", 398, 9],
	["Valkenburg", 218, 5],
	["Valkenburg aan de Geul", 218, 5],
	["Valkenheide", 115, 10],
	["Valkenhuizen", 190, 5],
	["Valkenswaard", 57, 1],
	["Valkeveen", 414, 3],
	["Valkkoog", 340, 3],
	["De Valom", 84, 8],
	["Valthe", 273, 0],
	["Valtherblokken", 273, 0],
	["Valthermond", 273, 0],
	["Valthermussel", 273, 0],
	["Varik", 327, 6],
	["Varsen", 136, 2],
	["Varssel", 50, 6],
	["Varsselder", 240, 6],
	["Varsseveld", 240, 6],
	["Varvik", 257, 2],
	["Vasse", 87, 2],
	["Vatrop", 208, 3],
	["De Vecht", 133, 6],
	["Vechten", 315, 10],
	["Veecaten", 243, 2],
	["Veele", 79, 7],
	["Veelerveen", 207, 7],
	["Veen", 6, 1],
	["Het Veen", 212, 7],
	["In het Veen", 212, 7],
	["Veendam", 182, 7],
	["Veendijk", 281, 0],
	["Veenendaal", 428, 10],
	["Veenhof", 0, 0],
	["De Veenhoop", 272, 8],
	["Veenhuizen", 104, 7],
	["Veenhuizen", 7, 0],
	["Veenhuizen", 305, 3],
	["Veenhuizen", 103, 0],
	["Veenhuizen", 212, 7],
	["Veenhuizerveld", 237, 6],
	["Veeningen", 106, 0],
	["Veenkoten", 81, 8],
	["Veenoord", 121, 0],
	["Veenwouden", 84, 8],
	["Veer", 153, 4],
	["Veere", 4, 4],
	["Veerhuis", 11, 6],
	["Veers", 165, 5],
	["Veessen", 222, 6],
	["Vegelinsoord", 86, 8],
	["Veghel", 229, 1],
	["Veld", 135, 5],
	["'t Veld", 186, 3],
	["Veldbuurt", 292, 6],
	["Velddriel", 91, 6],
	["Den Velde", 62, 2],
	["Ten Velde", 167, 2],
	["Velden", 135, 5],
	["Veldhoek", 63, 6],
	["Veldhoven", 83, 1],
	["Veldhuizen", 210, 6],
	["Veldhuizen", 92, 10],
	["Veldhunten", 240, 6],
	["Veldkamp", 257, 2],
	["Veldschuur", 321, 5],
	["Veldstreek", 247, 7],
	["Veldwijk", 197, 6],
	["Veldwijk", 50, 6],
	["Velgart", 135, 5],
	["Velletri", 283, 1],
	["Velp", 337, 6],
	["Velp", 270, 1],
	["Velsen", 296, 3],
	["Velsen-Noord", 296, 3],
	["Velsen-Zuid", 296, 3],
	["Velserbroek", 296, 3],
	["Velswijk", 50, 6],
	["Veltum", 254, 5],
	["Veluwe", 91, 6],
	["Velve", 257, 2],
	["Vemde", 278, 6],
	["Ven", 229, 1],
	["Ven", 279, 1],
	["Het Ven", 37, 1],
	["Het Ven", 135, 5],
	["Venebrugge", 62, 2],
	["Veneburen", 81, 8],
	["Veneind", 264, 1],
	["Venhorst", 137, 1],
	["Venhuizen", 242, 3],
	["Venkoelen", 135, 5],
	["Venlo", 135, 5],
	["Venne", 141, 5],
	["Venray", 254, 5],
	["Vensterburen", 301, 8],
	["Verlaat", 166, 2],
	["Verloren Einde", 154, 3],
	["Verreheide", 171, 1],
	["Vervoornepolder", 160, 1],
	["Verwolde", 97, 6],
	["Verzetswijk", 149, 10],
	["Vessem", 264, 1],
	["Vethuizen", 155, 6],
	["Veulen", 254, 5],
	["Vianen", 266, 10],
	["Vianen", 200, 1],
	["Viel", 239, 5],
	["Vierakker", 50, 6],
	["Vierambachtspolder", 94, 9],
	["Vierbannen", 160, 1],
	["Vierhouten", 361, 6],
	["Vierhuis", 86, 8],
	["Vierhuis", 161, 8],
	["Vierhuizen", 122, 7],
	["Vierhuizen", 96, 8],
	["Vierhuizen", 303, 7],
	["Vierlingsbeek", 228, 1],
	["Vierpolders", 299, 9],
	["Vieruitersten", 165, 5],
	["Vierverlaten", 291, 7],
	["Vijcie", 160, 1],
	["Vijfhuis", 31, 8],
	["Vijfhuizen", 10, 3],
	["Oosthout", 422, 9],
	["Vijfhuizen", 37, 1],
	["Vijfhuizen", 253, 8],
	["Vijlen", 319, 5],
	["Vilheide", 260, 1],
	["Vilsteren", 136, 2],
	["Vilt", 218, 5],
	["Vingerling", 153, 4],
	["Vink", 250, 5],
	["Vink", 5, 5],
	["Vinkega", 251, 8],
	["Vinkel", 354, 1],
	["Vinkenberg", 308, 1],
	["Vinkenbroek", 82, 1],
	["Vinkenbuurt", 136, 2],
	["Vinkenhoef", 132, 6],
	["Vinkeveen", 44, 10],
	["Visbuurt", 16, 8],
	["Vissersburen", 31, 8],
	["Visserweert", 30, 5],
	["Visvliet", 15, 7],
	["Vlaardingen", 429, 9],
	["Vlaardinger-Ambacht", 429, 9],
	["Vlaas", 141, 5],
	["Vlagtwedde", 79, 7],
	["Vlagtwedder-Veldhuis", 79, 7],
	["Vlasakkers", 116, 10],
	["Vledder", 281, 0],
	["Vledderhuizen", 104, 7],
	["Vledderveen", 104, 7],
	["Vledderveen", 281, 0],
	["Vlengendaal", 158, 5],
	["Vleut", 26, 1],
	["Vleuten", 92, 10],
	["Vliedberg", 345, 1],
	["Vliegert", 165, 5],
	["Vlieghuis", 7, 0],
	["Vlieland", 417, 8],
	["Vlieland", 333, 9],
	["Vlierden", 172, 1],
	["Vliert", 263, 1],
	["De Vliert", 91, 6],
	["Vliet", 336, 10],
	["Vlijmen", 345, 1],
	["Vlissingen", 379, 4],
	["Vlist", 204, 9],
	["Vlodrop", 112, 5],
	["Vloeieind", 172, 1],
	["'t Vlot", 18, 6],
	["Voederheil", 294, 1],
	["Voerendaal", 185, 5],
	["Vogelenzang", 73, 3],
	["Vogelfort", 39, 4],
	["Vogelwaarde", 39, 4],
	["Vogelzang", 338, 7],
	["Voldijn", 13, 1],
	["Volendam", 355, 3],
	["Volkel", 193, 1],
	["Vollenhove", 149, 10],
	["Vollenhove", 166, 2],
	["Volthe", 78, 2],
	["Vondelingenplaat", 286, 9],
	["Voorburg", 221, 1],
	["Voorburg", 407, 9],
	["Voordeldonk", 45, 1],
	["De Voordes", 382, 9],
	["Voordijk", 345, 1],
	["Voorhout", 422, 9],
	["Voorne", 91, 6],
	["Voorschoten", 419, 9],
	["Voorst", 144, 2],
	["Voorst", 240, 6],
	["Voorst", 133, 6],
	["Voorst", 112, 5],
	["Voorstad", 130, 2],
	["Voorste Brug", 57, 1],
	["Voorste Hees", 29, 5],
	["Voorste Heikant", 58, 1],
	["Voorsterveld", 112, 5],
	["Voorstonden", 312, 6],
	["Voort", 172, 1],
	["Voort", 1, 1],
	["De Voort", 135, 5],
	["Voorthuizen", 184, 6],
	["Voorveld", 338, 7],
	["Voorweg", 425, 9],
	["De Voorweg", 215, 9],
	["Vorchten", 222, 6],
	["Vorden", 50, 6],
	["Vorenseinde", 51, 1],
	["De Vorst", 217, 1],
	["De Vorst", 135, 5],
	["De Vorst", 29, 5],
	["Vorstenbosch", 225, 1],
	["Vortum-Mullem", 228, 1],
	["Vosberg", 165, 5],
	["Vosdonk", 147, 1],
	["Voskuil", 292, 6],
	["Voskuilen", 360, 10],
	["Vossebelt", 7, 0],
	["Vossebrink", 111, 2],
	["Vosselen", 45, 1],
	["Vossenburg", 48, 7],
	["Voulwames", 306, 5],
	["Vrachelen", 14, 1],
	["Vragender", 356, 6],
	["Vrakker", 108, 5],
	["Vrank", 190, 5],
	["Vredenheim", 0, 0],
	["Vredepeel", 254, 5],
	["Vrederust", 150, 1],
	["Vredeveld", 22, 0],
	["Vreeland", 410, 10],
	["Vreeswijk", 368, 10],
	["Vreewijk", 43, 10],
	["Vreewijk", 172, 1],
	["Vressel", 280, 1],
	["Vries", 213, 0],
	["Vriescheloo", 207, 7],
	["Vriezekoop", 94, 9],
	["Vriezenveen", 311, 2],
	["Vriezenveensewijk", 311, 2],
	["Vrij", 77, 5],
	["Vrijhoeve", 162, 1],
	["Vrijhoeven", 21, 9],
	["Vrilkhoven", 217, 1],
	["Vroelen", 178, 5],
	["Vroenhof", 218, 5],
	["Vroenhout", 82, 1],
	["Vroomshoop", 311, 2],
	["Vrouwenakker", 21, 9],
	["Vrouwenparochie", 238, 8],
	["Vrouwenpolder", 4, 4],
	["Vrusschemig", 190, 5],
	["Vught", 221, 1],
	["Vuile Riete", 106, 0],
	["Vuilwammes", 113, 5],
	["Vuren", 143, 6],
	["Waaksens", 157, 8],
	["Waal", 370, 9],
	["De Waal", 183, 3],
	["'t Waal", 375, 10],
	["Waalre", 13, 1],
	["Waalwijk", 162, 1],
	["'t Waar", 201, 7],
	["Waarddijk", 304, 3],
	["Waarde", 188, 4],
	["Waardenburg", 327, 6],
	["Waarder", 348, 9],
	["Waardhuizen", 100, 1],
	["Waardpolder", 129, 3],
	["Waarland", 340, 3],
	["Waatskamp", 259, 5],
	["Waaxens", 16, 8],
	["De Wacht", 241, 9],
	["Wachtum", 7, 0],
	["Waddinxveen", 430, 9],
	["Wadenoijen", 152, 6],
	["Wadway", 32, 3],
	["Wadwerd", 227, 7],
	["Wagenberg", 349, 1],
	["Wagenborgen", 122, 7],
	["Wagendijk", 297, 10],
	["Wageningen", 363, 6],
	["Wageningen-Hoog", 363, 6],
	["Wahlwiller", 202, 5],
	["Waldeck", 377, 9],
	["Walem (ged.)", 185, 5],
	["Walem (ged.)", 218, 5],
	["Walhofspark", 257, 2],
	["Walik", 1, 1],
	["Wals", 240, 6],
	["Walsberg", 172, 1],
	["Walsoorden", 39, 4],
	["Wamel", 101, 6],
	["Wammert", 157, 8],
	["Wanneperveen", 166, 2],
	["Wanroij", 249, 1],
	["Wanssum", 254, 5],
	["Wânswert", 253, 8],
	["Wapenveld", 222, 6],
	["Wapse", 281, 0],
	["Wapserveen", 281, 0],
	["War", 41, 8],
	["De Waranda", 386, 9],
	["Warande", 205, 1],
	["Warande", 14, 1],
	["Warder", 154, 3],
	["Warffum", 227, 7],
	["Warfhuizen", 303, 7],
	["Warfstermolen", 148, 8],
	["Warken", 309, 6],
	["Warkensche Veld", 309, 6],
	["Warm", 240, 6],
	["Warmenhuizen", 340, 3],
	["Warmond", 422, 9],
	["Warniahuizen", 85, 8],
	["Warns", 288, 8],
	["Warnsveld", 309, 6],
	["Warstiens", 85, 8],
	["Warten", 85, 8],
	["Waskemeer", 81, 8],
	["Waspik", 162, 1],
	["Wassenaar", 332, 9],
	["Wassinkbrink", 50, 6],
	["Waterakkers", 146, 3],
	["Wateren", 281, 0],
	["Watergang", 302, 3],
	["Watergraafsmeer", 120, 3],
	["Waterhuizen", 48, 7],
	["Wateringen", 378, 9],
	["Wateringse Veld", 377, 9],
	["Wateringskant", 186, 3],
	["Waterkant", 150, 1],
	["Waterland", 302, 3],
	["Waterlandkerkje", 23, 4],
	["Waterop", 202, 5],
	["Waterval", 306, 5],
	["Waverveen", 44, 10],
	["Wedde", 207, 7],
	["Wedderheide", 207, 7],
	["Wedderveer", 207, 7],
	["Weebosch", 1, 1],
	["De Weed", 242, 3],
	["De Weel", 186, 3],
	["Weende", 79, 7],
	["Weerd", 170, 5],
	["De Weerd", 142, 5],
	["Weerdinge", 121, 0],
	["De Weere", 186, 3],
	["De Weere", 28, 3],
	["Weerselo", 78, 2],
	["Weert", 306, 5],
	["Weert", 108, 5],
	["Weerwille", 106, 0],
	["De Weerwolf", 375, 10],
	["Weesp", 75, 3],
	["Weesperkarspel", 75, 3],
	["Wegdam", 111, 2],
	["Wehe-Den Hoorn", 303, 7],
	["Wehl", 64, 6],
	["De Weide", 106, 0],
	["Weidum", 157, 8],
	["Weijereind", 58, 1],
	["Weijerswold", 7, 0],
	["Weijland", 258, 9],
	["Weijpoort", 258, 9],
	["Weilenseind", 265, 1],
	["Weipoort", 369, 9],
	["Weite", 79, 7],
	["Weitemanslanden", 311, 2],
	["Weiteveen", 121, 0],
	["Weiver", 56, 3],
	["Weiwerd", 122, 7],
	["Wekerom", 210, 6],
	["Welberg", 248, 1],
	["Welfersveen", 50, 6],
	["Well", 91, 6],
	["Well", 77, 5],
	["Wellerlooi", 77, 5],
	["Wellseind", 91, 6],
	["Wellsmeer", 77, 5],
	["Welschap", 42, 1],
	["Wjelsryp", 157, 8],
	["Welsum", 127, 2],
	["Welsum", 262, 2],
	["Welten", 190, 5],
	["Wely", 342, 6],
	["Wemeldinge", 235, 4],
	["Wenum", 24, 6],
	["Weper", 81, 8],
	["Wergea", 85, 8],
	["Werkendam", 160, 1],
	["Werkensche Polder", 160, 1],
	["Werkhorst", 307, 0],
	["Werkhoven", 315, 10],
	["Wernhout", 70, 1],
	["De Werven", 302, 3],
	["Wervershoof", 351, 3],
	["Wesepe", 262, 2],
	["Wessem", 170, 5],
	["Wessinge", 131, 6],
	["Wessinghuizen", 104, 7],
	["Wessingtange", 79, 7],
	["West Maas en Waal", 101, 6],
	["Westbeemster", 199, 3],
	["Westbroek", 65, 10],
	["Westbroek", 306, 5],
	["Westdijk", 387, 9],
	["Westdijk", 241, 9],
	["Westdorp", 273, 0],
	["Westdorpe", 153, 4],
	["Westeind", 207, 7],
	["Westeind", 201, 7],
	["Westeind", 416, 9],
	["Westeind", 212, 7],
	["Westeinde", 365, 3],
	["Westeinde", 151, 3],
	["Westeinde", 369, 9],
	["Westeinde", 215, 9],
	["Westeinde", 281, 0],
	["Het Westeinde", 32, 3],
	["Westelbeers", 285, 1],
	["Westendorp", 278, 6],
	["Westendorp", 240, 6],
	["Westeneng", 210, 6],
	["Westenenk", 24, 6],
	["Westenesch", 121, 0],
	["Westenholte", 144, 2],
	["Wester Eng", 295, 3],
	["Westerbeek", 249, 1],
	["Westerblokker", 177, 3],
	["Westerbork", 107, 0],
	["Westerbroek", 48, 7],
	["Westerdijkshorn", 194, 7],
	["Westeremden", 357, 7],
	["Westerend", 157, 8],
	["Westerend Harich", 174, 8],
	["Westergeest", 148, 8],
	["Westerhaar", 311, 2],
	["Westerhaar", 166, 2],
	["Westerheul", 44, 10],
	["De Westerhoeve", 311, 2],
	["Westerhout", 233, 3],
	["Westerhoven", 1, 1],
	["Westerhuis", 62, 2],
	["Westering", 165, 5],
	["Westerklief", 208, 3],
	["Wester-Koggenland", 151, 3],
	["Westerland", 208, 3],
	["Westerlee", 201, 7],
	["Westerlee", 378, 9],
	["Westerleesche Veen", 201, 7],
	["Westermoerbeek", 186, 3],
	["Westernieland", 303, 7],
	["Westerse Bos", 121, 0],
	["Westervalge", 227, 7],
	["Westerveld", 281, 0],
	["Westervelde", 103, 0],
	["Westervoort", 391, 6],
	["Westerwijk", 169, 1],
	["Westerwijtwerd", 357, 7],
	["Westerzand", 313, 7],
	["Westfriese Zeedijk", 186, 3],
	["West-Graftdijk", 376, 3],
	["Westhem", 31, 8],
	["Westhoek", 238, 8],
	["West-Indiëbuurt", 257, 2],
	["Westkapelle", 4, 4],
	["West-Knollendam", 396, 3],
	["Westland", 378, 9],
	["Westlaren", 213, 0],
	["Westmaas", 241, 9],
	["Westpolder", 147, 1],
	["Westrik", 191, 1],
	["West-Souburg", 379, 4],
	["Weststellingwerf", 251, 8],
	["West-Terschelling", 156, 8],
	["Westvoorne", 386, 9],
	["Westwoud", 242, 3],
	["Westzaan", 56, 3],
	["Westzanerdijk", 56, 3],
	["Westzaner-Overtoom", 56, 3],
	["Westzijderveld", 56, 3],
	["Wetering", 166, 2],
	["Weteringbrug", 10, 3],
	["Wetsens", 16, 8],
	["Wetsinge", 72, 7],
	["Weurt", 231, 6],
	["Weustenrade", 185, 5],
	["Wevershoek", 268, 9],
	["Wezep", 292, 6],
	["Wezepsche Heide", 292, 6],
	["Wezup", 7, 0],
	["Wezuperbrug", 7, 0],
	["Wichmond", 50, 6],
	["Wieken", 240, 6],
	["Wieksloot", 117, 10],
	["Wiel", 157, 8],
	["Wielder", 29, 5],
	["Wieldrecht", 326, 9],
	["Wieler", 142, 5],
	["Wier", 203, 8],
	["Wierden", 366, 2],
	["Wieren", 313, 7],
	["Wierhuizen", 303, 7],
	["Wieringen", 208, 3],
	["Wieringermeer", 403, 3],
	["Wieringerwaard", 129, 3],
	["Wieringerwerf", 403, 3],
	["Wierum", 16, 8],
	["Wiesel", 24, 6],
	["Wieuwens", 157, 8],
	["Wijbosch", 277, 1],
	["Wijchen", 109, 6],
	["Wijckel", 174, 8],
	["Wijdemeren", 126, 3],
	["Wijdenes", 242, 3],
	["Wijdewormer", 396, 3],
	["Wijhe", 262, 2],
	["Wijk", 113, 5],
	["Wijk aan Zee", 233, 3],
	["Wijk bij Duurstede", 325, 10],
	["Wijk en Aalburg", 6, 1],
	["De Wijk", 106, 0],
	["Wijkertoren", 233, 3],
	["Wijler", 195, 6],
	["Wijlre", 202, 5],
	["Wijnaldum", 98, 8],
	["Wijnandsrade", 5, 5],
	["Wijnbergen", 155, 6],
	["De Wijngaard", 115, 10],
	["Wijngaarden", 252, 9],
	["Wijnjeterp", 175, 8],
	["Wijnjeterpverlaat", 175, 8],
	["Wijnjewoude", 175, 8],
	["Wijst", 225, 1],
	["Wijster", 107, 0],
	["Wytgaard", 161, 8],
	["Wijthmen", 144, 2],
	["Wijzend", 242, 3],
	["Wijzend", 32, 3],
	["Wilaard", 85, 8],
	["Wilbertoord", 260, 1],
	["Het Wild", 399, 1],
	["Wilde Plaats", 310, 7],
	["Wildenborch", 50, 6],
	["Wilderhof", 274, 7],
	["Wildert", 70, 1],
	["Wildervank", 182, 7],
	["Wildervanksterdallen", 182, 7],
	["Wildlust", 364, 9],
	["De Wilgen", 272, 8],
	["Wilhelminadorp", 33, 4],
	["Wilhelminadorp", 26, 1],
	["Wilhelminaoord", 281, 0],
	["Wilhelmsoord", 121, 0],
	["Willemsdorp", 326, 9],
	["Willemsoord", 166, 2],
	["Willemstad", 49, 1],
	["Willens", 255, 9],
	["Willeskop", 66, 10],
	["Willige Langerak", 214, 10],
	["Wilnis", 44, 10],
	["Wilp", 133, 6],
	["Wilp-Achterhoek", 133, 6],
	["Wilsum", 243, 2],
	["Wilsveen", 407, 9],
	["Wimmenhove", 106, 0],
	["Wimmenum", 3, 3],
	["Winde", 213, 0],
	["Windesheim", 144, 2],
	["Winkel", 186, 3],
	["De Winkel", 36, 10],
	["De Winkel", 112, 5],
	["Winkelshoek", 50, 6],
	["Winneweer (ged.)", 60, 7],
	["Winneweer (ged.)", 357, 7],
	["Winschoten", 201, 7],
	["Winschoterhoogebrug", 207, 7],
	["Winssen", 231, 6],
	["Winsum", 72, 7],
	["Winsum", 157, 8],
	["Wintelre", 264, 1],
	["Winterswijk", 300, 6],
	["Winthagen", 185, 5],
	["Wintraak", 275, 5],
	["Wippolder", 40, 9],
	["Wipstrik", 144, 2],
	["Wirdum", 357, 7],
	["Wirdum", 161, 8],
	["Wirdumerdraai", 357, 7],
	["Ter Wisch", 79, 7],
	["Wissel", 278, 6],
	["Wissenkerke", 323, 4],
	["Witdonk", 165, 5],
	["Witharen", 136, 2],
	["Withuis", 298, 5],
	["Witmarsum", 96, 8],
	["Witrijt", 1, 1],
	["Witte Bergen", 339, 2],
	["Wittelte", 281, 0],
	["Wittem", 202, 5],
	["Witten", 22, 0],
	["Wittepaarden", 166, 2],
	["Witteveen", 107, 0],
	["Wittevrouweveld", 113, 5],
	["Wittewierum", 60, 7],
	["Witveen", 90, 8],
	["Woensdrecht", 20, 1],
	["Woensel", 42, 1],
	["Woerd", 101, 6],
	["De Woerd", 11, 6],
	["Woerden", 187, 10],
	["Woerdense Verlaat", 21, 9],
	["Woezik", 109, 6],
	["Wogmeer", 151, 3],
	["Wognum", 32, 3],
	["De Wolden", 106, 0],
	["Woldendorp", 122, 7],
	["Wolder", 113, 5],
	["Wolfhaag", 319, 5],
	["Wolfhagen", 119, 5],
	["Wolfheze", 318, 6],
	["Wolfsbarge", 48, 7],
	["Wolfsbosch", 171, 1],
	["Wolfshoek", 345, 1],
	["Wolfshuis", 178, 5],
	["Wolfskuil", 211, 6],
	["Wolfswinkel", 19, 1],
	["Wollingboermarke", 79, 7],
	["Wollinghuizen", 79, 7],
	["Wolphaartsdijk", 33, 4],
	["Wolsum", 31, 8],
	["Wolsumerketting", 31, 8],
	["Wolterholten", 166, 2],
	["Woltersum", 60, 7],
	["Wolvega", 251, 8],
	["Wommels", 157, 8],
	["De Wonde", 2, 2],
	["Wonneburen", 96, 8],
	["Wons", 96, 8],
	["Woold", 300, 6],
	["Wooldrikshoek", 257, 2],
	["Woord", 109, 6],
	["Wordragen", 91, 6],
	["Workum", 288, 8],
	["Wormen", 24, 6],
	["Wormenschematen", 24, 6],
	["Wormer", 396, 3],
	["Wormerland", 396, 3],
	["Wormerveer", 56, 3],
	["Worp", 130, 2],
	["Worsum", 385, 6],
	["Woubrugge", 94, 9],
	["Woud", 198, 1],
	["Het Woud", 132, 6],
	["Het Woud", 3, 3],
	["Woudbloem", 274, 7],
	["De Woude en De Stierop", 80, 3],
	["Woudenberg", 360, 10],
	["Woudrichem", 100, 1],
	["Woudsend", 31, 8],
	["'t Woudt", 316, 9],
	["Wouw", 82, 1],
	["Wouwse Plantage", 82, 1],
	["Wullenhoven", 132, 6],
	["Wymbritseradiel", 31, 8],
	["Wyns", 90, 8],
	["Yde", 213, 0],
	["Yerseke", 188, 4],
	["Ypenburg (Ged.)", 377, 9],
	["Ypenburg (Ged.)", 382, 9],
	["Ysselsteyn", 254, 5],
	["Zaalheuvel", 270, 1],
	["Zaamslag", 153, 4],
	["Zaamslagveer", 153, 4],
	["Zaandam", 56, 3],
	["Zaandijk", 56, 3],
	["Te Zaanen", 383, 3],
	["Zaanstad", 56, 3],
	["Zalk", 243, 2],
	["Zalmplaat", 286, 9],
	["Zalné", 144, 2],
	["Zaltbommel", 12, 6],
	["Zand", 160, 1],
	["Zand", 171, 1],
	["Het Zand", 263, 1],
	["Het Zand", 19, 1],
	["Het Zand", 224, 1],
	["Het Zand", 124, 6],
	["'t Zand", 35, 3],
	["'t Zand", 102, 1],
	["Zandberg", 79, 7],
	["Zandberg", 243, 2],
	["Zandberg", 39, 4],
	["Zandberg", 165, 5],
	["Zandberg", 273, 0],
	["Zandberg", 49, 1],
	["Zandberg", 23, 4],
	["Zandbulten", 148, 8],
	["Zanddijk", 421, 9],
	["Zanddijk", 4, 4],
	["Zanddonk", 162, 1],
	["De Zande", 243, 2],
	["Zandeind", 37, 1],
	["Zanden", 274, 7],
	["Zandeweer", 227, 7],
	["Zandfort", 20, 1],
	["Zandhoek", 137, 1],
	["Zandhuizen", 251, 8],
	["Zandkamp", 226, 6],
	["Zandkant", 249, 1],
	["Zandkant", 225, 1],
	["Zandoerle", 83, 1],
	["Zandpol", 121, 0],
	["Zandschel", 162, 1],
	["Zandstraat", 153, 4],
	["'t Zandt", 357, 7],
	["Zandvoort", 216, 3],
	["Zandvoort", 0, 0],
	["Zandwerven", 28, 3],
	["Zanegeest", 3, 3],
	["Zeddam", 155, 6],
	["Zedde", 302, 3],
	["Zederik", 67, 9],
	["Zeedorp", 39, 4],
	["Zeegse", 213, 0],
	["Zeeland", 294, 1],
	["Zeelberg", 57, 1],
	["Zeelberg", 29, 5],
	["Zeelst", 83, 1],
	["Zeerijp", 357, 7],
	["Zeevang", 154, 3],
	["Zeewolde", 431, 11],
	["Zegenwerp", 198, 1],
	["Zegge", 51, 1],
	["Zeggelt", 257, 2],
	["Zegveld", 187, 10],
	["Zeijen", 213, 0],
	["Zeilberg", 172, 1],
	["Zeist", 149, 10],
	["Zeldam", 111, 2],
	["Zelder", 8, 5],
	["Zeldert", 116, 10],
	["Zelen-Hub", 165, 5],
	["Zelhem", 50, 6],
	["Zenderen", 276, 2],
	["Zennewijnen", 152, 6],
	["Zestienhoven", 286, 9],
	["Zetten", 18, 6],
	["Zevenaar", 125, 6],
	["Zevenbergen", 49, 1],
	["Zevenbergschen Hoek", 49, 1],
	["Zevender (ged.)", 214, 10],
	["Zevender (ged.)", 424, 9],
	["Zevenhoven", 21, 9],
	["Zevenhuis", 294, 1],
	["Zevenhuisterweg", 103, 0],
	["Zevenhuizen", 60, 7],
	["Zevenhuizen", 247, 7],
	["Zevenhuizen", 24, 6],
	["Zevenhuizen", 116, 10],
	["Zevenhuizen", 183, 3],
	["Zevenhuizen", 94, 9],
	["Zevenhuizen", 227, 7],
	["Zevenhuizen", 279, 1],
	["Zevenhuizen", 359, 9],
	["Zevenhuizen", 49, 1],
	["Zeyerveen", 22, 0],
	["Zeyerveld", 22, 0],
	["Ziek", 240, 6],
	["Zierikzee", 284, 4],
	["Zieuwent", 356, 6],
	["Zijderveld", 266, 10],
	["Zijdewind", 186, 3],
	["Zijldijk", 357, 7],
	["Zijlkwartier", 344, 9],
	["Zijp", 137, 1],
	["Zijpe", 35, 3],
	["Zijpendaal", 105, 6],
	["Zijtaart", 229, 1],
	["De Zilk", 380, 9],
	["Zilven", 24, 6],
	["Zilverkamp", 124, 6],
	["Zinkweg", 418, 9],
	["Zittard", 83, 1],
	["De Zoeke", 230, 2],
	["Zoelen", 11, 6],
	["Zoelmond", 11, 6],
	["Zoetermeer", 425, 9],
	["Zoeterwoude", 369, 9],
	["Zoggel", 225, 1],
	["Zomerdijk", 32, 3],
	["Zonderwijk", 83, 1],
	["Zondveld", 229, 1],
	["Zonnemaire", 284, 4],
	["Zonzeelsche Polder", 349, 1],
	["Zoom", 259, 5],
	["Zoomvliet", 82, 1],
	["Zorgvlied", 224, 1],
	["Zorgvlied", 281, 0],
	["Zoutelande", 4, 4],
	["Zouteveen", 316, 9],
	["Zoutkamp", 303, 7],
	["Zuidbarge", 121, 0],
	["Zuid-Beijerland", 374, 9],
	["Zuid-Berghuizen", 409, 2],
	["Zuidbroek", 212, 7],
	["Zuidbuurt", 369, 9],
	["Zuid-Carolina", 260, 1],
	["Zuiddijk", 56, 3],
	["Zuiddorpe", 153, 4],
	["Zuideinde", 243, 2],
	["Zuideinde", 56, 3],
	["Zuideinde", 25, 9],
	["Zuidend", 85, 8],
	["Zuiderkolonie", 310, 7],
	["Zuidermeer", 151, 3],
	["Zuideropgaande", 53, 0],
	["Zuiderpolder", 415, 3],
	["Zuiderrot", 292, 6],
	["Zuiderveen", 201, 7],
	["Zuiderwaard", 44, 10],
	["Zuiderwoude", 302, 3],
	["Zuiderzeeland (ged.)", 197, 6],
	["Zuiderzeeland (ged.)", 353, 6],
	["Zuidgeest", 150, 1],
	["Zuidhoek", 94, 9],
	["Zuidhorn", 15, 7],
	["Zuidhorn", 81, 8],
	["Zuidkant", 249, 1],
	["Zuidlaarderveen", 213, 0],
	["Zuidland", 34, 9],
	["Zuidlaren", 213, 0],
	["Zuid-Loo", 130, 2],
	["Zuidoostbeemster(=Tuinhoek)", 199, 3],
	["Zuidplas", 359, 9],
	["Zuidplaspolder", 359, 9],
	["Zuidpolder", 129, 3],
	["Zuid-Scharwoude", 304, 3],
	["Zuidschermer", 350, 3],
	["Zuidveen", 166, 2],
	["Zuidveld", 79, 7],
	["Zuidveld", 107, 0],
	["Zuidvelde", 103, 0],
	["Zuidwending", 182, 7],
	["Zuidwolde", 194, 7],
	["Zuidwolde", 106, 0],
	["Zuidzande", 23, 4],
	["Zuidzijde", 258, 9],
	["Zuidzijde", 68, 9],
	["Zuidzijde", 374, 9],
	["Zuilen", 411, 10],
	["Zuilichem", 12, 6],
	["Zultherveld", 103, 0],
	["Zuna", 366, 2],
	["Zunderdorp", 120, 3],
	["Zundert", 70, 1],
	["Zurich", 96, 8],
	["Zutphen", 309, 6],
	["Zuuk", 278, 6],
	["Zuurdijk", 303, 7],
	["Zuwe", 126, 3],
	["Zwaag", 177, 3],
	["Zwaagdijk (Oost)", 351, 3],
	["Zwaagdijk (West)", 32, 3],
	["Zwaagwesteinde", 84, 8],
	["Zwaanenheike", 29, 5],
	["Zwaanshoek", 10, 3],
	["Zwagerbosch", 148, 8],
	["Zwammerdam", 25, 9],
	["Zwanegat", 241, 9],
	["Zwanenburg", 10, 3],
	["Zwarte Haan", 238, 8],
	["Zwarte Kat", 118, 3],
	["Zwarte Ruiter", 248, 1],
	["Zwarte Veen", 97, 6],
	["Zwartebroek", 184, 6],
	["Zwartemeer", 121, 0],
	["Zwartendijk", 243, 2],
	["Zwartepaard", 11, 6],
	["Zwartewaal", 299, 9],
	["Zwartewaterland", 167, 2],
	["Zwartewatersklooster", 167, 2],
	["Zwartsluis", 167, 2],
	["Zwartsluisje", 374, 9],
	["Zweekhorst", 125, 6],
	["Zweeloo", 7, 0],
	["Zweins", 41, 8],
	["Zwiep", 97, 6],
	["Zwiggelte", 107, 0],
	["Zwijndrecht", 52, 9],
	["Zwijnsbergen", 280, 1],
	["Zwinderen", 7, 0],
	["Zwingelspaan", 49, 1],
	["Zwolle", 144, 2],
	["Zwolle", 63, 6],
	["Zwollerkerspel", 144, 2]
];

export const provinces = [
	"Drenthe",
	"Noord-Brabant",
	"Overijssel",
	"Noord-Holland",
	"Zeeland",
	"Limburg",
	"Gelderland",
	"Groningen",
	"Friesland",
	"Zuid-Holland",
	"Utrecht",
	"Flevoland"
];

export const municipalities = [
	"Aa en Hunze",
	"Bergeijk",
	"Almelo",
	"Bergen (NH.)",
	"Veere",
	"Nuth",
	"Aalburg",
	"Coevorden",
	"Gennep",
	"Aalsmeer",
	"Haarlemmermeer",
	"Buren",
	"Zaltbommel",
	"Waalre",
	"Oosterhout",
	"Zuidhorn",
	"Dongeradeel",
	"Aalten",
	"Overbetuwe",
	"Son en Breugel",
	"Woensdrecht",
	"Nieuwkoop",
	"Assen",
	"Sluis",
	"Apeldoorn",
	"Alphen aan den Rijn",
	"Best",
	"Laarbeek",
	"Opmeer",
	"Horst aan de Maas",
	"Echt-Susteren",
	"Wymbritseradiel",
	"Medemblik",
	"Goes",
	"Bernisse",
	"Zijpe",
	"Abcoude",
	"Goirle",
	"Landgraaf",
	"Hulst",
	"Delft",
	"Franekeradeel",
	"Eindhoven",
	"Rhenen",
	"De Ronde Venen",
	"Asten",
	"Bergambacht",
	"Someren",
	"Hoogezand-Sappemeer",
	"Moerdijk",
	"Bronckhorst",
	"Rucphen",
	"Zwijndrecht",
	"Hoogeveen",
	"Oss",
	"IJsselstein",
	"Zaanstad",
	"Valkenswaard",
	"Reusel-De Mierden",
	"Duiven",
	"Ten Boer",
	"Leusden",
	"Hardenberg",
	"Berkelland",
	"Doetinchem",
	"De Bilt",
	"Montfoort",
	"Zederik",
	"Oostflakkee",
	"Achtkarspelen",
	"Zundert",
	"Geldermalsen",
	"Winsum",
	"Bloemendaal",
	"Rijnwaarden",
	"Weesp",
	"Druten",
	"Bergen (L.)",
	"Dinkelland",
	"Vlagtwedde",
	"Castricum",
	"Ooststellingwerf",
	"Roosendaal",
	"Veldhoven",
	"Dantumadiel",
	"Boarnsterhim",
	"Skarsterlân",
	"Tubbergen",
	"Alblasserdam",
	"Albrandswaard",
	"Tytsjerksteradiel",
	"Maasdriel",
	"Utrecht",
	"Raalte",
	"Kaag en Braassem",
	"Alkmaar",
	"Wûnseradiel",
	"Lochem",
	"Harlingen",
	"Almere",
	"Woudrichem",
	"West Maas en Waal",
	"Alphen-Chaam",
	"Noordenveld",
	"Stadskanaal",
	"Arnhem",
	"De Wolden",
	"Midden-Drenthe",
	"Weert",
	"Wijchen",
	"Nuenen, Gerwen en Nederwetten",
	"Hof van Twente",
	"Roerdalen",
	"Maastricht",
	"Ameland",
	"Utrechtse Heuvelrug",
	"Amersfoort",
	"Soest",
	"Amstelveen",
	"Schinnen",
	"Amsterdam",
	"Emmen",
	"Delfzijl",
	"Andijk",
	"Lingewaard",
	"Zevenaar",
	"Wijdemeren",
	"Dalfsen",
	"Tholen",
	"Anna Paulowna",
	"Deventer",
	"Elburg",
	"Nijkerk",
	"Voorst",
	"Appingedam",
	"Venlo",
	"Ommen",
	"Boekel",
	"Giessenlanden",
	"Middelburg",
	"Hillegom",
	"Leudal",
	"Roermond",
	"Lingewaal",
	"Zwolle",
	"Uitgeest",
	"Heemskerk",
	"Etten-Leur",
	"Kollumerland en Nieuwkruisland",
	"Zeist",
	"Bergen op Zoom",
	"Koggenland",
	"Tiel",
	"Terneuzen",
	"Zeevang",
	"Montferland",
	"Terschelling",
	"Littenseradiel",
	"Simpelveld",
	"Loon op Zand",
	"Werkendam",
	"Leeuwarden",
	"Waalwijk",
	"Borsele",
	"Baarle-Nassau",
	"Peel en Maas",
	"Steenwijkerland",
	"Zwartewaterland",
	"Baarn",
	"Hilvarenbeek",
	"Maasgouw",
	"Gemert-Bakel",
	"Deurne",
	"Beesel",
	"Gaasterlân-Sleat",
	"Opsterland",
	"Lemsterland",
	"Hoorn",
	"Margraten",
	"Uithoorn",
	"Noordoostpolder",
	"Barendrecht",
	"Veendam",
	"Texel",
	"Barneveld",
	"Voerendaal",
	"Niedorp",
	"Woerden",
	"Reimerswaal",
	"Middelharnis",
	"Heerlen",
	"Breda",
	"Hengelo",
	"Uden",
	"Bedum",
	"Ubbergen",
	"Beek",
	"Ermelo",
	"Sint-Michielsgestel",
	"Beemster",
	"Cuijk",
	"Oldambt",
	"Gulpen-Wittem",
	"Menaldumadeel",
	"Vlist",
	"Helmond",
	"Geldrop-Mierlo",
	"Bellingwedde",
	"Wieringen",
	"Haaren",
	"Ede",
	"Nijmegen",
	"Menterwolde",
	"Tynaarlo",
	"Lopik",
	"Rijnwoude",
	"Zandvoort",
	"Boxtel",
	"Valkenburg aan de Geul",
	"Cranendonck",
	"Groesbeek",
	"Vught",
	"Heerde",
	"Lansingerland",
	"Tilburg",
	"Bernheze",
	"Hattem",
	"Eemsmond",
	"Boxmeer",
	"Veghel",
	"Losser",
	"Beuningen",
	"Rijssen-Holten",
	"Beverwijk",
	"Dronten",
	"Kapelle",
	"Schiedam",
	"Putten",
	"het Bildt",
	"Onderbanken",
	"Oude IJsselstreek",
	"Binnenmaas",
	"Drechterland",
	"Kampen",
	"Mook en Middelaar",
	"Bladel",
	"Blaricum",
	"Leek",
	"Steenbergen",
	"Sint Anthonis",
	"Kerkrade",
	"Weststellingwerf",
	"Graafstroom",
	"Ferwerderadiel",
	"Venray",
	"Gouda",
	"Bunschoten",
	"Enschede",
	"Bodegraven",
	"Nederweert",
	"Mill en Sint Hubert",
	"Marum",
	"Olst-Wijhe",
	"s-Hertogenbosch",
	"Eersel",
	"Gilze en Rijen",
	"Vianen",
	"Heiloo",
	"Ridderkerk",
	"Bolsward",
	"Grave",
	"Heerenveen",
	"Smallingerland",
	"Borger-Odoorn",
	"Slochteren",
	"Sittard-Geleen",
	"Borne",
	"Schijndel",
	"Epe",
	"Heeze-Leende",
	"Sint-Oedenrode",
	"Westerveld",
	"Boskoop",
	"Halderberge",
	"Schouwen-Duiveland",
	"Oirschot",
	"Rotterdam",
	"Brunssum",
	"Nijefurd",
	"Hardinxveld-Giessendam",
	"Stede Broec",
	"Groningen",
	"Oldebroek",
	"Haaksbergen",
	"Landerd",
	"Bussum",
	"Velsen",
	"Breukelen",
	"Eijsden",
	"Brielle",
	"Winterswijk",
	"Leeuwarderadeel",
	"Waterland",
	"De Marne",
	"Langedijk",
	"Heerhugowaard",
	"Meerssen",
	"Meppel",
	"Oisterwijk",
	"Zutphen",
	"Pekela",
	"Twenterand",
	"Brummen",
	"Grootegast",
	"Ouder-Amstel",
	"Bunnik",
	"Midden-Delfland",
	"Schagen",
	"Renkum",
	"Vaals",
	"Capelle aan den IJssel",
	"Stein",
	"Strijen",
	"Noord-Beveland",
	"Hilversum",
	"Wijk bij Duurstede",
	"Dordrecht",
	"Neerijnen",
	"Cromstrijen",
	"Culemborg",
	"Hellendoorn",
	"Gorinchem",
	"Wassenaar",
	"Pijnacker-Nootdorp",
	"Leerdam",
	"Diemen",
	"Oudewater",
	"Rheden",
	"Haren",
	"Staphorst",
	"Harenkarspel",
	"Dirksland",
	"Neder-Betuwe",
	"Doesburg",
	"Leiderdorp",
	"Heusden",
	"Geertruidenberg",
	"Dongen",
	"Reeuwijk",
	"Drimmelen",
	"Schermer",
	"Wervershoof",
	"Den Helder",
	"Harderwijk",
	"Maasdonk",
	"Edam-Volendam",
	"Oost Gelre",
	"Loppersum",
	"Eemnes",
	"Zuidplas",
	"Woudenberg",
	"Nunspeet",
	"Renswoude",
	"Wageningen",
	"Lisse",
	"Enkhuizen",
	"Wierden",
	"Spijkenisse",
	"Nieuwegein",
	"Zoeterwoude",
	"Liesveld",
	"Heemstede",
	"Goedereede",
	"Ouderkerk",
	"Korendijk",
	"Houten",
	"Graft-De Rijp",
	"s-Gravenhage",
	"Westland",
	"Vlissingen",
	"Noordwijkerhout",
	"Oostzaan",
	"Rijswijk",
	"Haarlem",
	"Haarlemmerliede en Spaarnwoude",
	"Heumen",
	"Westvoorne",
	"Hellevoetsluis",
	"Hendrik-Ido-Ambacht",
	"Oegstgeest",
	"Scherpenzeel",
	"Westervoort",
	"Huizen",
	"Sneek",
	"Landsmeer",
	"Rozendaal",
	"Wormerland",
	"Maassluis",
	"Katwijk",
	"Lith",
	"Nieuw-Lekkerland",
	"Noordwijk",
	"Krimpen aan den IJssel",
	"Wieringermeer",
	"Nederlek",
	"Laren",
	"Leiden",
	"Leidschendam-Voorburg",
	"Lelystad",
	"Oldenzaal",
	"Loenen",
	"Maarssen",
	"Millingen aan de Rijn",
	"Muiden",
	"Naarden",
	"Purmerend",
	"Papendrecht",
	"Vlieland",
	"Oud-Beijerland",
	"Voorschoten",
	"SkarsterlÔn",
	"Rozenburg",
	"Teylingen",
	"Schiermonnikoog",
	"Schoonhoven",
	"Zoetermeer",
	"Sliedrecht",
	"Urk",
	"Veenendaal",
	"Vlaardingen",
	"Waddinxveen",
	"Zeewolde"
];
